import React, {useState, useMemo, useEffect, useRef, useContext} from 'react'
import {useForm} from 'react-hook-form'
import {useIntl} from 'react-intl'
import Cookies from 'universal-cookie'
import {useLocation} from 'react-router-dom'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import SofaIcon from '../../../localMedia/sofa.svg'
// import SofaIcon from '../../../localMedia/sofa.svg'

// import PlaneIcon from '../../../localMedia/plane.svg'
import PlaneIcon from '../../../localMedia/plane.svg'

import UmbrellaIcon from '../../../localMedia/umbrella.svg'
// import Cal from '../../../localMedia/cal.svg'
// import ButtonCal from '../../../localMedia/buttonCal.svg'
import Accordion from 'react-bootstrap/Accordion'
import {useAccordionButton} from 'react-bootstrap/AccordionButton'
import clsx from 'clsx'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import {default as Apiservices} from '../../../common/index'
import Drawer from '../../../app/modules/apps/timesheetentry/ComponentDrawer'
import Popup from 'reactjs-popup'
import 'reactjs-popup/dist/index.css'
// import History from '../../../localMedia/history.svg'
import {useNavigate} from 'react-router-dom'
import ThingsContext from '../../modules/apps/masters/commonicons/GlobalContext'
import ValidContext from '../../modules/apps/masters/commonicons/ValidateContext'
import {PageTitle} from '../../../_metronic/layout/core'
import {usersColumns} from '../../modules/apps/user-management/users-list/table/columns/_columns'
import {Tooltip} from '../../modules/apps/timesheetentry/ComponentTooltip'
import BackDrop from '../../modules/apps/timesheetentry/ComponentBackdrop'
import SubmitButtonPop from '../../modules/apps/masters/modal/SubmitButtonPop'
import ViewDocumentPop from '../../modules/apps/masters/modal/ViewDocumentPop'
import LeaveAndHolidayPopup from '../../modules/apps/masters/modal/LeaveAndHolidayPop'
import LeavePopup from '../../modules/apps/masters/modal/LeavePop'
import {DrawerMessenger} from '../../../_metronic/partials'
import {MenuComponent} from '../../../_metronic/assets/ts/components'
import CopyButtonPop from '../../modules/apps/masters/modal/CopyButtonPop'
import {ClearButton, Typeahead} from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import VacationPop from '../../modules/apps/masters/modal/VacationPop'
import {KTSVG} from '../../../_metronic/helpers'
import WorkLocationPop from '../../modules/apps/masters/modal/WorkLocationPop'
import MonthlyCommentsPop from '../../modules/apps/masters/modal/MonthlyCommentsPop'
import MonthlyDocsOptionalPopUp from '../../modules/apps/masters/modal/MonthlyDocsOptionalPopUp'
import MonthlyFileUploadPop from '../../modules/apps/masters/modal/MonthlyFileUploadPop'
import WorkLocationSubmitAllPop from '../../modules/apps/masters/modal/WorkLocationSubmitAllPop'
import {Toolbar1} from '../../../_metronic/layout/components/toolbar/Toolbar1'
import AccordionContext from 'react-bootstrap/AccordionContext'
import parse from 'html-react-parser'
import SkillsRequiredPopup from '../login/SkillsRequiredPopup'
import {configConsumerProps} from 'antd/es/config-provider'
import ValidateContext from '../../modules/apps/masters/commonicons/ValidateContext'

type FormData = {
  monday_actual: any
  tuesday_actual: any
  wednesday_actual: any
  thursday_actual: any
  friday_actual: any
  saturday_actual: any
  sunday_actual: any
  total_actual: any
  total_leave: any
  monday_ot: any
  tuesday_ot: any
  wednesday_ot: any
  thursday_ot: any
  friday_ot: any
  saturday_ot: any
  sunday_ot: any
  monday_leave: any
  tuesday_leave: any
  wednesday_leave: any
  thursday_leave: any
  friday_leave: any
  saturday_leave: any
  sunday_leave: any
  project_name: any
  client_manager_name: any
  client_manager_email: any
  comments: any
}
type FormInputs = {
  regular_hours: any
  ot_hours: any
}

function ContextAwareToggle(person: {children: string; eventKey: any}) {
  const {activeEventKey} = useContext(AccordionContext)
  const decoratedOnClick = useAccordionButton(person.eventKey)
  const isCurrentEventKey: any = activeEventKey === person.eventKey
  return (
    <button type='button' className='btn btn-icon bg-body mt-7 p-0' onClick={decoratedOnClick}>
      {isCurrentEventKey ? (
        <i className='bi fs-3 bi-chevron-up text-primary'></i>
      ) : (
        <i className='bi fs-3 bi-chevron-down text-primary'></i>
      )}
    </button>
  )
}

function MonthlyTimesheet(props: any) {
  const {list1, month_view_dates, user_id, Project_id} = props
  const [show, setShow] = useState(false)
  const [viewshow, setViewShow] = useState(false)
  const [view_open, setViewOpen] = useState(false)
  const [view_blob, setViewBlob] = useState<any | []>([])
  const [submitshow, setSubmitShow] = useState(false)
  const [WorkLocationshow, setWorkLocationShow] = useState(false)
  const [MonthCommentshow, setMonthCommentShow] = useState(false)
  const [WorkLocationAllshow, setWorkLocationAllShow] = useState(false)
  const [submitAllshow, setSubmitAllShow] = useState(false)
  const [forLeaveAndHoldiayPopup, setForLeaveAndHoldiayPopup] = useState(false)
  const [forLeavePopup, setForLeavePopup] = useState(false)
  const [otdisable, setOtDisable] = useState(true)
  const [submit_open, setSubmitOpen] = useState(false)
  const [submitall_open, setSubmitAllOpen] = useState(false)
  const [ClientManagerNameValidation, setClientManagerNameValidation] = useState<any | []>([])
  const [WorkLocationValidation, setWorkLocationValidation] = useState<any | []>([])
  const [otfieldsdisabledValidation, setotfieldsdisabledValidation] = useState<any | []>([])
  const [MonthlyotfieldsdisabledValidation, setMonthlyotfieldsdisabledValidation] = useState<
    any | []
  >([])
  const {getValidate}: any = useContext(ValidateContext)
  const [history_per_week, setHistoryPerWeek] = useState<any | []>([])
  const [history_per_day, setHistoryPerDay] = useState<any | []>([])
  const [monthArray, setMonthArray] = useState([])
  const [history_status_per_day, setHistoryStatusPerDay] = useState<any | []>([])
  const [currentWeek, setCurrentWeek] = useState<any | []>([])
  const [history_open_per_week, setHistoryOpenPerWeek] = useState(false)
  const [CopyProjectMatching, setCopyProjectMatching] = useState(false)
  const [CopyProjectMatchingprevweek, setCopyProjectMatchingPrevWeek] = useState<any | []>([])
  const [history_open_per_day, setHistoryOpenPerDay] = useState(false)
  const [indexState, setindexState] = useState<any>('')
  const [workPopMessage, setWorkPopMessage] = useState('')
  const [CommentPopMessage, setCommentPopMessage] = useState('')
  const [workAllPopMessage, setWorkAllPopMessage] = useState('')
  const [workAllPopModifyMessage, setWorkAllPopModifyMessage] = useState('')
  const [workPopModifyMessage, setWorkPopModifyMessage] = useState('')
  const [MonthCommentMessage, setMonthCommentMessage] = useState('')
  const [docResultDataRes, setDocResultDataRes] = useState<any>([])
  const [prevAr, setPrevAr] = useState<any>([])
  const [sumofRegularHoursProject, setSumofRegularHoursProject] = useState<any[]>([])
  const [sumofOtHoursProject, setSumofOtHoursProject] = useState<any[]>([])
  const [pageTitle, setPageTitle] = useState<any>('')
  const [ermState, setErmState] = useState<any>('')
  const [isLogin, setIsLogin] = useState('')
  const [showSkillsRequiredPopup, setShowSkillsRequiredPopup] = useState(false)
  const [sumofLeaveHoursProject, setSumofLeaveHoursProject] = useState<any[]>([])
  const location = useLocation()
  const [weekDates, setWeekDates] = useState<any>([])
  const [weekStartDate, setWeekStartDate] = useState('')
  const [monthStartDate, setMonthStartDate] = useState('')
  //   const [month_view_dates, setMonthViewDates] = useState<any[]>([])
  const [total_month_view_hours, setTotalMonthViewHours] = useState('')
  const [total_month_view_status, setTotalMonthViewStatus] = useState<any | {}>({})
  const [month_view, setMonth_View] = useState(false)
  const [month_week_view, setMonthWeekView] = useState(false)
  const [weekEndDate, setWeekEndDate] = useState('')
  const [monthEndDate, setMonthEndDate] = useState('')
  const [startEnd, setStartEnd] = useState('')
  const [startMonthNumber, setStartMonthNumber] = useState('')
  const [RegularHoursEntry, setRegularHoursEntry] = useState<any>(8)
  const [OTHoursEntry, setOTHoursEntry] = useState<any>(16)
  const [LeaveHoursEntry, setLeaveHoursEntry] = useState<any>(8)
  const [disableWorkLocation, setDisableWorkLocation] = useState(false)
  const [disableDesc, setDisableDesc] = useState(false)
  const [startYearNumber, setStartYearNumber] = useState('')
  const [list, setList] = useState<any[]>([])
  const [mon, setMon] = useState<any>()
  const [tue, setTue] = useState<any>()
  const [wed, setWed] = useState<any>()
  const [thu, setThu] = useState<any>()
  const [fri, setFri] = useState<any>()
  const [sat, setSat] = useState<any>()
  const [sun, setSun] = useState<any>()
  const [Random, setRandom] = useState('')

  const [copySuccess, setCopySuccess] = useState('')
  const abc = `<div style='display: block'>
  <div><h2>
  <b>Submit Time Off Requests From ADP</b>
  </h2></div>
  <div style='display: block; 'color:#747474'>
  <p style='color:#747474'>
  Navigate to: <b style="font-weight:bolder">Myself > Time Off > My Time Off</b>
  </p>
  <li style='color:#747474'>
  Click <b style="font-weight:bolder">Request Time Off</b> and enter the <b style="font-weight:bolder">Start Date</b> and <b>End Date.</b>
  </li>
  <p style='color:#747474'>If preferred, you can instead click <b style="font-weight:bolder">Calendar View</b> first and click days to select them before clicking <b style="font-weight:bolder">Request Time Off.</b></p>
  
  <li style='color:#747474'>Select the applicable <b style="font-weight:bolder">Time Off Policy</b> and <b style="font-weight:bolder">Reason Code.</b></li>
  <li style='color:#747474'>If applicable, click <b style="font-weight:bolder">Make Recurring</b> to set up a repeating pattern.</li>
  <li style='color:#747474'>To change the number of hours per day for the request, click and type in the
  <b style="font-weight:bolder">Hours Per Day</b> field and then click out of the field.</li>
  <li style='color:#747474'>Verify the <b style="font-weight:bolder">Start Time</b> or select another time.</li>
  <li style='color:#747474'>If more days should be added with a different Hours Per Day amount, click <b style="font-weight:bolder">Add more Time Off</b> and enter those dates and all applicable data as well.</li>
  <li style='color:#747474'>Click <b style="font-weight:bolder">Review.</b></li>
  <li style='color:#747474'>In the <b style="font-weight:bolder">Approve by Date</b> field, you can click to select a date. There is also a field for <b style="font-weight:bolder">Comments..</b></li>
  <li style='color:#747474'>Click <b style="font-weight:bolder">Submit.</b></li>
  </div>
  </div>`

  const xmlString = abc

  const [employeesProjectList, setEmployeesProjectList] = useState<any[]>([])
  const [headerHours, setHeaderHours] = useState<any | {}>({})
  const [weekHourDataSubmit, setWeekHourDataSubmit] = useState<any | {}>({
    submit: 0,
    pending: 0,
    rejected: 0,
    approve: 0,
    headerTotalHours: 0,
  })
  let business: any = localStorage.getItem('role_Name')
  let numArray: any = business?.split(',')
  const [sumofAllProj, setSumofAllProj] = useState<any[]>([])
  const [sumofAllProjLeave, setSumofAllProjLeave] = useState<any[]>([])
  const [imagesArrayRes, setImagesArrayRes] = useState<any>([])
  const [showBackDrop, setShowBackDrop] = useState(false)
  const [timeTracker, setTimeTracker] = useState(moment())
  // const user_id =
  //   localStorage.getItem('role_Name') === 'timesheetadmin'
  //     ? localStorage.getItem('time_sheet_admin_screen_user_id')
  //     : localStorage.getItem('userid')
  const state2: any = location.state
  // const user_id =
  //   state2?.names == 'create'
  //     ? localStorage.getItem('time_sheet_admin_screen_user_id')
  //     : localStorage.getItem('userid')
  const [weekDayDataEntry, setweekDayDataEntry] = useState<any[]>([])
  const [monthDayDataEntry, setmonthDayDataEntry] = useState<any[]>([])
  const [StateFielddisabled, setStateFielddisabled] = useState<any | []>([])
  const [SelectedCountry, setSelectedCountry] = useState<any[]>([])
  const [WorkStatesBasedOnCountry, setWorkStatesBasedOnCountry] = useState<any | []>([])
  const [submitButtonEnableDisable, setSubmitButtonEnableDisable] = useState<any[]>([])
  const [MonthlysubmitButtonEnableDisable, setMonthlySubmitButtonEnableDisable] = useState<any[]>(
    []
  )
  const [submitButtonEnableDisableValidation, setSubmitButtonEnableDisableValidation] = useState<
    any[]
  >([])
  const [
    MonthlysubmitButtonEnableDisableValidation,
    setMonthlySubmitButtonEnableDisableValidation,
  ] = useState<any[]>([])
  const [CopyButtonEnableDisableValidation, setCopyButtonEnableDisableValidation] = useState<any[]>(
    []
  )
  const [holidayData, setHolidayData] = useState<any | {}>({})
  const [projectStartDateDisable, setProjectStartDateDisable] = useState<any[]>([])
  const [projectEndDateDisable, setProjectEndDateDisable] = useState<any[]>([])
  const [disableLeftArrow, setDisableLeftArrow] = useState<any>(false)
  const [ApplyPopupOpen, setApplyPopupOpen] = useState<any>(false)
  const [disableRightArrow, setDisableRightArrow] = useState<any>(false)
  const [disableMonthLeftArrow, setDisableMonthLeftArrow] = useState<any>(false)
  const [disableMonthRightArrow, setDisableMonthRightArrow] = useState<any>(false)
  const [disableCalendarDays, setdisableCalendarDays] = useState<any>(false)
  const [weekDayStatus, setWeekDayStatus] = useState<any[]>([])
  const [MonthlyStatus, setMonthlyStatus] = useState<any[]>([])
  const [WeeklyComments, setWeeklyComments] = useState<any[]>([])
  const [WeeklyDocuments, setWeeklyDocuments] = useState<any[]>([])
  const [FilePop, setFilePop] = useState(false)
  const [Fileindex, setFileindex] = useState<any>('')
  const [FileEvent, setFileEvent] = useState<any>('')
  const [weekDayName, setWeekDayName] = useState<any>('')
  const [statusForSubmitALL, setStatusForSubmitALL] = useState<any[]>([])
  const [statusForUnSubmitALL, setStatusForUnSubmitALL] = useState<any[]>([])
  const [monthYear, setmonthYear] = useState('')
  const [month_name, setMonthName] = useState('')
  const [Monthname, setMonthname] = useState<any>('')
  const [year_name, setYearName] = useState('')
  const [monthNumber, setMonthNumber] = useState<any>()
  const [seletedDate, setseletedDate] = useState(moment(new Date()))
  const [country, setCountry] = useState<any | []>([])
  const [countries, setCountries] = useState<any | []>([])
  const [state, setState] = useState<any | []>([])
  const [states, setStates] = useState<any | []>([])
  const [MonthlyDocsPopProceed, setMonthlyDocsPopProceed] = useState(false)
  const [useStateCountryId, setUseStateCountryId] = useState<any | []>([])
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: {errors},
  } = useForm<FormInputs>()

  const SuccessToast = (message: any) => {
    toast.success(message, {
      position: 'top-right',
      autoClose: 500,
    })
  }
  const WarnToast = (message: any) => {
    toast.warn(message, {
      position: 'top-right',
      autoClose: 500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    })
  }

  const ErrorToast = (message: any) => {
    toast.error(message, {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    })
  }

  const tokenHeader: any = useContext(ThingsContext)
  const renderThings = async () => {
    tokenHeader.getCookie()
  }

  useEffect(() => {
    setmonthDayDataEntry(month_view_dates)
    if (month_view_dates.length > 0 && month_view_dates[0].timesheet_data.length > 0) {
      let year = moment(month_view_dates[0].timesheet_data[15].date).format('YYYY')
      let month = moment(month_view_dates[0].timesheet_data[15].date).format('M')
      // moment(list1[15].date).format('M')
      setMonthname(moment(month_view_dates[0].timesheet_data[15].date).format('M'))
      getEmployeeProjectsList1(user_id, year, month, '')
    }
    // getEmployeeProjectsList(user_id1, year, month, '')

    // let otLeaveHolidayStatus: any = []
    // for (let i = 0; i < month_view_dates[0]?.length; i++) {
    //   let forSingleProject: any = {
    //     ott: false,
    //     leavet: false,
    //     holidayt: false,
    //   }

    //   otLeaveHolidayStatus.push(forSingleProject)
    // }
    // setMonthlyStatus([...otLeaveHolidayStatus])
  }, [month_view_dates])

  const tokenHeader1: any = useContext(ValidContext)
  const renderThings1 = async () => {
    tokenHeader1.getValidate()
  }

  // useEffect(() => {
  //   renderThings1()
  // }, [])
  const intl = useIntl()
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])
  useEffect(() => {
    let state: any = location.state
    let state1: any = location.state
    setPageTitle(state1)
    let state2: any = location.state
    setErmState(state2)
    setIsLogin(state2?.consultant_role)
    if (location.state) {
      var week = state.week
      // viewEmployee(week)
    } else {
      // getWeekFun()
      let start = moment(new Date())
    }
    let business: any = localStorage.getItem('role_Name')
    let numArray: any = business?.split(',')
    if (numArray?.includes('employee')) {
      const isSkillsRequired = localStorage.getItem('skillsrequired') ? false : true
      setShowSkillsRequiredPopup(isSkillsRequired)
    }
  }, [])

  const viewEmployee = async (week: any) => {
    let state: any = location.state
    state = state.week
    let week1 = moment(state.slice(0, 10), 'YYYY-MM-DD').format('MMM DD')
    let week2 = moment(state.slice(11, 21), 'YYYY-MM-DD').format('MMM DD, YYYY')
    let weeks = `${week1} - ${week2}`
    setStartEnd(weeks)
    setTimeTracker(moment(state.slice(0, 10)))
    var startOfWeek = moment(state.slice(0, 10)).clone().startOf('isoWeek')
    var endOfWeek = moment(state.slice(11, 21)).clone().endOf('isoWeek')
    var days = []
    var day: any = startOfWeek
    while (day.isSameOrBefore(endOfWeek)) {
      days.push(day.toDate())
      day = day.add(1, 'days')
    }
    let arr = []
    let arr1 = []
    for (let each of days) {
      let week1 = moment(each, 'ddd MMM DD YYYY').format('YYYY-MM-DD')
      let week2 = moment(each, 'ddd MMM DD YYYY').format('DD/MM/YYYY')
      arr.push(week1)
      arr1.push(week2)
      setWeekDates(arr)
    }
    setCurrentWeek(arr1)
    let DateArray = arr
    var startdate = moment(days[0], 'ddd MMM DD YYYY').format('YYYY-MM-DD')
    var enddate = moment(days[6], 'ddd MMM DD YYYY').format('YYYY-MM-DD')
    setWeekStartDate(startdate)
    setWeekEndDate(enddate)
    let week1update = moment(days[0], 'ddd MMM DD YYYY').format('MMM DD')
    let prestartweek = moment().subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD')
    let week2update = moment(days[6], 'ddd MMM DD YYYY').format('MMM DD, YYYY')
    let preendweek = moment().subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD')
    let weekupdate = `${week1update} - ${week2update}`
    let prevWeek = `${prestartweek}T00:00:00Z - ${preendweek}T00:00:00Z`
    setStartEnd(weekupdate)
    let weekOnMonth = moment(days[0], 'ddd MMM DD YYYY').format('M')
    let weekOnYear = moment(days[0], 'ddd MMM DD YYYY').format('YYYY')
    setStartMonthNumber(weekOnMonth)
    setStartYearNumber(weekOnYear)
    // setseletedDate(moment(startOfWeek))
    setseletedDate(moment(days[0]))
    // setMon(
    //   String(new Date(days[0]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[0]).getMonth() + 1).padStart(2, '0')
    // )
    // setTue(
    //   String(new Date(days[1]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[1]).getMonth() + 1).padStart(2, '0')
    // )
    // setWed(
    //   String(new Date(days[2]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[2]).getMonth() + 1).padStart(2, '0')
    // )
    // setThu(
    //   String(new Date(days[3]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[3]).getMonth() + 1).padStart(2, '0')
    // )
    // setFri(
    //   String(new Date(days[4]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[4]).getMonth() + 1).padStart(2, '0')
    // )
    // setSat(
    //   String(new Date(days[5]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[5]).getMonth() + 1).padStart(2, '0')
    // )
    // setSun(
    //   String(new Date(days[6]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[6]).getMonth() + 1).padStart(2, '0')
    // )
    // getEmployeeProjectsList(user_id, startdate, enddate, DateArray)
  }
  type ButtonProps = React.HTMLProps<HTMLButtonElement>
  const [startDate, setStartDate] = useState(new Date())
  const ExampleCustomInput = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({value, onClick}, ref: any) => (
      <button className='btn btn-icon btn-light btn-sm  ms-2 ' onClick={onClick} ref={ref}>
        {/* <img src={ButtonCal} className='buttonCal' /> */}
      </button>
    )
  )
  //Calander Button XXXXXXX//

  function getDays(e: any) {
    var days = []
    if (e == 0) {
      setTimeTracker(moment())
    } else {
      timeTracker.add(e, 'weeks')
    }
    var startOfWeek = timeTracker.clone().startOf('isoWeek')
    var endOfWeek = timeTracker.clone().endOf('isoWeek')
    var days = []
    var day: any = startOfWeek
    while (day.isSameOrBefore(endOfWeek)) {
      days.push(day.toDate())
      day = day.add(1, 'days')
    }
    let arr = []
    let arr1 = []
    for (let each of days) {
      let week1 = moment(each, 'ddd MMM DD YYYY').format('YYYY-MM-DD')
      let week2 = moment(each, 'ddd MMM DD YYYY').format('DD/MM/YYYY')
      arr.push(week1)
      arr1.push(week2)
      setWeekDates(arr)
    }
    setCurrentWeek(arr1)
    let DatesArray = arr
    let week1 = moment(days[0], 'ddd MMM DD YYYY').format('MMM DD')
    let prestartweek = moment().subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD')
    let week2 = moment(days[6], 'ddd MMM DD YYYY').format('MMM DD, YYYY')
    let preendweek = moment().subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD')
    var startdate = moment(days[0], 'ddd MMM DD YYYY').format('YYYY-MM-DD')
    var enddate = moment(days[6], 'ddd MMM DD YYYY').format('YYYY-MM-DD')
    setWeekStartDate(startdate)
    setWeekEndDate(enddate)
    let week = `${week1} - ${week2}`
    let prevWeek = `${prestartweek}T00:00:00Z - ${preendweek}T00:00:00Z`
    setStartEnd(week)
    let weekOnMonth = moment(days[0], 'ddd MMM DD YYYY').format('M')
    let weekOnYear = moment(days[0], 'ddd MMM DD YYYY').format('YYYY')
    setStartMonthNumber(weekOnMonth)
    setStartYearNumber(weekOnYear)
    // setseletedDate(moment(startOfWeek))
    setseletedDate(moment(days[0]))
    // setMon(
    //   String(new Date(days[0]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[0]).getMonth() + 1).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[0]).getFullYear())
    // )
    // setTue(
    //   String(new Date(days[1]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[1]).getMonth() + 1).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[1]).getFullYear())
    // )
    // setWed(
    //   String(new Date(days[2]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[2]).getMonth() + 1).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[2]).getFullYear())
    // )
    // setThu(
    //   String(new Date(days[3]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[3]).getMonth() + 1).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[3]).getFullYear())
    // )
    // setFri(
    //   String(new Date(days[4]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[4]).getMonth() + 1).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[4]).getFullYear())
    // )
    // setSat(
    //   String(new Date(days[5]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[5]).getMonth() + 1).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[5]).getFullYear())
    // )
    // setSun(
    //   String(new Date(days[6]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[6]).getMonth() + 1).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[6]).getFullYear())
    // )
    // getEmployeeProjectsList(user_id, startdate, enddate, DatesArray)
    return days.join('<br />')
  }

  const getWeekFun = async () => {
    setSumofAllProj([])
    setweekDayDataEntry([])
    ZeroAllTotalHours()
    setImagesArrayRes([])
    setEmployeesProjectList([])
    getDays(0)
  }

  const nextWeek = async () => {
    setWorkAllPopModifyMessage('')
    setWorkPopModifyMessage('')
    setSubmitButtonEnableDisableValidation([])
    setMonthlySubmitButtonEnableDisableValidation([])
    setCopyButtonEnableDisableValidation([])
    setSumofAllProj([])
    setweekDayDataEntry([])
    setDocResultDataRes([])
    setEmployeesProjectList([])
    ZeroAllTotalHours()
    setImagesArrayRes([])
    getDays(1)
    // setMonthViewDates([])
    setMonth_View(false)
    setMonthWeekView(false)
    setOtDisable(true)
  }

  const prevWeek = async () => {
    setWorkAllPopModifyMessage('')
    setWorkPopModifyMessage('')
    setSubmitButtonEnableDisableValidation([])

    setCopyButtonEnableDisableValidation([])
    setweekDayDataEntry([])
    setSumofAllProj([])
    setDocResultDataRes([])
    setEmployeesProjectList([])
    ZeroAllTotalHours()
    setImagesArrayRes([])
    getDays(-1)
    // setMonthViewDates([])
    setMonth_View(false)
    setMonthWeekView(false)
    setOtDisable(true)
  }

  const singleDateSelection = async (date: any) => {
    setEmployeesProjectList([])
    setCopyButtonEnableDisableValidation([])
    setDocResultDataRes([])
    setMonthWeekView(false)
    // setMonthViewDates([])
    var today = moment(date)
    var startOfWeek = today.clone().startOf('isoWeek').format('YYYY-MM-DD')
    var endOfWeek = today.clone().endOf('isoWeek').format('YYYY-MM-DD')
    let week1 = moment(startOfWeek, 'YYYY-MM-DD').format('MMM DD')
    let week2 = moment(endOfWeek, 'YYYY-MM-DD').format('MMM DD, YYYY')
    let weeks = `${week1} - ${week2}`
    setStartEnd(weeks)
    let weekOnMonth = moment(startOfWeek, 'YYYY-MM-DD').format('M')
    let weekOnYear = moment(startOfWeek, 'YYYY-MM-DD').format('YYYY')
    setStartMonthNumber(weekOnMonth)
    setStartYearNumber(weekOnYear)
    setseletedDate(moment(startOfWeek))
    setTimeTracker(moment(startOfWeek))
    var start = moment(startOfWeek).clone().startOf('isoWeek')
    var end = moment(endOfWeek).clone().endOf('isoWeek')
    var days = []
    var day: any = start
    while (day.isSameOrBefore(end)) {
      days.push(day.toDate())
      day = day.add(1, 'days')
    }
    let arr = []
    let arr1 = []
    for (let each of days) {
      let week1 = moment(each, 'ddd MMM DD YYYY').format('YYYY-MM-DD')
      let week2 = moment(each, 'ddd MMM DD YYYY').format('DD/MM/YYYY')
      arr.push(week1)
      arr1.push(week2)
      setWeekDates(arr)
    }
    setCurrentWeek(arr1)
    let DateArray = arr
    var startdate = moment(days[0], 'ddd MMM DD YYYY').format('YYYY-MM-DD')
    var enddate = moment(days[6], 'ddd MMM DD YYYY').format('YYYY-MM-DD')
    // setMon(
    //   String(new Date(days[0]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[0]).getMonth() + 1).padStart(2, '0')
    // )
    // setTue(
    //   String(new Date(days[1]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[1]).getMonth() + 1).padStart(2, '0')
    // )
    // setWed(
    //   String(new Date(days[2]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[2]).getMonth() + 1).padStart(2, '0')
    // )
    // setThu(
    //   String(new Date(days[3]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[3]).getMonth() + 1).padStart(2, '0')
    // )
    // setFri(
    //   String(new Date(days[4]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[4]).getMonth() + 1).padStart(2, '0')
    // )
    // setSat(
    //   String(new Date(days[5]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[5]).getMonth() + 1).padStart(2, '0')
    // )
    // setSun(
    //   String(new Date(days[6]).getDate()).padStart(2, '0') +
    //     '/' +
    //     String(new Date(days[6]).getMonth() + 1).padStart(2, '0')
    // )
    // getEmployeeProjectsList(user_id, startdate, enddate, DateArray)
    return days.join('<br />')
  }

  const ZeroAllTotalHours = () => {
    setWeekHourDataSubmit({
      ...weekHourDataSubmit,
      pending: 0,
      submit: 0,
      rejected: 0,
      approve: 0,
      headerTotalHours: 0,
    })
  }

  const ApplyVacation = async (vacation_type: any, startDate: any, endDate: any) => {
    var days = []
    var day: any = moment(startDate)
    while (day.isSameOrBefore(endDate)) {
      days.push(day.toDate())
      day = day.add(1, 'days')
    }
    let arr = []
    for (let each of days) {
      let week1 = moment(each, 'ddd MMM DD YYYY').format('YYYY-MM-DD')
      arr.push(week1)
    }
    let DatesArray = arr
    const article = {
      user_id: Number(user_id),
      absent_type: Number(vacation_type),
      dates: DatesArray,
    }
    setApplyPopupOpen(false)
    const response: any = await Apiservices.applyLeavesHolidays(article)
    if (response.statuscode == 200) {
      // getEmployeeProjectsList(user_id, weekStartDate, weekEndDate, weekDates)
    }
  }
  const ApplyLeavePopUpOpen = () => {
    setApplyPopupOpen(true)
  }
  const ApplyLeavePopUpClose = () => {
    setApplyPopupOpen(false)
  }
  const monthView = async () => {
    setShowBackDrop(true)
    setmonthYear('')
    setMonthName('')
    setYearName('')
    setMonthWeekView(!month_week_view)
    if (month_week_view) {
      //   setMonthViewDates([])
      let week1 = moment(monthStartDate, 'YYYY-MM-DD').format('MMM DD')
      let week2 = moment(monthEndDate, 'YYYY-MM-DD').format('MMM DD, YYYY')
      let weeks = `${week1} - ${week2}`
      setStartEnd(weeks)
      let weekOnMonth = moment(monthStartDate, 'YYYY-MM-DD').format('M')
      let weekOnYear = moment(monthStartDate, 'YYYY-MM-DD').format('YYYY')
      setStartMonthNumber(weekOnMonth)
      setStartYearNumber(weekOnYear)
      setseletedDate(moment(monthStartDate))
      setTimeTracker(moment(monthStartDate))
      var start = moment(monthStartDate).clone().startOf('isoWeek')
      var end = moment(monthEndDate).clone().endOf('isoWeek')
      var days = []
      var day: any = start
      while (day.isSameOrBefore(end)) {
        days.push(day.toDate())
        day = day.add(1, 'days')
      }
      let arr = []
      let arr1 = []
      for (let each of days) {
        let week1 = moment(each, 'ddd MMM DD YYYY').format('YYYY-MM-DD')
        let week2 = moment(each, 'ddd MMM DD YYYY').format('DD/MM/YYYY')
        arr.push(week1)
        arr1.push(week2)
        setWeekDates(arr)
      }
      setCurrentWeek(arr1)
      let DateArray = arr
      var startdate = moment(days[0], 'ddd MMM DD YYYY').format('YYYY-MM-DD')
      var enddate = moment(days[6], 'ddd MMM DD YYYY').format('YYYY-MM-DD')
      //   setMon(
      //     String(new Date(days[0]).getDate()).padStart(2, '0') +
      //       '/' +
      //       String(new Date(days[0]).getMonth() + 1).padStart(2, '0')
      //   )
      //   setTue(
      //     String(new Date(days[1]).getDate()).padStart(2, '0') +
      //       '/' +
      //       String(new Date(days[1]).getMonth() + 1).padStart(2, '0')
      //   )
      //   setWed(
      //     String(new Date(days[2]).getDate()).padStart(2, '0') +
      //       '/' +
      //       String(new Date(days[2]).getMonth() + 1).padStart(2, '0')
      //   )
      //   setThu(
      //     String(new Date(days[3]).getDate()).padStart(2, '0') +
      //       '/' +
      //       String(new Date(days[3]).getMonth() + 1).padStart(2, '0')
      //   )
      //   setFri(
      //     String(new Date(days[4]).getDate()).padStart(2, '0') +
      //       '/' +
      //       String(new Date(days[4]).getMonth() + 1).padStart(2, '0')
      //   )
      //   setSat(
      //     String(new Date(days[5]).getDate()).padStart(2, '0') +
      //       '/' +
      //       String(new Date(days[5]).getMonth() + 1).padStart(2, '0')
      //   )
      //   setSun(
      //     String(new Date(days[6]).getDate()).padStart(2, '0') +
      //       '/' +
      //       String(new Date(days[6]).getMonth() + 1).padStart(2, '0')
      //   )
      // getEmployeeProjectsList(user_id, startdate, enddate, DateArray)
      return days.join('<br />')
    } else {
      // let month = moment(new Date()).format('MMMM')
      let month = moment(startMonthNumber, 'M').format('MMMM')
      // let year = moment(new Date()).format('YYYY')
      let year = moment(startYearNumber, 'YYYY').format('YYYY')
      const monthNo = moment().month() + 1
      const present = `${month} ${year}`
      setmonthYear(present)
      setMonthName(month)
      setYearName(year)
      monthViewNextAndPrev(startMonthNumber, startYearNumber)
      setEmployeesProjectList([])
    }
    setShowBackDrop(false)
  }

  const monthViewNextAndPrev = async (month: any, year: any) => {
    setShowBackDrop(true)
    let SelectedMonth = year + '-' + month + '-' + 1
    let SelectedMonth2 = year + '-' + month + '-' + 30
    if (
      new Date(SelectedMonth).getTime() <
      new Date(moment().subtract(disableCalendarDays, 'days').format('YYYY-MM-DD')).getTime()
    ) {
      setDisableMonthLeftArrow(true)
    } else {
      setDisableMonthLeftArrow(false)
    }
    if (
      new Date(SelectedMonth2).getTime() >
      new Date(moment().add(disableCalendarDays, 'days').format('YYYY-MM-DD')).getTime()
    ) {
      setDisableMonthRightArrow(true)
    } else {
      setDisableMonthRightArrow(false)
    }

    const data: any = await Apiservices.consultantSingleMonthtimesheetsbyyearandmonth({
      user_id: user_id,
      year: year,
      month: month,
    })
    setEmployeesProjectList([])
    if (data.status == 200) {
      let start = data.data.data[0].week_start_date
      let end = data.data.data[0].week_end_date
      setMonthStartDate(start)
      setMonthEndDate(end)
      let month_data = [data.data.data]
      let month_length = Object(month_data[0])
      //   const keys = Object.values(month_data)
      //   setMonthViewDates(month_data)
      setTotalMonthViewHours(data.data.hours_data.final_total_hm)
      setTotalMonthViewStatus(data.data.status_wise_hours_data)

      setMonth_View(true)
    }
    setShowBackDrop(false)
  }

  const closeSKillPopup = () => {
    setShowSkillsRequiredPopup(false)
  }

  const getCopyProjectNotMatchingPopup = (projectIndex: any) => {
    setCopyProjectMatching(false)
  }

  const getDisableStatusofBenchProject = (currentProjet: any, day: any) => {
    if (employeesProjectList?.length > 0) {
      const Completedplacement = employeesProjectList?.filter(
        (proj: any) => proj?.is_placement_project === 1 && proj?.project_status === 'COMPLETED'
      )
      //filter to check whether the placement projects exists or not
      const placement = employeesProjectList?.filter(
        (proj: any) => proj?.is_placement_project === 1
      )
      let formattedDate: any = null
      if (placement?.length > 0) {
        const highestDateObject = placement?.reduce((max: any, current: any) => {
          // Convert date strings to Date objects for comparison
          const maxDate = new Date(max?.end_date)
          const currentDate = new Date(current?.end_date)
          return currentDate > maxDate ? current : max
        }, 0)
        let date = new Date(highestDateObject?.end_date)
        let day1 = ('0' + date?.getDate())?.slice(-2) // Pad single digit days with a leading zero
        let month = ('0' + (date?.getMonth() + 1))?.slice(-2) // Pad single digit months with a leading zero
        let year = date?.getFullYear()

        // Final formatted date
        formattedDate = `${day1}/${month}/${year}`
      }
      if (day && currentProjet === 2) {
        if (employeesProjectList?.length === 1) {
          return false
        } else {
          let resp
          if (currentProjet === 2 && placement?.length > 0) {
            //find whether placement project completed or not
            let completedProjects = employeesProjectList?.filter(
              (proj: any) => proj?.project_status === 'COMPLETED'
            )
            //condition to check all placement projects completed or not
            //if all are completed then bench project timesheet enble to add timesheet entry
            if (completedProjects?.length > 0 && completedProjects?.length === placement?.length) {
              if (day && formattedDate >= day) {
                resp = true
              } else {
                resp = false
              }
            } else {
              resp = true
            }
          } else {
            resp = false
          }
          return resp
        }
      } else {
        let resp
        if (
          currentProjet === 2 &&
          Completedplacement?.length == placement?.length &&
          formattedDate
        ) {
          currentWeek?.map((week: any) => {
            if (formattedDate >= week) {
              resp = true
            } else {
              resp = false
            }
          })
        } else {
          resp = false
        }
        return resp
      }
    }
  }
  const getEmployeeProjectsList1 = async (
    user_id: any,
    startdate: any,
    enddate: any,
    dates: any
  ) => {
    setWeekStartDate(startdate)
    setWeekEndDate(enddate)
    setShowBackDrop(true)
    let get_org_id = localStorage.getItem('org_id')
    const resAllowedPastEntryDays: any = await Apiservices.getOrganizationSetting({
      org_id: get_org_id,
    })
    let CalDisableDays = resAllowedPastEntryDays?.data?.data[0]?.allowed_past_entry_days
      ? resAllowedPastEntryDays?.data?.data[0]?.allowed_past_entry_days
      : 180

    var TimesheetWorkLocation = resAllowedPastEntryDays?.data?.data[0]?.timesheet_work_location
    setDisableWorkLocation(TimesheetWorkLocation)
    setdisableCalendarDays(CalDisableDays)

    const projectData = month_view_dates
    setmonthDayDataEntry(projectData)
    setEmployeesProjectList(projectData)
    // setHeaderHours(getProjectList.data?.hours_data)
    let otLeaveHolidayStatus1: any = []
    let forSingleProjectValidation: any = []
    let forSingleProjectWorkLocationValidation: any = []
    if (projectData?.length > 0) {
      for (let p = 0; p < projectData?.length; p++) {
        let otLeaveHolidayStatus12: any = []

        for (let q = 0; q < projectData[p]?.timesheet_data?.length; q++) {
          let forSingleProject: any = {
            ott: false,
            leavet: false,
            holidayt: false,
          }
          otLeaveHolidayStatus12.push(forSingleProject)
        }

        var forSingleProjectVal: any = {
          cmValidation: false,
          ccValidation: false,
          ucValidation: false,
          ceValidation: false,
        }
        forSingleProjectValidation.push(forSingleProjectVal)

        var forSingleProjectValidate: any = {
          countryValidation: false,
          stateValidation: false,
          cityValidation: false,
        }

        forSingleProjectWorkLocationValidation.push(forSingleProjectValidate)

        otLeaveHolidayStatus1.push(otLeaveHolidayStatus12)
        setMonthlyStatus([...otLeaveHolidayStatus1])
      }
      setClientManagerNameValidation([...forSingleProjectValidation])
      setWorkLocationValidation([...forSingleProjectWorkLocationValidation])
    }
    const projectDataTotalLength = month_view_dates[0]?.timesheet_data

    var Days1: any = []
    if (projectData?.length > 0 && projectData[0].timesheet_data?.length > 0) {
      for (let p = 0; p < projectDataTotalLength?.length; p++) {
        Days1.push(projectDataTotalLength[p].date)
      }
    }
    let workCountry = []
    let workState1 = []
    if (projectData?.length > 0) {
      var ProjDetailsArray1: any = []
      for (let p = 0; p < projectData?.length; p++) {
        let data = [
          {
            name: TimesheetWorkLocation
              ? projectData && projectData[p] && projectData[p].ts_work_country
                ? projectData[p].ts_work_country
                : projectData[p].work_country
                ? projectData[p].work_country
                : ''
              : null,
          },
        ]
        let data1 = [
          {
            name: TimesheetWorkLocation
              ? projectData && projectData[p] && projectData[p].ts_work_state
                ? projectData[p].ts_work_state
                : projectData[p].work_state
                ? projectData[p].work_state
                : ''
              : null,
          },
        ]
        var projDetails: any = {
          // week_start_date: startdate,
          // week_end_date: enddate,
          // week_start_date: projectData[p].week_start_date,
          // week_end_date: projectData[p].week_end_date,
          user_id: Number(user_id),
          project_id: projectData[p].id,
          year: parseInt(moment(startdate).format('YYYY')),
          month: parseInt(moment(enddate).format('MM')),
          user_notes: projectData[p].ts_user_notes,
          approver_id: null,
          approver_notes: null,
          client_manager_name: projectData[p].client_manager_name
            ? projectData[p].client_manager_name
            : projectData[p].ts_client_manager_name,
          client_manager_email: projectData[p].client_manager_email
            ? projectData[p].client_manager_email
            : projectData[p].ts_client_manager_email,
          ts_approver_notes: projectData[p]?.ts_approver_notes,
          ts_status: projectData[p].ts_status,
          work_country: data[0].name,
          work_state: data1[0].name,
          work_city: TimesheetWorkLocation
            ? projectData[p].ts_work_city
              ? projectData[p].ts_work_city
              : projectData[p].work_city
            : null,
          ot_product: projectData[p].ot_product,
          timesheet_data: [],
        }
        let arr: any = []
        for (let q = 0; q < projectData[p].timesheet_data?.length; q++) {
          if (projectData[p].timesheet_data[q].timesheet_date !== null) {
            let regularMinutes: any =
              projectData[p]?.timesheet_data[q]?.regular_minutes <= 9
                ? '0' + projectData[p]?.timesheet_data[q]?.regular_minutes
                : projectData[p]?.timesheet_data[q]?.regular_minutes
            let absentMinutes: any =
              projectData[p]?.timesheet_data[q]?.absent_minutes <= 9
                ? '0' + projectData[p]?.timesheet_data[q]?.absent_minutes
                : projectData[p]?.timesheet_data[q]?.absent_minutes
            let otMinutes: any =
              projectData[p]?.timesheet_data[q]?.ot_minutes <= 9
                ? '0' + projectData[p]?.timesheet_data[q]?.ot_minutes
                : projectData[p]?.timesheet_data[q]?.ot_minutes
            var ProjObj1 = {
              id: projectData[p]?.timesheet_data[q]?.id,
              timesheet_date: projectData[p]?.timesheet_data[q]?.date,
              regular_hours:
                projectData[p]?.timesheet_data[q]?.regular_hours + ':' + regularMinutes,
              regular_minutes: projectData[p]?.timesheet_data[q]?.regular_minutes,
              ot_hours: projectData[p]?.timesheet_data[q]?.ot_hours + ':' + otMinutes,
              ot_minutes: projectData[p]?.timesheet_data[q]?.ot_minutes,
              absent_type: projectData[p]?.timesheet_data[q]?.absent_type,
              absent_hours: projectData[p]?.timesheet_data[q]?.absent_hours + ':' + absentMinutes,
              absent_minutes: projectData[p]?.timesheet_data[q]?.absent_minutes,
              status: projectData[p]?.timesheet_data[q]?.status,
              qb_timesheet_id: projectData[p]?.timesheet_data[q]?.qb_timesheet_id,
              qb_status: projectData[p]?.timesheet_data[q]?.qb_status,
              approver_notes: projectData[p]?.timesheet_data[q]?.approver_notes,
              qb_invoice_id: projectData[p]?.timesheet_data[q]?.qb_invoice_id,
            }
            arr.push(ProjObj1)
          } else {
            let obj2: any = {
              // timesheet_date: projectData[p].timesheet_date,
              timesheet_date: projectData[p].timesheet_data[q].date,
              regular_hours: 0,
              regular_minutes: 0,
              ot_hours: 0,
              ot_minutes: 0,
              absent_type: null,
              absent_hours: 0,
              absent_minutes: 0,
              status: '',
              qb_timesheet_id: null,
              qb_status: null,
            }
            arr.push(obj2)
          }
        }
        workCountry.push(data)
        setCountries(workCountry)
        workState1.push(data1)
        setStates(workState1)
        projDetails.timesheet_data = arr

        ProjDetailsArray1.push(projDetails)
        setweekDayDataEntry([...ProjDetailsArray1])
      }
      const allWeeklyComments: any[] = []
      for (let p = 0; p < projectData?.length; p++) {
        const timesheetData = projectData[p]?.timesheet_data || []
        for (let i = 0; i < timesheetData.length; i += 7) {
          const weeklyChunk = timesheetData.slice(i, i + 7)
          // Find the first comment in this weekly chunk
          const comment =
            weeklyChunk.find((entry: any) => entry.ts_user_notes)?.ts_user_notes || null
          allWeeklyComments.push({
            // projectIndex: p,
            isboolean: comment == null ? false : true,
            weekIndex: i,
            comments: comment,
            WeekStartDate: weeklyChunk[0].date,
          })
        }
      }
      setWeeklyComments(allWeeklyComments)

      for (let p = 0; p < projectData?.length; p++) {
        for (let j = 0; j < ProjDetailsArray1[p]?.timesheet_data?.length; j++) {
          if (
            ProjDetailsArray1[p]?.timesheet_data[j] &&
            ProjDetailsArray1[p]?.timesheet_data[j]?.absent_type == 1
          ) {
            otLeaveHolidayStatus1[0][j]['holidayt'] = true
            setMonthlyStatus([...otLeaveHolidayStatus1])
          }
          if (
            ProjDetailsArray1[p]?.timesheet_data[j] &&
            ProjDetailsArray1[p]?.timesheet_data[j]?.absent_type == 2
          ) {
            otLeaveHolidayStatus1[0][j]['leavet'] = true
            setMonthlyStatus([...otLeaveHolidayStatus1])
          }
          if (
            parseInt(ProjDetailsArray1[p]?.timesheet_data[j]?.ot_hours) ||
            parseInt(ProjDetailsArray1[p]?.timesheet_data[j]?.ot_minutes)
          ) {
            otLeaveHolidayStatus1[0][j]['ott'] = true
            setMonthlyStatus([...otLeaveHolidayStatus1])
          }
        }
      }

      MonthlyotfieldsdisabledValidation.length = 0
      for (let p = 0; p < projectData?.length; p++) {
        let weekOtFieldsDisable = []
        for (let j = 0; j < ProjDetailsArray1[p]?.timesheet_data?.length; j++) {
          if (ProjDetailsArray1[p]?.timesheet_data[j]?.regular_hours) {
            let splitRegularHours1 = {...ProjDetailsArray1[p]}
            let splitted = splitRegularHours1?.timesheet_data[j]?.regular_hours.split(':')
            let totaltime = splitted[0] * 60 + parseInt(splitted[1])
            if (totaltime > 0) {
              weekOtFieldsDisable.push(false)
            } else {
              weekOtFieldsDisable.push(true)
            }
          } else {
            weekOtFieldsDisable.push(true)
          }
        }
        MonthlyotfieldsdisabledValidation.push(weekOtFieldsDisable)
        setMonthlyotfieldsdisabledValidation(MonthlyotfieldsdisabledValidation)
      }
      MonthlysubmitButtonEnableDisableValidation.length = 0
      let ForAllProjects: any = []
      ProjDetailsArray1.map((singleProject: any, index: any) => {
        let ForSingleProject: any = []
        if (singleProject?.timesheet_data.find((item: any) => item.status == 'SAVED')) {
          ForSingleProject = []
        } else {
          singleProject.timesheet_data.map((singleDay: any, index: any) => {
            if (singleDay.status == '' || singleDay.status == 'REJECTED') {
              ForSingleProject.push(false)
            }
          })
        }
        ForAllProjects.push(ForSingleProject)
      })

      ForAllProjects.map((eachProject: any, index: any) => {
        if (eachProject.length > 0) {
          MonthlysubmitButtonEnableDisableValidation.push(true)
        } else {
          MonthlysubmitButtonEnableDisableValidation.push(false)
        }
      })
      setMonthlySubmitButtonEnableDisableValidation([...MonthlysubmitButtonEnableDisableValidation])
      setMonthlySubmitButtonEnableDisable([...ForAllProjects])
      setmonthDayDataEntry(ProjDetailsArray1)
      setMonthlyStatus([...otLeaveHolidayStatus1])
      sumOfTotalHours(ProjDetailsArray1)
      setShowBackDrop(false)
    }

    if (projectData?.length > 0) {
      // let state2: any = location.state
      // let userIdData5 =
      //   state2?.names == 'create'
      //     ? localStorage.getItem('time_sheet_admin_screen_user_id')
      //     : localStorage.getItem('userid')
      const getcountries: any = await Apiservices.getallcountries()
      const allWeeklyDocuments: any = []
      for (let p = 0; p < projectData?.length; p++) {
        var work_Country_id =
          projectData && projectData[p] && projectData[p].ts_work_country
            ? projectData[p].ts_work_country
            : projectData[p].work_country && projectData[p].work_country
        if (work_Country_id) {
          StateFielddisabled[p] = false
          let stateName1 = getcountries?.data?.data.filter(
            (temp: any) => temp?.name == work_Country_id
          )
          if (stateName1) {
            SelectedCountry[p] = stateName1[0]?.id
            setSelectedCountry([...SelectedCountry])
            setUseStateCountryId(stateName1[0]?.id)
            const response: any = await Apiservices.getstatebyname({
              country_id: stateName1[0]?.id,
            })
            if (response?.data?.data) {
              WorkStatesBasedOnCountry.push(response.data.data)
              setWorkStatesBasedOnCountry([...WorkStatesBasedOnCountry])
              setState(WorkStatesBasedOnCountry)
            } else {
              WorkStatesBasedOnCountry.push([])
              setWorkStatesBasedOnCountry([...WorkStatesBasedOnCountry])
              setState(WorkStatesBasedOnCountry)
            }
          }
        } else {
          StateFielddisabled[p] = true
        }
        setStateFielddisabled([...StateFielddisabled])

        const timesheetData = projectData[p]?.timesheet_data || []
        for (let i = 0; i < timesheetData.length; i += 7) {
          const weeklyChunk = timesheetData.slice(i, i + 7)
          // const document =
          //   weeklyChunk.find((entry: any) => entry.timesheet_documents)?.timesheet_documents || null
          const document =
            weeklyChunk
              .find((entry: any) => entry.timesheet_documents)
              ?.timesheet_documents?.filter((doc: any) => doc.doc_type == 'Weekly') || null
          let status = 'SAVED'
          if (weeklyChunk.some((entry: any) => entry.status == 'REJECTED')) {
            status = 'REJECTED'
          } else if (weeklyChunk.some((entry: any) => entry.status == 'SUBMITTED')) {
            status = 'SUBMITTED'
          } else if (weeklyChunk.some((entry: any) => entry.status === 'APPROVED')) {
            status = 'APPROVED'
          }
          allWeeklyDocuments.push({
            // projectIndex: p,
            weekIndex: i,
            document: document?.length > 0 ? document : null,
            weekStart: weeklyChunk[0].date,
            weekEnd: weeklyChunk[6].date,
            status: status,
          })
        }
      }
      setWeeklyDocuments(allWeeklyDocuments)

      const getImages = await Apiservices.docNameIdMonthlyProjectList1({
        user_id: user_id,
        project_id: Project_id,
        month: enddate,
        year: startdate,
      })
      setDocResultDataRes(getImages?.data?.data)
    }
    projectStartDateDisable.length = 0
    let AllProjectStartDateDisable: any = []
    if (projectData?.length > 0) {
      projectData.map((eachProject: any, index: any) => {
        let DayFieldEntryDisable1 = eachProject.joining_date
          ? eachProject.joining_date
          : eachProject.start_date
        var DayFieldEntryDisable: any
        if (new Date(DayFieldEntryDisable1) <= new Date(eachProject.emp_joining_date)) {
          DayFieldEntryDisable = eachProject.emp_joining_date
        } else if (new Date(DayFieldEntryDisable1) >= new Date(eachProject.emp_joining_date)) {
          DayFieldEntryDisable = DayFieldEntryDisable1
        }

        let SingleProjectStartDateDisable: any = []
        Days1.map((eachDay: any, dayIndex: any) => {
          if (
            new Date(DayFieldEntryDisable).getTime() >
            new Date(moment().subtract(CalDisableDays, 'days').format('YYYY-MM-DD')).getTime()
          ) {
            if (new Date(DayFieldEntryDisable).getTime() > new Date(eachDay).getTime()) {
              SingleProjectStartDateDisable.push(true)
            } else {
              SingleProjectStartDateDisable.push(false)
            }
          } else {
            if (
              new Date(moment().subtract(CalDisableDays, 'days').format('YYYY-MM-DD')).getTime() >
              new Date(eachDay).getTime()
            ) {
              SingleProjectStartDateDisable.push(true)
            } else {
              SingleProjectStartDateDisable.push(false)
            }
          }
        })
        AllProjectStartDateDisable.push(SingleProjectStartDateDisable)
      })
      setProjectStartDateDisable(AllProjectStartDateDisable)
    }
    let CalDisableEndDays = 30
    projectEndDateDisable.length = 0
    let AllProjectsEndDateDisable: any = []
    if (projectData?.length > 0) {
      projectData.map((eachProject: any, index: any) => {
        let SingleProjectEndDateDisable: any = []
        Days1.map((eachDay: any, dayIndex: any) => {
          let endAndCancelDate = eachProject.leaving_date
            ? eachProject.leaving_date
            : eachProject.project_status &&
              (eachProject.project_status === 'COMPLETED' ||
                eachProject.project_status === 'CANCELLED')
            ? eachProject.project_status === 'COMPLETED' ||
              eachProject.project_status === 'CANCELLED'
              ? eachProject.end_date
              : eachProject.cancel_date
            : ''
          if (endAndCancelDate) {
            if (
              new Date(endAndCancelDate).getTime() <
              new Date(moment().add(CalDisableEndDays, 'days').format('YYYY-MM-DD')).getTime()
            ) {
              if (new Date(endAndCancelDate).getTime() < new Date(eachDay).getTime()) {
                SingleProjectEndDateDisable.push(true)
              } else {
                SingleProjectEndDateDisable.push(false)
              }
            } else {
              if (
                new Date(moment().add(CalDisableEndDays, 'days').format('YYYY-MM-DD')).getTime() <
                new Date(eachDay).getTime()
              ) {
                SingleProjectEndDateDisable.push(true)
              } else {
                SingleProjectEndDateDisable.push(false)
              }
            }
          } else if (
            new Date(moment().add(CalDisableEndDays, 'days').format('YYYY-MM-DD')).getTime() <
            new Date(eachDay).getTime()
          ) {
            SingleProjectEndDateDisable.push(true)
          } else {
            SingleProjectEndDateDisable.push(false)
          }
        })
        AllProjectsEndDateDisable.push(SingleProjectEndDateDisable)
      })
      setProjectEndDateDisable(AllProjectsEndDateDisable)
    }

    setShowBackDrop(false)
  }
  const getCopyProjectNotMatchingClosePopup = () => {
    setCopyProjectMatching(false)
  }

  const showOtLeaveHolidayHandler = (index: any, day: any, dayIndex: any) => {
    // MonthlyStatus[dayIndex][day] = !MonthlyStatus[dayIndex][day]
    // setMonthlyStatus([...MonthlyStatus])
    // monthDayDataEntry[dayIndex].project_wise_data[index].ot_hours = 0
    // setmonthDayDataEntry([...monthDayDataEntry])
    setWeekDayName(day)
    MonthlyStatus[index][dayIndex][day] = !MonthlyStatus[index][dayIndex][day]
    setMonthlyStatus([...MonthlyStatus])
    monthDayDataEntry[index].timesheet_data[dayIndex].ot_hours = 0
    setmonthDayDataEntry([...monthDayDataEntry])
  }

  const showOtLeaveHolidayHandlerForOtbutton = (index: any, day: any, dayIndex: any) => {
    // // weekDayStatus[index][day] = false
    // setWeekDayStatus([...weekDayStatus])
    // // weekDayDataEntry[index].timesheet_data[dayIndex].ot_hours = 0
    // monthDayDataEntry[dayIndex].project_wise_data[index].ot_hours = 0
    // // setweekDayDataEntry([...weekDayDataEntry])
    // setmonthDayDataEntry([...monthDayDataEntry])
    setWeekDayName(day)
    MonthlyStatus[index][dayIndex][day] = false
    setMonthlyStatus([...MonthlyStatus])
    monthDayDataEntry[index].timesheet_data[dayIndex].ot_hours = 0
    setmonthDayDataEntry([...monthDayDataEntry])
  }

  const onClickHolidayDisableLeave = (index: any, day: any, dayIndex: any) => {
    const Holiday = {ProjectIndex: index, dayName: day, dayIndexNo: dayIndex}
    setHolidayData(Holiday)
    if (MonthlyStatus[index][dayIndex][day] == false) {
      setForLeaveAndHoldiayPopup(true)
    } else {
      leaveHandler('ApplyLeave', Holiday)
    }
  }

  const leaveHandler = (message: any, data: any) => {
    setForLeaveAndHoldiayPopup(false)
    if (message == 'ApplyLeave') {
      let index = data.ProjectIndex
      let day = data.dayName
      let dayIndex = data.dayIndexNo
      MonthlyStatus[index][dayIndex][day] = !MonthlyStatus[index][dayIndex][day]
      setMonthlyStatus([...MonthlyStatus])
      if (MonthlyStatus[index][dayIndex][day]) {
        monthDayDataEntry[index].timesheet_data[dayIndex].absent_type = 2
        setmonthDayDataEntry([...monthDayDataEntry])
        SuccessToast('Marked As Holiday')
      } else {
        monthDayDataEntry[index].timesheet_data[dayIndex].absent_type = null
        setmonthDayDataEntry([...monthDayDataEntry])
        ErrorToast('Holiday Not Applied')
      }
      enableDisableSubmitButton(monthDayDataEntry)
    }
  }

  function copyToClipboard(e: any) {
    // setRandom(random)
    const textField = document.createElement('textarea')
    textField.innerText = e
    // weekDayStatus[index].otdisable = true
    // setWeekDayStatus([...weekDayStatus])
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    setCopySuccess('Copied!')
    setTimeout(function () {
      setCopySuccess('')
      // weekDayStatus[index].otdisable = false
    }, 1000)
  }

  const DailyEntry = (e: any, projectIndex: number, weekDayIndex: number) => {
    // let weekDayDataEntries = weekDayDataEntry
    let weekDayDataEntries = monthDayDataEntry

    if (e.target.getAttribute('name') == 'user_notes') {
      weekDayDataEntries[projectIndex][e.target.getAttribute('name')] = e.target.value
      ClientManagerNameValidation[projectIndex].ccValidation = false
    }
    if (e.target.getAttribute('name') == 'absent_hours') {
      if (e.target.value > LeaveHoursEntry) {
        ErrorToast('Leave hours not more than 8:00 hours')
      }
      weekDayDataEntries[projectIndex].timesheet_data[weekDayIndex].absent_type = 1
      // weekDayDataEntries[weekDayIndex].project_wise_data[projectIndex].absent_type = 1
    }
    if (e.target.getAttribute('name') == 'ot_hours') {
      if (e.target.value > OTHoursEntry) {
        ErrorToast('OT  hours not more than 16:00 hours')
      }
    }
    const re = /^[0-9.:\b]+$/
    const LengthOfEnteredValue = e.target.value
    let count = 0
    for (let i = 0; i < LengthOfEnteredValue.length; i++) {
      if (LengthOfEnteredValue[i] === ':') {
        count++
      }
      if (LengthOfEnteredValue[i] === '.') {
        count++
      }
    }
    if (
      (e.target.value === '' || re.test(e.target.value)) &&
      count <= 1 &&
      e.target.value.length <= 5
    ) {
      weekDayDataEntries[projectIndex].timesheet_data[weekDayIndex][e.target.getAttribute('name')] =
        e.target.value
    }
    if (e.target.getAttribute('name') === 'regular_hours') {
      if (e.target.value > RegularHoursEntry) {
        ErrorToast(`Regular hours not more than ${RegularHoursEntry}:00 hours`)
      }
      if (e.target.value !== '') {
        MonthlyotfieldsdisabledValidation[projectIndex][weekDayIndex] = false
      } else {
        MonthlyotfieldsdisabledValidation[projectIndex][weekDayIndex] = true
        let ottDay: any = [
          'monday_ott',
          'tuesday_ott',
          'wednesday_ott',
          'thursday_ott',
          'friday_ott',
          'saturday_ott',
          'sunday_ott',
        ]

        // showOtLeaveHolidayHandlerForOtbutton(projectIndex, ottDay[weekDayIndex], weekDayIndex)
        showOtLeaveHolidayHandlerForOtbutton(projectIndex, 'ott', weekDayIndex)
      }
      // setotfieldsdisabledValidation([...otfieldsdisabledValidation])
      setMonthlyotfieldsdisabledValidation([...MonthlyotfieldsdisabledValidation])
    }

    let RegularHoursTwoFour =
      weekDayDataEntries[projectIndex].timesheet_data[weekDayIndex].regular_hours
    // weekDayDataEntries[weekDayIndex].project_wise_data[projectIndex].regular_hours

    let OtHoursTwoFour = weekDayDataEntries[projectIndex].timesheet_data[weekDayIndex].ot_hours
    // let OtHoursTwoFour = weekDayDataEntries[weekDayIndex].project_wise_data[projectIndex].ot_hours

    let AbsentHoursTwoFour =
      weekDayDataEntries[projectIndex].timesheet_data[weekDayIndex].absent_hours
    // let AbsentHoursTwoFour =
    //   weekDayDataEntries[weekDayIndex].project_wise_data[projectIndex].absent_hours
    var TotalMinutesOne = 0
    var TotalMinutesTwo = 0
    if (
      e.target.getAttribute('name') === 'regular_hours' ||
      e.target.getAttribute('name') === 'ot_hours' ||
      e.target.getAttribute('name') === 'absent_hours'
    ) {
      if (e.target.getAttribute('name') === 'regular_hours') {
        if (OtHoursTwoFour) {
          if (OtHoursTwoFour.toString().indexOf(':') > -1) {
            var [OtTwoFour, OtMinutesTwoFour] = OtHoursTwoFour.split(':')
            var TotalMinutesOne = OtTwoFour * 60 + parseInt(OtMinutesTwoFour)
          } else {
            TotalMinutesOne = OtHoursTwoFour
          }
        } else {
          TotalMinutesOne = 0
        }
        if (AbsentHoursTwoFour) {
          if (AbsentHoursTwoFour.toString().indexOf(':') > -1) {
            var [AbsentTwoFour, AbsentMinuteTwoFour] = AbsentHoursTwoFour.split(':')
            var TotalMinutesTwo = AbsentTwoFour * 60 + parseInt(AbsentMinuteTwoFour)
          } else {
            TotalMinutesTwo = AbsentHoursTwoFour
          }
        } else {
          TotalMinutesTwo = 0
        }
      }
      if (e.target.getAttribute('name') === 'ot_hours') {
        if (RegularHoursTwoFour) {
          if (RegularHoursTwoFour.toString().indexOf(':') > -1) {
            var [ReguarHoursTwoFour, RegularMinutesTwoFour] = RegularHoursTwoFour.split(':')
            var TotalMinutesOne = ReguarHoursTwoFour * 60 + parseInt(RegularMinutesTwoFour)
          } else {
            TotalMinutesOne = RegularHoursTwoFour
          }
        } else {
          TotalMinutesOne = 0
        }
        if (AbsentHoursTwoFour) {
          if (AbsentHoursTwoFour.toString().indexOf(':') > -1) {
            var [AbsentTwoFour, AbsentMinuteTwoFour] = AbsentHoursTwoFour.split(':')
            var TotalMinutesTwo = AbsentTwoFour * 60 + parseInt(AbsentMinuteTwoFour)
          } else {
            TotalMinutesTwo = AbsentHoursTwoFour
          }
        } else {
          TotalMinutesTwo = 0
        }
      }
      if (e.target.getAttribute('name') === 'absent_hours') {
        if (RegularHoursTwoFour) {
          if (RegularHoursTwoFour.toString().indexOf(':') > -1) {
            var [ReguarHoursTwoFour, RegularMinutesTwoFour] = RegularHoursTwoFour.split(':')
            var TotalMinutesOne = ReguarHoursTwoFour * 60 + parseInt(RegularMinutesTwoFour)
          } else {
            TotalMinutesOne = RegularHoursTwoFour
          }
        } else {
          TotalMinutesOne = 0
        }
        if (OtHoursTwoFour) {
          if (OtHoursTwoFour.toString().indexOf(':') > -1) {
            var [OtTwoFour, OtMinutesTwoFour] = OtHoursTwoFour.split(':')
            var TotalMinutesTwo = OtTwoFour * 60 + parseInt(OtMinutesTwoFour)
          } else {
            TotalMinutesTwo = OtHoursTwoFour
          }
        } else {
          TotalMinutesTwo = 0
        }
        if (AbsentHoursTwoFour) {
          if (AbsentHoursTwoFour.toString().indexOf(':') > -1) {
            let [lessThanOneHours, lessThanOneMinutes] = AbsentHoursTwoFour.split(':')
            var lessThanHour: number = lessThanOneHours * 60
            var lessThanHourMinutes: number =
              lessThanOneMinutes >= 60 ? 59 : parseInt(lessThanOneMinutes)
            var checkLeassThanOneHour = lessThanHour + lessThanHourMinutes
          } else if (AbsentHoursTwoFour.toString().indexOf('.') > -1) {
            let [lessThanOneHours, lessThanOneMinutes] = AbsentHoursTwoFour.split('.')
            var lessThanHour: number = lessThanOneHours * 60
            var lessThanHourMinutes: number =
              (lessThanOneMinutes * 60) / Math.pow(10, lessThanOneMinutes.length)
            lessThanHourMinutes = Math.round(lessThanHourMinutes)
            var checkLeassThanOneHour = lessThanHour + lessThanHourMinutes
          } else {
            let tfregularStart = AbsentHoursTwoFour
            var lessThanHour: number = tfregularStart * 60
            var checkLeassThanOneHour = lessThanHour
          }
          if (checkLeassThanOneHour <= 59) {
            ErrorToast('Less than One hour not allowed for leave')
            weekDayDataEntries[projectIndex].timesheet_data[weekDayIndex][
              e.target.getAttribute('name')
            ] = 0
          }
        }
      }

      let calcAbsentHours = e.target.value
      if (calcAbsentHours.indexOf(':') > -1) {
        var tftotalMints = MinutesConvertionWithColon(calcAbsentHours)
      } else if (calcAbsentHours.indexOf('.') > -1) {
        var tftotalMints = MinutesConvertionWithDot(calcAbsentHours)
      } else {
        let tfregularStart = calcAbsentHours
        var tfregularStartingValue: number = tfregularStart * 60
        var tftotalMints = tfregularStartingValue
      }

      tftotalMints += TotalMinutesOne + TotalMinutesTwo
      if (tftotalMints > 1440) {
        ErrorToast('Per day per project max of 24 hours allowed')
        weekDayDataEntries[projectIndex].timesheet_data[weekDayIndex][
          e.target.getAttribute('name')
        ] = 0
        // weekDayDataEntries[weekDayIndex].project_wise_data[projectIndex][
        //   e.target.getAttribute('name')
        // ] = 0
      }
    }
    // setweekDayDataEntry([...weekDayDataEntries])
    setmonthDayDataEntry([...monthDayDataEntry])
  }
  const MinutesConvertionWithColon = (Hours: any) => {
    let [tfregularStart, tfregularDec] = Hours.split(':')
    var tfregularStartingValue: number = tfregularStart * 60
    var tfreularMins: number = tfregularDec >= 60 ? 59 : parseInt(tfregularDec)
    var tftotalMints = tfregularStartingValue + tfreularMins
    return tftotalMints
  }

  const MinutesConvertionWithDot = (Hours: any) => {
    let [tfregularStart, tfregularDec] = Hours.split('.')
    var tfregularStartingValue: number = tfregularStart * 60
    var tfreularMins: number = (tfregularDec * 60) / Math.pow(10, tfregularDec.length)
    tfreularMins = Math.round(tfreularMins)
    var tftotalMints = tfregularStartingValue + tfreularMins
    return tftotalMints
  }

  /****************adding client name client email form text fileds********************** */
  const ClientDetails = (e: any, projectIndex: number) => {
    const textFieldName = e.target.getAttribute('name')
    weekDayDataEntry[projectIndex][e.target.getAttribute('name')] = e.target.value

    if (e.target.getAttribute('name') == 'client_manager_name') {
      ClientManagerNameValidation[projectIndex].cmValidation = false
    }
    if (e.target.getAttribute('name') == 'work_city') {
      WorkLocationValidation[projectIndex].cityValidation = false
    }
    setweekDayDataEntry([...weekDayDataEntry])
  }
  /**********************XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX**************** */
  const [documentId, setDocumentId] = useState<any[]>([])
  let DocResultData: any = []

  const FileUploadPop = (Event1: any, Index1: any, pop_up: any) => {
    setFilePop(false)
    FileUpload(Event1, Index1, pop_up)
  }

  const FileUpload = async (e: any, index: number, fileVal: any) => {
    let y2 = WeeklyDocuments?.filter((test: any) => test.document)
    if (fileVal == '') {
      setFileindex(index)
      setFileEvent(Array.from(e.target.files))
      setFilePop(true)
    } else if (fileVal == 'yes' || fileVal == 'no') {
      let weeks: any = []
      if (fileVal == 'yes') {
        for (let k = 0; k < WeeklyDocuments.length; k++) {
          weeks.push({
            weekStart: WeeklyDocuments[k].weekStart,
            weekEnd: WeeklyDocuments[k].weekEnd,
          })
        }
      }
      if (fileVal == 'no') {
        let x = WeeklyDocuments.filter(
          (check: any) =>
            check.document == null || check.document == undefined || check.document?.length == 0
          //   (check: any) => check.document?.length == 0
        )
        for (let k = 0; k < x.length; k++) {
          weeks.push({
            weekStart: x[k].weekStart,
            weekEnd: x[k].weekEnd,
          })
        }
      }
      var fileData = y2?.length == 0 ? e.target.files : e
      let FileSize = []
      let FileFormats = [
        'image/png',
        'image/jpg',
        'image/jpeg',
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword',
      ]
      let EmptyFileFormats = []
      if (fileData.length > 0) {
        for (let i = 0; i < fileData.length; i++) {
          if (fileData[i].size / (1024 * 1024) <= 10) {
            FileSize.push(fileData[i].size / (1024 * 1024))
          } else {
            FileSize.length = 0
            break
          }
          if (FileFormats.includes(fileData[i].type)) {
            EmptyFileFormats.push(fileData[i].type)
          } else {
            EmptyFileFormats.length = 0
            break
          }
        }
      }

      if (fileData.length <= 5) {
        if (FileSize.length > 0) {
          if (EmptyFileFormats.length > 0) {
            var formData = new FormData()
            var filesLength = fileData && fileData.length ? fileData.length : 0
            for (var i = 0; i < filesLength; i++) {
              formData.append('file', fileData[i])
            }
            const PrevFileLength =
              imagesArrayRes && imagesArrayRes[index] ? imagesArrayRes[index].length : 0
            if (PrevFileLength > 0) {
              for (var j = 0; j < PrevFileLength; j++) {
                if (imagesArrayRes[index].length > 0) {
                  formData.append('document_name', imagesArrayRes[index][j])
                }
              }
            }
            var org_id: any = localStorage.getItem('org_id')
            // var project_id = employeesProjectList[index].id
            let state2: any = location.state
            let user_id: any =
              state2?.names == 'create'
                ? localStorage.getItem('time_sheet_admin_screen_user_id')
                : localStorage.getItem('userid')
            formData.append('week_days', JSON.stringify(weeks))
            formData.append('year', weekStartDate)
            formData.append('month', weekEndDate)
            // formData.append('createdby', '1')
            formData.append('user_id', user_id)
            // formData.append('document_name', DocResultData)
            formData.append('org_id', org_id)
            formData.append('project_id', Project_id)
            setShowBackDrop(true)
            const res = await Apiservices.insertMonthlyDocument(formData)
            setShowBackDrop(false)
            // res.data.documents_result.map((each: any) => {
            //   let docsResult = each.original_name
            //   DocResultData.push(docsResult)
            // })

            if (res.message == 'Added Successfully') {
              SuccessToast('Uploaded Successfully')
            } else {
              ErrorToast('Error Occured')
            }
            // let userIdData5 =
            //   state2?.names == 'create'
            //     ? localStorage.getItem('time_sheet_admin_screen_user_id')
            //     : localStorage.getItem('userid')

            const response1 = await Apiservices.docNameIdMonthlyProjectList1({
              user_id: user_id,
              project_id: Project_id,
              month: weekEndDate,
              year: weekStartDate,
            })
            setDocResultDataRes(response1?.data?.data)
            // if (numArray?.includes('timesheetadmin')) {
            //   if (
            //     response1 &&
            //     response1.data &&
            //     response1.data.data &&
            //     response1.data.data.length > 0 &&
            //     prevAr &&
            //     prevAr.length > 0
            //   ) {
            //     var test2 = [...prevAr, ...response1.data.data]
            //   } else if (response1?.data?.data?.length == null && prevAr?.length == null) {
            //     var test2 = [...prevAr]
            //   } else if (prevAr && prevAr?.length > 0 && response1?.data?.data?.length == null) {
            //     var test2 = [...prevAr]
            //   } else {
            //     var test2 = [...response1?.data?.data]
            //   }
            //   setDocResultDataRes(test2)
            // } else {
            //   // setDocResultDataRes(response1?.data?.data)
            // }

            let DocumentsData = imagesArrayRes

            // for (let each in imagesArrayRes) {
            //   if (project_id === imagesArrayRes[each].project_id) {
            //     DocumentsData[each].documents =
            //       response1.data.data !== null ? response1.data.data : []
            //   }
            // }
            setImagesArrayRes(DocumentsData)
            setDocumentId([...documentId])
          } else {
            ErrorToast('Document type not allowed')
          }
        } else {
          ErrorToast('Maximum upload file size 10 MB')
        }
      } else {
        ErrorToast('Please upload less than 5 Files')
      }
    }
  }

  const FormSave = async (index: any) => {
    setShowBackDrop(true)
    // let ProjectNo = index
    // const ProjectList = weekDayDataEntry[index]
    const updatedData = splitHoursAndMinutes(monthDayDataEntry[index])
    const data = updatedData
    const data1 = JSON.parse(JSON.stringify(updatedData))

    let updateTimesheetDataArray1 = []
    for (let i = 0; i < data.timesheet_data.length; i++) {
      if (
        Number(data.timesheet_data[i].regular_hours) > 0 ||
        Number(data.timesheet_data[i].regular_minutes) > 0 ||
        Number(data.timesheet_data[i].ot_hours) > 0 ||
        Number(data.timesheet_data[i].ot_minutes) > 0 ||
        Number(data.timesheet_data[i].absent_hours) > 0 ||
        Number(data.timesheet_data[i].absent_minutes) > 0 ||
        Number(data.timesheet_data[i].absent_type) == 2 ||
        Number(data.timesheet_data[i].id)
      ) {
        updateTimesheetDataArray1.push(data.timesheet_data[i])
      }
    }
    let updateTimesheetDataArray = updateTimesheetDataArray1.filter(
      (temp: any) => moment(temp.timesheet_date).format('M') == Monthname
    )
    // data.timesheet_data = updateTimesheetDataArray
    let arr1: any = []
    if (updateTimesheetDataArray.length > 0) {
      const weeklyData: any = groupDatesByWeek(updateTimesheetDataArray)
      let week_Array1 = Object.keys(weeklyData)
      let week_Array2: any = Object.values(weeklyData)
      let end_date = []
      if (week_Array1?.length > 0) {
        for (let i = 0; i < week_Array1?.length; i++) {
          const date = new Date(week_Array1[i])
          date.setDate(date.getDate() + 6)
          end_date.push(date.toISOString().split('T')[0])
        }
      }
      let week_Array =
        end_date?.length > 0 &&
        week_Array2?.length > 0 &&
        week_Array2.map((temp: any) => {
          const filteredData = temp.timesheet_data.filter((temp_check: any) => {
            return moment(temp_check.timesheet_date).format('M') == Monthname
          })
          return {
            ...temp,
            timesheet_data: filteredData,
          }
        })

      const filteredComments = WeeklyComments.filter((comment: any) =>
        week_Array1.includes(comment.WeekStartDate)
      )
      if (end_date?.length > 0 && week_Array?.length > 0) {
        for (let i = 0; i < week_Array?.length; i++) {
          let data1: any = {} // Create a new object every time
          data.week_start_date = week_Array1[i]
          data.week_end_date = end_date[i]
          data1 = {...data}
          data1.user_notes =
            monthDayDataEntry[0].user_notes == null ||
            monthDayDataEntry[0].user_notes == '' ||
            monthDayDataEntry[0].user_notes == undefined
              ? filteredComments[i].comments
              : monthDayDataEntry[0].user_notes
          data1.timesheet_data = week_Array[i].timesheet_data
          arr1.push(data1)
        }
        // var saveAllProjects: any = await Apiservices.timeSheetSaveMonthlyInsert(
        //   arr1?.length > 0 ? arr1 : data
        // )
        // if (updatedData) {
        //   handlerForResetDataAndShowToasters(saveAllProjects.message, saveAllProjects.isError)
        // }
      } else {
        setShowBackDrop(false)
      }
    } else {
      data1.week_start_date = data1.timesheet_data[0].timesheet_date
      data1.week_end_date = data1.timesheet_data[6].timesheet_date
      data1.timesheet_data = []
    }
    var saveAllProjects: any = await Apiservices.timeSheetSaveMonthlyInsert(
      arr1?.length > 0 ? arr1 : [data1]
    )
    if (updatedData) {
      handlerForResetDataAndShowToasters(saveAllProjects.message, saveAllProjects.isError)
    }
    setShowBackDrop(false)
  }

  const handlerForResetDataAndShowToasters = async (toasterMessage: any, isError: any) => {
    if (isError) {
      setEmployeesProjectList([])
      // getDays(`${weekStartDate}-${weekEndDate}`)
      await props.handleMonthView(Project_id, weekStartDate, weekEndDate)
      await getEmployeeProjectsList1(user_id, weekStartDate, weekEndDate, '')
      WarnToast(toasterMessage)
    } else {
      setEmployeesProjectList([])
      // getDays(`${weekStartDate}-${weekEndDate}`)
      await props.handleMonthView(Project_id, weekStartDate, weekEndDate)
      await getEmployeeProjectsList1(user_id, weekStartDate, weekEndDate, '')
      SuccessToast(toasterMessage)
    }
    setShowBackDrop(false)
  }

  // const getMonths = () => {

  // }

  const handleSubmitted = (e: any, index: any) => {
    setSubmitOpen(true)
    setSubmitShow(false)

    FormSingleProjectSubmit(index, 'handleSubmit', list, '')
  }

  const modalPop = () => {
    setSubmitOpen(false)
    setSubmitShow(false)
    setShowBackDrop(false)
  }
  const WorkLocationContinuePop = (e: any, alert_any: any, index: any) => {
    setWorkPopMessage(alert_any)
    setWorkLocationShow(false)
    setWorkPopModifyMessage('')
    setSubmitOpen(true)
    setSubmitShow(true)
  }
  const CommentOverRidePop = (e: any, alert_any: any, index: any) => {
    setCommentPopMessage(alert_any)
    setMonthCommentShow(false) //--
    // setMonthCommentMessage('')

    let today = moment(new Date()).format('YYYY-MM-DD')
    let pastDay: any = moment(employeesProjectList[indexState].work_location_updatedate).format(
      'YYYY-MM-DD'
    )
    let startt = moment(today)
    let enddd = moment(pastDay)
    let duration1 = moment.duration(startt.diff(enddd))
    let dayss = duration1.asDays()

    let week_status_checking = WeeklyDocuments.filter((stat: any) => stat.status == 'APPROVED')
    let filteredDocsBasedonProjId =
      docResultDataRes &&
      docResultDataRes.filter(
        (each: any) => each.project_id === monthDayDataEntry[indexState]?.project_id
      )

    if (
      employeesProjectList[indexState].is_placement_project == 1 &&
      !filteredDocsBasedonProjId?.length &&
      WeeklyDocuments?.length == week_status_checking?.length
    ) {
      setMonthlyDocsPopProceed(true)
    } else {
      if (workPopModifyMessage != 'modify') {
        if (dayss >= 90) {
          setWorkLocationShow(true)
        } else {
          setWorkPopMessage('')
          setWorkPopModifyMessage('')
          setSubmitOpen(true)
          setSubmitShow(true)
        }
      }
    }
  }
  const DocumentProceedPop = () => {
    setMonthlyDocsPopProceed(false)
    let today = moment(new Date()).format('YYYY-MM-DD')
    let pastDay: any = moment(employeesProjectList[indexState].work_location_updatedate).format(
      'YYYY-MM-DD'
    )
    let startt = moment(today)
    let enddd = moment(pastDay)
    let duration1 = moment.duration(startt.diff(enddd))
    let dayss = duration1.asDays()

    if (workPopModifyMessage != 'modify') {
      if (dayss >= 90) {
        setWorkLocationShow(true)
      } else {
        setWorkPopMessage('')
        setWorkPopModifyMessage('')
        setSubmitOpen(true)
        setSubmitShow(true)
      }
    }
  }
  const DocumentStopPop = () => {
    setMonthlyDocsPopProceed(false)
  }
  const WorkLocationOkPop = (e: any, alert: any) => {
    setWorkPopMessage('')
    setWorkPopModifyMessage(alert)
    let today = moment(new Date()).format('YYYY-MM-DD')
    let pastDay: any = moment(employeesProjectList[indexState].work_location_updatedate).format(
      'YYYY-MM-DD'
    )
    let startt = moment(today)
    let enddd = moment(pastDay)
    let duration1 = moment.duration(startt.diff(enddd))
    let dayss = duration1.asDays()
    var workCountrySetting: any = []
    var workStateSetting: any = []
    if (dayss >= 90) {
      weekDayDataEntry[indexState].work_country = ''
      weekDayDataEntry[indexState].work_state = ''
      weekDayDataEntry[indexState].work_city = ''
      // employeesProjectList[indexState].ts_work_city = ''
      // employeesProjectList[indexState].work_city = ''
      // setEmployeesProjectList([...employeesProjectList])
      setweekDayDataEntry([...weekDayDataEntry])
      let data = [
        {
          name: weekDayDataEntry[indexState].work_country
            ? weekDayDataEntry[indexState].work_country
            : null,
        },
      ]
      let data1 = [
        {
          name: weekDayDataEntry[indexState].work_state
            ? weekDayDataEntry[indexState].work_state
            : null,
        },
      ]
      workCountrySetting[indexState] = data
      workStateSetting[indexState] = data1
    }
    setWorkLocationShow(false)
    setweekDayDataEntry([...weekDayDataEntry])
    setCountries(workCountrySetting)
    setStates(workStateSetting)
  }
  const CommentRemainingOkPop = (e: any, alert: any) => {
    setCommentPopMessage(alert)
    // setMonthCommentMessage(alert)
    setMonthCommentShow(false)
    // setweekDayDataEntry([...weekDayDataEntry])

    let today = moment(new Date()).format('YYYY-MM-DD')
    let pastDay: any = moment(employeesProjectList[indexState].work_location_updatedate).format(
      'YYYY-MM-DD'
    )
    let startt = moment(today)
    let enddd = moment(pastDay)
    let duration1 = moment.duration(startt.diff(enddd))
    let dayss = duration1.asDays()

    let week_status_checking = WeeklyDocuments.filter((stat: any) => stat.status == 'APPROVED')
    let filteredDocsBasedonProjId =
      docResultDataRes &&
      docResultDataRes.filter(
        (each: any) => each.project_id === monthDayDataEntry[indexState]?.project_id
      )
    if (
      employeesProjectList[indexState].is_placement_project == 1 &&
      !filteredDocsBasedonProjId?.length &&
      WeeklyDocuments?.length == week_status_checking?.length
    ) {
      setMonthlyDocsPopProceed(true)
    } else {
      if (workPopModifyMessage != 'modify') {
        if (dayss >= 90) {
          setWorkLocationShow(true)
        } else {
          setWorkPopMessage('')
          setWorkPopModifyMessage('')
          setSubmitOpen(true)
          setSubmitShow(true)
        }
      }
    }
  }
  const FormSingleProjectSubmit = async (
    index: any,
    fromVal: any,
    list1: any,
    work_locaion_pop: any
  ) => {
    setindexState(index)
    setList(list1)
    let list = month_view_dates[0]
    if (fromVal !== 'handleSubmit') {
      let WorkLocationAllPopLength = 0
      let today = moment(new Date()).format('YYYY-MM-DD')
      let pastDay: any = moment(list?.work_location_updatedate).format('YYYY-MM-DD')
      let startt = moment(today)
      let enddd = moment(pastDay)
      let duration1 = moment.duration(startt.diff(enddd))
      let dayss = duration1.asDays()
      let filteredDocsBasedonProjId =
        docResultDataRes &&
        docResultDataRes.filter(
          (each: any) => each.project_id === monthDayDataEntry[index]?.project_id
        )
      let week_status_checking = WeeklyDocuments.filter((stat: any) => stat.status == 'APPROVED')
      const updatedData = splitHoursAndMinutes(monthDayDataEntry[index])

      const data = updatedData
      let regulararray = []

      for (let j = 0; j < data.timesheet_data.length; j++) {
        if (data.timesheet_data[j].status != 'APPROVED') {
          let data123: any = data?.timesheet_data[j]
          regulararray.push(data123)
        }
      }
      TotalSumofHoursEntry(regulararray)

      let updateTimesheetDataArray = []
      for (let i = 0; i < data.timesheet_data.length; i++) {
        if (
          Number(data.timesheet_data[i].regular_hours) > 0 ||
          Number(data.timesheet_data[i].regular_minutes) > 0 ||
          Number(data.timesheet_data[i].ot_hours) > 0 ||
          Number(data.timesheet_data[i].ot_minutes) > 0 ||
          Number(data.timesheet_data[i].absent_hours) > 0 ||
          Number(data.timesheet_data[i].absent_minutes) > 0 ||
          Number(data.timesheet_data[i].absent_type) == 2 ||
          Number(data.timesheet_data[i].id)
        ) {
          updateTimesheetDataArray.push(data.timesheet_data[i])
        }
      }
      if (monthDayDataEntry[index].user_notes?.length > 0) {
        ClientManagerNameValidation[index].ccValidation = false
      } else {
        ClientManagerNameValidation[index].ccValidation = true
      }
      if (monthDayDataEntry[index].client_manager_name?.length > 0) {
        ClientManagerNameValidation[index].cmValidation = false
      } else {
        ClientManagerNameValidation[index].cmValidation = true
      }
      if (!disableWorkLocation || monthDayDataEntry[index].work_country?.length > 0) {
        WorkLocationValidation[index].countryValidation = false
      } else {
        WorkLocationValidation[index].countryValidation = true
      }
      if (!disableWorkLocation || monthDayDataEntry[index].work_state?.length > 0) {
        WorkLocationValidation[index].stateValidation = false
      } else {
        WorkLocationValidation[index].stateValidation = true
      }
      if (!disableWorkLocation || monthDayDataEntry[index].work_city?.length > 0) {
        WorkLocationValidation[index].cityValidation = false
      } else {
        WorkLocationValidation[index].cityValidation = true
      }
      if (workPopModifyMessage != 'modify') {
        if (dayss >= 90) {
          WorkLocationAllPopLength += 1
        } else {
          setWorkPopMessage('')
          setWorkPopModifyMessage('')
        }
      }
      // setCommentPopMessage
      // CommentPopMessage
      // MonthCommentMessage
      // setMonthCommentMessage
      let LeaveHoursSplit = sumofAllProjLeave[index]
      let LeaveHoursSplit1 = LeaveHoursSplit && LeaveHoursSplit.split(':')
      let arr2 = LeaveHoursSplit1 && LeaveHoursSplit1[0]
      let arr3 = LeaveHoursSplit1 && LeaveHoursSplit1[1]
      let timesheet1 = sumofAllProj[index] == '0:00' && (arr2 >= 0 || arr3 >= 0)
      if (
        filteredDocsBasedonProjId?.length > 0 ||
        timesheet1 ||
        WeeklyDocuments?.length == week_status_checking?.length ||
        list.is_placement_project == 2 ||
        list.is_placement_project == 3
      ) {
        ClientManagerNameValidation[index].ucValidation = false
      } else {
        ClientManagerNameValidation[index].ucValidation = true
      }
      if (
        updateTimesheetDataArray.length > 0 &&
        monthDayDataEntry[index].user_notes?.length > 0 &&
        monthDayDataEntry[index].client_manager_name?.length > 0 &&
        (!disableWorkLocation || monthDayDataEntry[index].work_country?.length > 0) &&
        (!disableWorkLocation || monthDayDataEntry[index].work_state?.length > 0) &&
        (!disableWorkLocation || monthDayDataEntry[index].work_city?.length > 0) &&
        (filteredDocsBasedonProjId?.length > 0 ||
          timesheet1 ||
          WeeklyDocuments?.length == week_status_checking?.length ||
          list.is_placement_project == 2 ||
          list.is_placement_project == 3)
      ) {
        ClientManagerNameValidation[index].cmValidation = false
        ClientManagerNameValidation[index].ccValidation = false
        ClientManagerNameValidation[index].ucValidation = false
        WorkLocationValidation[index].countryValidation = false
        WorkLocationValidation[index].stateValidation = false
        WorkLocationValidation[index].cityValidation = false

        let teste = WeeklyComments.some((temp: any) => temp.isboolean == true)
        if (teste) {
          setMonthCommentShow(true)
        } else if (
          list.is_placement_project == 1 &&
          !filteredDocsBasedonProjId?.length &&
          WeeklyDocuments?.length == week_status_checking?.length
        ) {
          setMonthlyDocsPopProceed(true)
        } else if (
          (monthDayDataEntry[0].user_notes == null ||
            monthDayDataEntry[0].user_notes == '' ||
            monthDayDataEntry[0].user_notes == undefined) &&
          WorkLocationAllPopLength > 0
        ) {
          setWorkLocationShow(true)
        } else {
          setSubmitOpen(true)
          setSubmitShow(true)
        }
      } else {
        setShowBackDrop(false)
      }
    } else if (fromVal === 'handleSubmit') {
      let filteredDocsBasedonProjId =
        docResultDataRes &&
        docResultDataRes.filter(
          (each: any) => each.project_id === monthDayDataEntry[index]?.project_id
        )
      let week_status_checking = WeeklyDocuments.filter((stat: any) => stat.status == 'APPROVED')
      let LeaveHoursSplit = sumofAllProjLeave[index]
      let LeaveHoursSplit1 = LeaveHoursSplit && LeaveHoursSplit.split(':')
      let arr2 = LeaveHoursSplit1 && LeaveHoursSplit1[0]
      let arr3 = LeaveHoursSplit1 && LeaveHoursSplit1[1]

      let timesheet1 = sumofAllProj[index] == '0:00' && (arr2 >= 0 || arr3 >= 0)
      let today = moment(new Date()).format('YYYY-MM-DD')
      let pastDay: any = moment(list.work_location_updatedate).format('YYYY-MM-DD')
      let startt = moment(today)
      let enddd = moment(pastDay)
      let duration1 = moment.duration(startt.diff(enddd))
      let dayss = duration1.asDays()
      setShowBackDrop(true)
      let wcountry =
        monthDayDataEntry[index].work_country == employeesProjectList[index].ts_work_country ||
        monthDayDataEntry[index].work_country == employeesProjectList[index].work_country

      let ws =
        monthDayDataEntry[index].work_state == employeesProjectList[index].ts_work_state ||
        monthDayDataEntry[index].work_state == employeesProjectList[index].work_state

      let wc =
        monthDayDataEntry[index].work_city == employeesProjectList[index].ts_work_city ||
        monthDayDataEntry[index].work_city == employeesProjectList[index].work_city

      if (workPopModifyMessage == 'modify') {
        //after click on modify
        if (dayss >= 90) {
          if (!wcountry || !ws || !wc) {
            //changed
            monthDayDataEntry[index].user_same_work_location = false
            setWorkPopMessage('')
          } else {
            monthDayDataEntry[index].user_same_work_location = true
          }
        }
      } else {
        monthDayDataEntry[index].user_same_work_location = false
      }

      if (CommentPopMessage) {
      }

      if (
        monthDayDataEntry[index]?.user_notes?.length > 0 &&
        monthDayDataEntry[index]?.client_manager_name?.length > 0 &&
        (filteredDocsBasedonProjId?.length > 0 ||
          WeeklyDocuments?.length == week_status_checking?.length ||
          timesheet1 ||
          list.is_placement_project == 2 ||
          list.is_placement_project == 3)
      ) {
        const updatedData = splitHoursAndMinutes(monthDayDataEntry[index])
        if (workPopMessage == 'continue') {
          monthDayDataEntry[index]['user_same_work_location'] = true
        } else if (workPopModifyMessage == 'modify') {
          monthDayDataEntry[index]['user_same_work_location'] =
            monthDayDataEntry[index].user_same_work_location
        } else {
          monthDayDataEntry[index]['user_same_work_location'] = false
        }
        // MonthCommentMessage

        if (CommentPopMessage) {
        }
        const data = updatedData

        let updateTimesheetDataArray1 = []
        for (let i = 0; i < data.timesheet_data.length; i++) {
          if (
            Number(data.timesheet_data[i].regular_hours) > 0 ||
            Number(data.timesheet_data[i].regular_minutes) > 0 ||
            Number(data.timesheet_data[i].ot_hours) > 0 ||
            Number(data.timesheet_data[i].ot_minutes) > 0 ||
            Number(data.timesheet_data[i].absent_hours) > 0 ||
            Number(data.timesheet_data[i].absent_minutes) > 0 ||
            Number(data.timesheet_data[i].absent_type) == 2 ||
            Number(data.timesheet_data[i].id)
          ) {
            updateTimesheetDataArray1.push(data.timesheet_data[i])
          }
        }
        let updateTimesheetDataArray = updateTimesheetDataArray1.filter(
          (temp: any) => moment(temp.timesheet_date).format('M') == Monthname
        )
        if (updateTimesheetDataArray.length > 0) {
          const weeklyData: any = groupDatesByWeek(updateTimesheetDataArray)
          let week_Array1 = Object.keys(weeklyData)
          let week_Array2: any = Object.values(weeklyData)
          let end_date = []
          if (week_Array1?.length > 0) {
            for (let i = 0; i < week_Array1?.length; i++) {
              const date = new Date(week_Array1[i])
              date.setDate(date.getDate() + 6)
              end_date.push(date.toISOString().split('T')[0])
            }
          }

          let week_Array =
            end_date?.length > 0 &&
            week_Array2?.length > 0 &&
            week_Array2.map((temp: any) => {
              const filteredData = temp.timesheet_data.filter((temp_check: any) => {
                return moment(temp_check.timesheet_date).format('M') == Monthname
              })
              return {
                ...temp,
                timesheet_data: filteredData,
              }
            })

          if (end_date?.length > 0 && week_Array?.length > 0) {
            let arr1 = []
            for (let i = 0; i < week_Array?.length; i++) {
              data.week_start_date = week_Array1[i]
              data.week_end_date = end_date[i]

              let data1: any = {...data} // Create a new object every time

              data1.user_notes =
                CommentPopMessage == 'yes'
                  ? monthDayDataEntry[0].user_notes
                  : CommentPopMessage == 'no'
                  ? WeeklyComments[i].comments
                    ? WeeklyComments[i].comments
                    : monthDayDataEntry[0].user_notes
                  : monthDayDataEntry[0].user_notes
              data1.timesheet_data = week_Array[i].timesheet_data
              arr1.push(data1)
            }
            // // data.timesheet_data = arr1
            const timeSheetSingleProjectSubmit: any = await Apiservices.timeSheetMonthProjectSubmit(
              arr1
            )
            handlerForResetDataAndShowToasters(
              timeSheetSingleProjectSubmit.message,
              timeSheetSingleProjectSubmit.isError
            )
          } else {
            setShowBackDrop(false)
          }
          // let sat_check = updateTimesheetDataArray.find(
          //   (f1: any) => f1.timesheet_date == weekDates[5]
          // )

          // let sun_check = updateTimesheetDataArray.find(
          //   (f1: any) => f1.timesheet_date == weekDates[6]
          // )

          // data.timesheet_data = updateTimesheetDataArray

          // const timeSheetSingleProjectSubmit: any = await Apiservices.timeSheetSingleProjectSubmit(
          //   data
          // )

          // if (numArray?.includes('timesheetadmin')) {
          //   if (docResultDataRes) {
          //     let docarr = []
          //     for (let each of docResultDataRes) {
          //       if (each.previous_doc) {
          //         docarr.push(each.id)
          //       }
          //     }

          //     const updateDocsData = {
          //       user_id: data.user_id,
          //       project_id: data.project_id,
          //       week_start_date: weekStartDate,
          //       week_end_date: weekEndDate,
          //       documents: docarr,
          //     }
          //     if (docarr && docarr.length > 0) {
          //       var copyDocs: any = await Apiservices.copyTimesheetDocs(updateDocsData)
          //       if (copyDocs.message == 'Added Successfully') {
          //         setPrevAr([])
          //       }
          //     }
          //   }
          // }
          // handlerForResetDataAndShowToasters(
          //   timeSheetSingleProjectSubmit.message,
          //   timeSheetSingleProjectSubmit.isError
          // )
        } else {
          // toast.warn('Please fill all the required fields to submit the timesheet')
          setShowBackDrop(false)
        }
      } else {
        // toast.warn('Please fill all the required fields to submit the timesheet')
        setShowBackDrop(false)
      }
    }
    setShowBackDrop(false)
    for (let w = 0; w < monthDayDataEntry[index].timesheet_data.length; w++) {
      if (
        monthDayDataEntry[index].timesheet_data[w].regular_hours ||
        monthDayDataEntry[index].timesheet_data[w].regular_minutes
      ) {
        let rMinutes =
          monthDayDataEntry[index].timesheet_data[w].regular_minutes <= 9
            ? '0' + monthDayDataEntry[index].timesheet_data[w].regular_minutes
            : monthDayDataEntry[index].timesheet_data[w].regular_minutes
        monthDayDataEntry[index].timesheet_data[w].regular_hours =
          monthDayDataEntry[index].timesheet_data[w].regular_hours + ':' + rMinutes
      }
      if (
        monthDayDataEntry[index].timesheet_data[w].ot_hours ||
        monthDayDataEntry[index].timesheet_data[w].ot_minutes
      ) {
        let otMinutes =
          monthDayDataEntry[index].timesheet_data[w].ot_minutes <= 9
            ? '0' + monthDayDataEntry[index].timesheet_data[w].ot_minutes
            : monthDayDataEntry[index].timesheet_data[w].ot_minutes
        monthDayDataEntry[index].timesheet_data[w].ot_hours =
          monthDayDataEntry[index].timesheet_data[w].ot_hours + ':' + otMinutes
      }
      if (
        monthDayDataEntry[index].timesheet_data[w].absent_hours ||
        monthDayDataEntry[index].timesheet_data[w].absent_minutes
      ) {
        let absentMinutes =
          monthDayDataEntry[index].timesheet_data[w].absent_minutes <= 9
            ? '0' + monthDayDataEntry[index].timesheet_data[w].absent_minutes
            : monthDayDataEntry[index].timesheet_data[w].absent_minutes
        monthDayDataEntry[index].timesheet_data[w].absent_hours =
          monthDayDataEntry[index].timesheet_data[w].absent_hours + ':' + absentMinutes
      }
    }
    // setweekDayDataEntry([...monthDayDataEntry])
  }
  // const groupDatesByWeek = (datesArray: any) => {
  //   const weeks: any = {} // Store weeks using Monday as the starting key
  //   datesArray.forEach((dateStr: any) => {
  //     const weekStart = getWeekStartDate(dateStr.timesheet_date) // Get Monday of the week
  //     if (!weeks[weekStart]) {
  //       weeks[weekStart] = {timesheet_data: []} // Create new week entry
  //     }
  //     weeks[weekStart].timesheet_data.push(dateStr)
  //   })
  //   return weeks
  // }

  const groupDatesByWeek = (datesArray: any) => {
    const weeks: any = {} // Store weeks using Monday as the starting key
    var satBoolean = false
    var sunBoolean = false
    let newsat, newsun
    var oldWeek = datesArray[0].timesheet_date
    let obj = {
      regular_hours: 0,
      regular_minutes: 0,
      ot_hours: 0,
      ot_minutes: 0,
      absent_type: null,
      absent_hours: 0,
      absent_minutes: 0,
      status: '',
      qb_timesheet_id: null,
      qb_status: null,
    }
    datesArray.forEach((dateStr: any) => {
      const weekStart = getWeekStartDate(dateStr.timesheet_date)
      // Get Monday of the week
      const date = new Date(oldWeek)
      date.setDate(date.getDate() + 5)
      newsat = date.toISOString().split('T')[0]
      const date1 = new Date(oldWeek)
      date1.setDate(date1.getDate() + 6)
      newsun = date1.toISOString().split('T')[0]

      if (newsat == dateStr.timesheet_date) {
        satBoolean = false
      }
      if (newsun == dateStr.timesheet_date) {
        sunBoolean = false
      }
      if (!weeks[weekStart]) {
        if (satBoolean) {
          weeks[oldWeek].timesheet_data.push({
            ...obj,
            timesheet_date: newsat,
          })
        }
        if (sunBoolean) {
          weeks[oldWeek].timesheet_data.push({
            ...obj,
            timesheet_date: newsun,
          })
        }
        satBoolean = true
        sunBoolean = true
        oldWeek = weekStart
        weeks[weekStart] = {timesheet_data: []} // Create new week entry
      }

      weeks[weekStart].timesheet_data.push(dateStr)
    })

    if (weeks[oldWeek].timesheet_data.length == 1) {
      const date2 = new Date(oldWeek)
      date2.setDate(date2.getDate() + 5)
      newsat = date2.toISOString().split('T')[0]
      const date3 = new Date(oldWeek)
      date3.setDate(date3.getDate() + 6)
      newsun = date3.toISOString().split('T')[0]
      weeks[oldWeek].timesheet_data.push({...obj, timesheet_date: newsat})
      weeks[oldWeek].timesheet_data.push({...obj, timesheet_date: newsun})
    } else {
      if (satBoolean) {
        weeks[oldWeek].timesheet_data.push({...obj, timesheet_date: newsat})
      }
      if (sunBoolean) {
        weeks[oldWeek].timesheet_data.push({...obj, timesheet_date: newsun})
      }
    }
    // return Object.values(weeks) // Convert object into an array of weekly groups
    return weeks
  }
  const getWeekStartDate = (dateString: any) => {
    const date = new Date(dateString) //date
    const daysOfWeek1 = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const calculate_day = moment(dateString, 'YYYY-MM-DD').format('ddd')
    let x = daysOfWeek1.findIndex((test: any) => test == calculate_day)
    const dayOfWeek = date.getDay() //2
    const monday = new Date(date)
    monday.setDate(date.getDate() - x + (x === 0 ? -6 : 1)) // Adjust to Monday
    return monday.toISOString().split('T')[0] // Format YYYY-MM-DD
  }
  const handleSubmittedAll = (e: any, index: any) => {
    setSubmitAllOpen(true)
    setSubmitAllShow(false)
    FormSubmitAllProjects(index, 'handleSubmit')
  }

  const modalPopforSubmitAll = () => {
    setSubmitAllOpen(false)
    setSubmitAllShow(false)
    setShowBackDrop(false)
  }
  const TotalSumofHoursEntry = (regulararray: any) => {
    let totalRegularHoursArr: any = []
    let totalOtHoursArr: any = []
    let totalLeaveHoursArr: any = []
    const sumofhour = regulararray?.reduce(function (acc: any, data: any) {
      return acc + Number(data?.regular_hours)
    }, 0)
    const sumofmin = regulararray?.reduce(function (acc: any, data: any) {
      return acc + Number(data?.regular_minutes)
    }, 0)
    const sumofOthour = regulararray?.reduce(function (acc: any, data: any) {
      return acc + Number(data?.ot_hours)
    }, 0)
    const sumofOtmin = regulararray?.reduce(function (acc: any, data: any) {
      return acc + Number(data?.ot_minutes)
    }, 0)
    const sumofLeavehour = regulararray?.reduce(function (acc: any, data: any) {
      return acc + Number(data?.absent_hours)
    }, 0)
    const sumofLeavemin = regulararray?.reduce(function (acc: any, data: any) {
      return acc + Number(data?.absent_minutes)
    }, 0)
    const total_hour = sumofhour * 60
    const total_minutes = total_hour + sumofmin
    const total_ot_hour = sumofOthour * 60
    const total_ot_minutes = total_ot_hour + sumofOtmin
    const total_leave_hour = sumofLeavehour * 60
    const total_leave_minutes = total_leave_hour + sumofLeavemin
    const rh =
      Math.floor(total_minutes / 60) <= 9
        ? '0' + Math.floor(total_minutes / 60)
        : Math.floor(total_minutes / 60)
    const rm = total_minutes % 60 <= 9 ? '0' + (total_minutes % 60) : total_minutes % 60
    const total_sum_of_regular_hours = `${rh}:${rm}`
    const oth =
      Math.floor(total_ot_minutes / 60) <= 9
        ? '0' + Math.floor(total_ot_minutes / 60)
        : Math.floor(total_ot_minutes / 60)
    const otm = total_ot_minutes % 60 <= 9 ? '0' + (total_ot_minutes % 60) : total_ot_minutes % 60
    const total_sum_of_ot_hours = `${oth}:${otm}`

    const lh =
      Math.floor(total_leave_minutes / 60) <= 9
        ? '0' + Math.floor(total_leave_minutes / 60)
        : Math.floor(total_leave_minutes / 60)
    const lm =
      total_leave_minutes % 60 <= 9 ? '0' + (total_leave_minutes % 60) : total_leave_minutes % 60
    const total_sum_of_leave_hours = `${lh}:${lm}`

    totalRegularHoursArr.push(total_sum_of_regular_hours)
    totalOtHoursArr.push(total_sum_of_ot_hours)
    totalLeaveHoursArr.push(total_sum_of_leave_hours)

    setSumofRegularHoursProject(totalRegularHoursArr)
    setSumofOtHoursProject(totalOtHoursArr)
    setSumofLeaveHoursProject(totalLeaveHoursArr)
  }

  const WorkLocationAllContinuePop = (e: any, alert_any: any, index: any) => {
    setWorkAllPopMessage(alert_any)
    setWorkAllPopModifyMessage('')
    setWorkLocationAllShow(false)
    setSubmitAllOpen(true)
    setSubmitAllShow(true)
  }
  const WorkLocationAllOkPop = (e: any, alert: any) => {
    setWorkAllPopMessage('')
    setWorkAllPopModifyMessage(alert)
    var workCountrySetting: any = []
    var workStateSetting: any = []
    weekDayDataEntry.map((items: any, index: any) => {
      let today = moment(new Date()).format('YYYY-MM-DD')
      let pastDay: any = moment(employeesProjectList[index].work_location_updatedate).format(
        'YYYY-MM-DD'
      )
      let startt = moment(today)
      let enddd = moment(pastDay)
      let duration1 = moment.duration(startt.diff(enddd))
      let dayss = duration1.asDays()
      if (dayss >= 90) {
        weekDayDataEntry[index].work_country = ''
        weekDayDataEntry[index].work_state = ''
        weekDayDataEntry[index].work_city = ''
        // employeesProjectList[index].ts_work_city = ''
        // employeesProjectList[index].work_city = ''
        // setEmployeesProjectList([...employeesProjectList])
        setweekDayDataEntry([...weekDayDataEntry])
        let data = [
          {
            name: weekDayDataEntry[index].work_country
              ? weekDayDataEntry[index].work_country
              : null,
          },
        ]
        let data1 = [
          {
            name: weekDayDataEntry[index].work_state ? weekDayDataEntry[index].work_state : null,
          },
        ]
        workCountrySetting[index] = data
        workStateSetting[index] = data1
      } else {
        let data = [
          {
            name: weekDayDataEntry[index].work_country
              ? weekDayDataEntry[index].work_country
              : null,
          },
        ]
        let data1 = [
          {
            name: weekDayDataEntry[index].work_state ? weekDayDataEntry[index].work_state : null,
          },
        ]
        workCountrySetting[index] = data
        workStateSetting[index] = data1
      }
      setWorkLocationAllShow(false)
    })
    setweekDayDataEntry([...weekDayDataEntry])
    setCountries(workCountrySetting)
    setStates(workStateSetting)
  }
  const FormSubmitAllProjects = async (index: any, fromVal: any) => {
    setShowBackDrop(true)
    setindexState(index)
    if (fromVal !== 'handleSubmit') {
      const updatedData = splitHoursAndMinutes(weekDayDataEntry)
      let validProjLength = 0
      let issuesProjectLength = 0
      let WorkLocationAllPopLength = 0
      weekDayDataEntry.map((items: any, index: any) => {
        let today = moment(new Date()).format('YYYY-MM-DD')
        let pastDay: any = moment(employeesProjectList[index].work_location_updatedate).format(
          'YYYY-MM-DD'
        )
        let startt = moment(today)
        let enddd = moment(pastDay)
        let duration1 = moment.duration(startt.diff(enddd))
        let dayss = duration1.asDays()
        let Document =
          docResultDataRes &&
          docResultDataRes.filter((doc: any) => doc.project_id === items.project_id)
        // if (items.user_notes == null || items.user_notes == '' || items.user_notes == undefined) {
        //   ClientManagerNameValidation[index].ccValidation = true
        // } else {
        //   ClientManagerNameValidation[index].ccValidation = false
        // }
        if (
          items.client_manager_name == null ||
          items.client_manager_name == '' ||
          items.client_manager_name == undefined
        ) {
          ClientManagerNameValidation[index].cmValidation = true
        } else {
          ClientManagerNameValidation[index].cmValidation = false
        }
        if (
          disableWorkLocation &&
          (items.work_country == null ||
            items.work_country == '' ||
            items.work_country == undefined)
        ) {
          WorkLocationValidation[index].countryValidation = true
        } else {
          WorkLocationValidation[index].countryValidation = false
        }
        if (
          disableWorkLocation &&
          (items.work_state == null || items.work_state == '' || items.work_state == undefined)
        ) {
          WorkLocationValidation[index].stateValidation = true
        } else {
          WorkLocationValidation[index].stateValidation = false
        }
        if (
          disableWorkLocation &&
          (items.work_city == null || items.work_city == '' || items.work_city == undefined)
        ) {
          WorkLocationValidation[index].cityValidation = true
        } else {
          WorkLocationValidation[index].cityValidation = false
        }
        let Timesheet = items?.timesheet_data?.filter(
          (test: any) =>
            test.regular_hours == 0 && (test.absent_hours > 0 || test.absent_minutes > 0)
        )
        let Timesheet1 = items?.timesheet_data?.filter((test: any) => test.regular_hours > 0)

        if (Document?.length === 0 || Document == undefined || Document == null || Document == '') {
          // if (employeesProjectList[index].is_placement_project) {
          if (employeesProjectList[index].is_placement_project == 1) {
            if (Timesheet?.length == 0 || Timesheet1.length > 0) {
              ClientManagerNameValidation[index].ucValidation = true
            }
          } else {
            ClientManagerNameValidation[index].ucValidation = false
          }
        } else {
          ClientManagerNameValidation[index].ucValidation = false
        }

        if (
          items.user_notes == null ||
          items.user_notes == '' ||
          items.user_notes == undefined ||
          items.client_manager_name == null ||
          items.client_manager_name == '' ||
          items.client_manager_name == undefined ||
          (disableWorkLocation &&
            (items.work_country == null ||
              items.work_country == '' ||
              items.work_country == undefined ||
              items.work_state == null ||
              items.work_state == '' ||
              items.work_state == undefined ||
              items.work_city == null ||
              items.work_city == '' ||
              items.work_city == undefined)) ||
          // items.client_manager_email == null ||
          // items.client_manager_email == '' ||
          // items.client_manager_email == undefined ||
          Document?.length === 0 ||
          Document == undefined ||
          Document == null ||
          Document == ''
        ) {
          // issuesProjectLength += 1
          if (
            // (employeesProjectList[index].is_placement_project &&
            (employeesProjectList[index].is_placement_project == 1 &&
              (Timesheet?.length == 0 || Timesheet1.length > 0)) ||
            items.user_notes == null ||
            items.user_notes == '' ||
            items.user_notes == undefined ||
            items.client_manager_name == null ||
            items.client_manager_name == '' ||
            items.client_manager_name == undefined ||
            (disableWorkLocation &&
              (items.work_country == null ||
                items.work_country == '' ||
                items.work_country == undefined ||
                items.work_state == null ||
                items.work_state == '' ||
                items.work_state == undefined ||
                items.work_city == null ||
                items.work_city == '' ||
                items.work_city == undefined))
          ) {
            issuesProjectLength += 1
          } else {
            validProjLength += 1
          }
        } else {
          validProjLength += 1
        }

        if (workAllPopModifyMessage != 'modify') {
          //before click on modify
          if (dayss >= 90) {
            WorkLocationAllPopLength += 1
          } else {
            setWorkAllPopMessage('')
          }
        }
      })
      if (issuesProjectLength > 0) {
        // toast.warn(`Please fill all the required fields to submit the timesheet`)
      }

      if (weekDayDataEntry.length === validProjLength) {
        const data = updatedData
        let regulararray = []

        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < data[i].timesheet_data?.length; j++) {
            if (data[i].timesheet_data[j].status != 'APPROVED') {
              let data123: any = data[i].timesheet_data[j]
              regulararray.push(data123)
            }
          }
        }
        TotalSumofHoursEntry(regulararray)

        let validWeekLength = 0

        for (let j = 0; j < data.length; j++) {
          let updateTimesheetDataArray = []
          let duplicateWeekEntry = []
          for (let i = 0; i < data[j].timesheet_data.length; i++) {
            if (
              Number(data[j].timesheet_data[i].regular_hours) > 0 ||
              Number(data[j].timesheet_data[i].regular_minutes) > 0 ||
              Number(data[j].timesheet_data[i].ot_hours) > 0 ||
              Number(data[j].timesheet_data[i].ot_minutes) > 0 ||
              Number(data[j].timesheet_data[i].absent_hours) > 0 ||
              Number(data[j].timesheet_data[i].absent_minutes) > 0 ||
              Number(data[j].timesheet_data[i].absent_type) == 2
            ) {
              updateTimesheetDataArray.push(data[j].timesheet_data[i])
            }
            duplicateWeekEntry.push(data[j].timesheet_data[i])
          }

          if (updateTimesheetDataArray.length > 0) {
            data[j].timesheet_data = updateTimesheetDataArray
            validWeekLength += 1
          } else {
            toast.warn(`Timesheets data are missing `)
          }
          weekDayDataEntry[j].timesheet_data = duplicateWeekEntry
        }

        if (data.length === validWeekLength) {
          if (WorkLocationAllPopLength > 0) {
            setWorkLocationAllShow(true)
          } else {
            setSubmitAllOpen(true)
            setSubmitAllShow(true)
          }
        }
      }

      setweekDayDataEntry([...weekDayDataEntry])
    } else if (fromVal === 'handleSubmit') {
      const updatedData = splitHoursAndMinutes(weekDayDataEntry)
      let validProjLength = 0
      let issuesProjectLength = 0

      weekDayDataEntry.map((items: any, index: any) => {
        let Document =
          docResultDataRes &&
          docResultDataRes.filter((doc: any) => doc.project_id === items.project_id)

        let Timesheet = items?.timesheet_data?.filter(
          (test: any) =>
            test.regular_hours == 0 && (test.absent_hours > 0 || test.absent_minutes > 0)
        )
        let Timesheet1 = items?.timesheet_data?.filter((test: any) => test.regular_hours > 0)

        if (
          items.user_notes == null ||
          items.user_notes == '' ||
          items.user_notes == undefined ||
          items.client_manager_name == null ||
          items.client_manager_name == '' ||
          items.client_manager_name == undefined ||
          (disableWorkLocation &&
            (items.work_country == null ||
              items.work_country == '' ||
              items.work_country == undefined ||
              items.work_state == null ||
              items.work_state == '' ||
              items.work_state == undefined ||
              items.work_city == null ||
              items.work_city == '' ||
              items.work_city == undefined)) ||
          // items.client_manager_email == null ||
          // items.client_manager_email == '' ||
          // items.client_manager_email == undefined ||
          Document?.length === 0 ||
          Document == undefined ||
          Document == null ||
          Document == ''
        ) {
          // issuesProjectLength += 1
          if (
            // (employeesProjectList[index].is_placement_project &&
            (employeesProjectList[index].is_placement_project == 1 &&
              (Timesheet?.length == 0 || Timesheet1.length > 0)) ||
            items.user_notes == null ||
            items.user_notes == '' ||
            items.user_notes == undefined ||
            items.client_manager_name == null ||
            items.client_manager_name == '' ||
            items.client_manager_name == undefined ||
            (disableWorkLocation &&
              (items.work_country == null ||
                items.work_country == '' ||
                items.work_country == undefined ||
                items.work_state == null ||
                items.work_state == '' ||
                items.work_state == undefined ||
                items.work_city == null ||
                items.work_city == '' ||
                items.work_city == undefined))
          ) {
            issuesProjectLength += 1
          } else {
            validProjLength += 1
          }
        } else {
          validProjLength += 1
        }
      })
      if (issuesProjectLength > 0) {
        // toast.warn(`Please fill all the required fields to submit the timesheet`)
      }

      if (weekDayDataEntry.length === validProjLength) {
        const data = updatedData
        let validWeekLength = 0
        weekDayDataEntry.map((items: any, index: any) => {
          let today = moment(new Date()).format('YYYY-MM-DD')
          let pastDay: any = moment(employeesProjectList[index].work_location_updatedate).format(
            'YYYY-MM-DD'
          )
          let startt = moment(today)
          let enddd = moment(pastDay)
          let duration1 = moment.duration(startt.diff(enddd))
          let dayss = duration1.asDays()

          let wcountry =
            items.work_country == employeesProjectList[index]?.ts_work_country ||
            items.work_country == employeesProjectList[index]?.work_country

          let ws =
            items.work_state == employeesProjectList[index]?.ts_work_state ||
            items.work_state == employeesProjectList[index]?.work_state

          let wc =
            items.work_city == employeesProjectList[index]?.ts_work_city ||
            items.work_city == employeesProjectList[index]?.work_city

          if (workAllPopModifyMessage == 'modify') {
            //after click on modify
            if (dayss >= 90) {
              if (!wcountry || !ws || !wc) {
                //changed
                weekDayDataEntry[index].user_same_work_location = false
                setWorkAllPopMessage('')
              } else {
                weekDayDataEntry[index].user_same_work_location = true
              }
            }
          } else {
            weekDayDataEntry[index].user_same_work_location = false
          }

          if (workAllPopMessage == 'continue') {
            weekDayDataEntry[index]['user_same_work_location'] = true
          } else if (workAllPopModifyMessage == 'modify') {
            weekDayDataEntry[index]['user_same_work_location'] =
              weekDayDataEntry[index].user_same_work_location
          } else {
            weekDayDataEntry[index]['user_same_work_location'] = false
          }
        })

        for (let j = 0; j < data.length; j++) {
          let updateTimesheetDataArray = []
          for (let i = 0; i < data[j].timesheet_data.length; i++) {
            if (
              Number(data[j].timesheet_data[i].regular_hours) > 0 ||
              Number(data[j].timesheet_data[i].regular_minutes) > 0 ||
              Number(data[j].timesheet_data[i].ot_hours) > 0 ||
              Number(data[j].timesheet_data[i].ot_minutes) > 0 ||
              Number(data[j].timesheet_data[i].absent_hours) > 0 ||
              Number(data[j].timesheet_data[i].absent_minutes) > 0 ||
              Number(data[j].timesheet_data[i].absent_type) == 2
            ) {
              updateTimesheetDataArray.push(data[j].timesheet_data[i])
            }
          }

          for (let j = 0; j < data.length; j++) {
            let sat_check = updateTimesheetDataArray.find(
              (f1: any) => f1.timesheet_date == weekDates[5]
            )

            if (!sat_check) {
              updateTimesheetDataArray.push({
                timesheet_date: weekDates[5],
                regular_hours: 0,
                regular_minutes: 0,
                ot_hours: 0,
                ot_minutes: 0,
                absent_type: null,
                absent_hours: 0,
                absent_minutes: 0,
                status: '',
                qb_timesheet_id: null,
                qb_status: null,
              })
            }
            let sun_check = updateTimesheetDataArray.find(
              (f1: any) => f1.timesheet_date == weekDates[6]
            )
            if (!sun_check) {
              updateTimesheetDataArray.push({
                timesheet_date: weekDates[6],
                regular_hours: 0,
                regular_minutes: 0,
                ot_hours: 0,
                ot_minutes: 0,
                absent_type: null,
                absent_hours: 0,
                absent_minutes: 0,
                status: '',
                qb_timesheet_id: null,
                qb_status: null,
              })
            }
          }

          if (updateTimesheetDataArray.length > 0) {
            data[j].timesheet_data = updateTimesheetDataArray
            data[j].ot_product = data[j].ot_product
            validWeekLength += 1
          } else {
            toast.warn(`Timesheets data are missing `)
          }
        }

        if (data.length === validWeekLength) {
          const updatedSendingData = {
            year: moment(weekStartDate).format('YYYY'),
            month: moment(weekStartDate).format('MM'),
            week_start_date: weekStartDate,
            week_end_date: weekEndDate,
            timesheets: data,
          }
          const timeSheetAllProjectSubmit: any = await Apiservices.timeSheetSubmitAllProject(
            updatedSendingData
          )
          if (numArray?.includes('timesheetadmin')) {
            if (docResultDataRes) {
              for (let j = 0; j < data.length; j++) {
                let docarr = []
                for (let each of docResultDataRes) {
                  if (data[j].project_id == each.project_id)
                    if (each.previous_doc) {
                      docarr.push(each.id)
                    }
                }

                const updateDocsData = {
                  user_id: data[j].user_id,
                  project_id: data[j].project_id,
                  week_start_date: weekStartDate,
                  week_end_date: weekEndDate,
                  documents: docarr,
                }
                if (docarr && docarr.length > 0) {
                  var copyDocs: any = await Apiservices.copyTimesheetDocs(updateDocsData)
                  if (copyDocs.message == 'Added Successfully') {
                    setPrevAr([])
                  }
                }
              }
            }
          }
          handlerForResetDataAndShowToasters(
            timeSheetAllProjectSubmit.message,
            timeSheetAllProjectSubmit.isError
          )
        }
      }
    }
    for (let i = 0; i < weekDayDataEntry.length; i++) {
      for (let w = 0; w < weekDayDataEntry[i].timesheet_data.length; w++) {
        if (
          weekDayDataEntry[i].timesheet_data[w].regular_hours ||
          weekDayDataEntry[i].timesheet_data[w].regular_minutes
        ) {
          let rMinutes =
            weekDayDataEntry[i].timesheet_data[w].regular_minutes <= 9
              ? '0' + weekDayDataEntry[i].timesheet_data[w].regular_minutes
              : weekDayDataEntry[i].timesheet_data[w].regular_minutes
          weekDayDataEntry[i].timesheet_data[w].regular_hours =
            weekDayDataEntry[i].timesheet_data[w].regular_hours + ':' + rMinutes
        }
        if (
          weekDayDataEntry[i].timesheet_data[w].ot_hours ||
          weekDayDataEntry[i].timesheet_data[w].ot_minutes
        ) {
          weekDayDataEntry[i].timesheet_data[w].ot_hours =
            weekDayDataEntry[i].timesheet_data[w].ot_hours +
            ':' +
            weekDayDataEntry[i].timesheet_data[w].ot_minutes
        }
        if (
          weekDayDataEntry[i].timesheet_data[w].absent_hours ||
          weekDayDataEntry[i].timesheet_data[w].absent_minutes
        ) {
          weekDayDataEntry[i].timesheet_data[w].absent_hours =
            weekDayDataEntry[i].timesheet_data[w].absent_hours +
            ':' +
            weekDayDataEntry[i].timesheet_data[w].absent_minutes
        }
      }
    }
    setweekDayDataEntry([...weekDayDataEntry])
    setShowBackDrop(false)
  }
  const FormSaveAll = async (index: any) => {
    setShowBackDrop(true)
    const updatedData = splitHoursAndMinutes(weekDayDataEntry)
    const data = updatedData
    let validWeekLength = 0
    for (let j = 0; j < data.length; j++) {
      let updateTimesheetDataArray = []
      for (let i = 0; i < data[j].timesheet_data.length; i++) {
        if (
          Number(data[j].timesheet_data[i].regular_hours) > 0 ||
          Number(data[j].timesheet_data[i].regular_minutes) > 0 ||
          Number(data[j].timesheet_data[i].ot_hours) > 0 ||
          Number(data[j].timesheet_data[i].ot_minutes) > 0 ||
          Number(data[j].timesheet_data[i].absent_hours) > 0 ||
          Number(data[j].timesheet_data[i].absent_minutes) > 0 ||
          Number(data[j].timesheet_data[i].absent_type) == 2 ||
          Number(data[j].timesheet_data[i].id)
        ) {
          updateTimesheetDataArray.push(data[j].timesheet_data[i])
        }
      }
      if (updateTimesheetDataArray.length > 0) {
        data[j].timesheet_data = updateTimesheetDataArray
        data[j].ot_product = data[j].ot_product
        validWeekLength += 1
      } else {
        toast.warn(`Timesheet entries are missing `)
      }
    }
    if (data.length === validWeekLength) {
      const updatedSendingData = {
        year: moment(weekStartDate).format('YYYY'),
        month: moment(weekStartDate).format('MM'),
        week_start_date: weekStartDate,
        week_end_date: weekEndDate,
        timesheets: data,
      }
      var saveAllProjects: any = await Apiservices.timeSheetSaveAllInsert(updatedSendingData)
      if (numArray?.includes('timesheetadmin')) {
        if (docResultDataRes) {
          for (let j = 0; j < data.length; j++) {
            let docarr = []
            for (let each of docResultDataRes) {
              if (data[j].project_id == each.project_id)
                if (each.previous_doc) {
                  docarr.push(each.id)
                }
            }
            const updateDocsData = {
              user_id: data[j].user_id,
              project_id: data[j].project_id,
              week_start_date: weekStartDate,
              week_end_date: weekEndDate,
              documents: docarr,
            }
            if (docarr && docarr.length > 0) {
              var copyDocs: any = await Apiservices.copyTimesheetDocs(updateDocsData)

              if (copyDocs.message == 'Added Successfully') {
                setPrevAr([])
              }
            }
          }
        }
      }
      handlerForResetDataAndShowToasters(saveAllProjects.message, saveAllProjects.isError)
    }
    setShowBackDrop(false)
  }
  const FormSingleProjectUnSubmit = async (index: any) => {
    setShowBackDrop(true)
    const data = monthDayDataEntry[index]
    const unSubmitData = {
      user_id: data.user_id,
      project_id: data.project_id,
      year: data.year,
      month: parseInt(data.month),
      ot_product: data.ot_product,
    }
    const singleProjectUnSubmit: any = await Apiservices.timeSheetUnSubmitMonthSingleProject(
      unSubmitData
    )
    handlerForResetDataAndShowToasters(singleProjectUnSubmit.message, singleProjectUnSubmit.isError)
  }

  const FormUnSubmitAll = async (index: any) => {
    setShowBackDrop(true)
    const data = weekDayDataEntry
    var timesheetData = []
    for (let i = 0; i < data.length; i++) {
      var unSubmitData = {
        user_id: data[i].user_id,
        project_id: data[i].project_id,
        year: data[i].year,
        month: parseInt(data[i].month),
        week_start_date: data[i].week_start_date,
        week_end_date: data[i].week_end_date,
        ot_product: data[i].ot_product,
      }
      timesheetData.push(unSubmitData)
    }
    const unSubmitAllData = {
      year: moment(weekStartDate).format('YYYY'),
      month: moment(weekStartDate).format('MM'),
      week_start_date: weekStartDate,
      week_end_date: weekEndDate,
      timesheets: timesheetData,
    }
    const unSubmitAllProjects: any = await Apiservices.timeSheetUnSubmitAllProject(unSubmitAllData)
    handlerForResetDataAndShowToasters(unSubmitAllProjects.message, unSubmitAllProjects.isError)
  }
  const splitHoursAndMinutes = (data: any) => {
    if (data.length > 0) {
      for (let j = 0; j < data.length; j++) {
        for (let i = 0; i < data[j].timesheet_data.length; i++) {
          if (data[j].timesheet_data[i].regular_hours) {
            if (data[j].timesheet_data[i].regular_hours.toString().indexOf(':') > -1) {
              let splitRegularHours = data[j].timesheet_data[i].regular_hours.split(':')
              data[j].timesheet_data[i].regular_hours = parseInt(splitRegularHours[0])
              data[j].timesheet_data[i].regular_minutes = parseInt(splitRegularHours[1])
            }
          }
          if (data[j].timesheet_data[i].absent_hours) {
            if (data[j].timesheet_data[i].absent_hours.toString().indexOf(':') > -1) {
              let splitAbsentHours = data[j].timesheet_data[i].absent_hours.split(':')
              data[j].timesheet_data[i].absent_hours = parseInt(splitAbsentHours[0])
              data[j].timesheet_data[i].absent_minutes = parseInt(splitAbsentHours[1])
            }
          }
          if (data[j].timesheet_data[i].ot_hours) {
            if (data[j].timesheet_data[i].ot_hours.toString().indexOf(':') > -1) {
              let splitOTHours = data[j].timesheet_data[i].ot_hours.split(':')
              data[j].timesheet_data[i].ot_hours = parseInt(splitOTHours[0])
              data[j].timesheet_data[i].ot_minutes = parseInt(splitOTHours[1])
            }
          }
        }
      }
      return data
    } else {
      for (let i = 0; i < data.timesheet_data.length; i++) {
        if (data.timesheet_data[i].regular_hours) {
          if (data.timesheet_data[i].regular_hours.toString().indexOf(':') > -1) {
            let splitRegularHours = data.timesheet_data[i].regular_hours.split(':')
            data.timesheet_data[i].regular_hours = parseInt(splitRegularHours[0])
            data.timesheet_data[i].regular_minutes = parseInt(splitRegularHours[1])
          }
        }
        if (data.timesheet_data[i].absent_hours) {
          if (data.timesheet_data[i].absent_hours.toString().indexOf(':') > -1) {
            let splitAbsentHours = data.timesheet_data[i].absent_hours.split(':')
            data.timesheet_data[i].absent_hours = parseInt(splitAbsentHours[0])
            data.timesheet_data[i].absent_minutes = parseInt(splitAbsentHours[1])
          }
        }
        if (data.timesheet_data[i].ot_hours) {
          if (data.timesheet_data[i].ot_hours.toString().indexOf(':') > -1) {
            let splitOTHours = data.timesheet_data[i].ot_hours.split(':')
            data.timesheet_data[i].ot_hours = parseInt(splitOTHours[0])
            data.timesheet_data[i].ot_minutes = parseInt(splitOTHours[1])
          }
        }
      }

      return data
    }
  }
  const splitHoursAndMinutesTwo = (data: any) => {
    if (data.length > 0) {
      for (let j = 0; j < data.length; j++) {
        for (let i = 0; i < data[j].timesheet_data.length; i++) {
          if (data[j].timesheet_data[i].regular_hours) {
            if (data[j].timesheet_data[i].regular_hours.toString().indexOf(':') > -1) {
              let splitRegularHours = data[j].timesheet_data[i].regular_hours.split(':')
              data[j].timesheet_data[i].regular_hours = parseInt(splitRegularHours[0])
              data[j].timesheet_data[i].regular_minutes = parseInt(splitRegularHours[1])
            }
          } else {
            data[j].timesheet_data[i].regular_hours = 0
          }
          if (data[j].timesheet_data[i].absent_hours) {
            if (data[j].timesheet_data[i].absent_hours.toString().indexOf(':') > -1) {
              let splitAbsentHours = data[j].timesheet_data[i].absent_hours.split(':')
              data[j].timesheet_data[i].absent_hours = parseInt(splitAbsentHours[0])
              data[j].timesheet_data[i].absent_minutes = parseInt(splitAbsentHours[1])
            }
          } else {
            data[j].timesheet_data[i].absent_hours = 0
          }
          if (data[j].timesheet_data[i].ot_hours) {
            if (data[j].timesheet_data[i].ot_hours.toString().indexOf(':') > -1) {
              let splitOTHours = data[j].timesheet_data[i].ot_hours.split(':')
              data[j].timesheet_data[i].ot_hours = parseInt(splitOTHours[0])
              data[j].timesheet_data[i].ot_minutes = parseInt(splitOTHours[1])
            }
          } else {
            data[j].timesheet_data[i].ot_hours = 0
          }
        }
      }
      return data
    } else {
      for (let i = 0; i < data.timesheet_data.length; i++) {
        if (data.timesheet_data[i].regular_hours) {
          if (data.timesheet_data[i].regular_hours.toString().indexOf(':') > -1) {
            let splitRegularHours = data.timesheet_data[i].regular_hours.split(':')
            data.timesheet_data[i].regular_hours = parseInt(splitRegularHours[0])
            data.timesheet_data[i].regular_minutes = parseInt(splitRegularHours[1])
          }
        }
        if (data.timesheet_data[i].absent_hours) {
          if (data.timesheet_data[i].absent_hours.toString().indexOf(':') > -1) {
            let splitAbsentHours = data.timesheet_data[i].absent_hours.split(':')
            data.timesheet_data[i].absent_hours = parseInt(splitAbsentHours[0])
            data.timesheet_data[i].absent_minutes = parseInt(splitAbsentHours[1])
          }
        }
        if (data.timesheet_data[i].ot_hours) {
          if (data.timesheet_data[i].ot_hours.toString().indexOf(':') > -1) {
            let splitOTHours = data.timesheet_data[i].ot_hours.split(':')
            data.timesheet_data[i].ot_hours = parseInt(splitOTHours[0])
            data.timesheet_data[i].ot_minutes = parseInt(splitOTHours[1])
          }
        }
      }

      return data
    }
  }

  const removeDoc1 = async (fileName: any, projectIndex: any, projectID: any) => {
    var formData = new FormData()
    const doc_id = documentId[projectIndex]
    formData.append('id', doc_id)
    let Doc = docResultDataRes[projectIndex]
    let arr = docResultDataRes
    if (Doc.previous_doc) {
      let x = arr.splice(projectIndex, 1)
      setDocResultDataRes([...arr])
      setPrevAr([...arr])
    } else {
      const response: any = await Apiservices.deleteMonthlyDocId({
        id: fileName,
      })

      const response1 = await Apiservices.docNameIdMonthlyProjectList1({
        // week_start_date: weekStartDate,
        // week_end_date: weekEndDate,
        // project_id: projectID,

        user_id: user_id,
        project_id: Project_id,
        month: weekEndDate,
        year: weekStartDate,
      })
      setDocResultDataRes(response1.data.data)
      // if (numArray?.includes('timesheetadmin')) {
      //   if (response1.data.data && response1.data.data.length > 0 && prevAr && prevAr.length > 0) {
      //     var test3 = [...prevAr, ...response1.data.data]
      //   } else if (response1.data.data?.length == null && prevAr?.length == null) {
      //     // var test3 = [...prevAr]
      //     var test3 = [response1?.data?.data]
      //   } else if (prevAr && prevAr?.length > 0 && response1.data.data?.length == null) {
      //     var test3 = [...prevAr]
      //   } else {
      //     var test3 = response1?.data?.data ? [...response1?.data?.data] : []
      //   }

      //   setDocResultDataRes(test3)
      // } else {
      //   setDocResultDataRes(response1.data.data)
      // }
      // let DocumentsData = imagesArrayRes

      // for (let each in imagesArrayRes) {
      //   if (projectID === imagesArrayRes[each].project_id) {
      //     DocumentsData[each].documents = response1.data.data !== null ? response1.data.data : []
      //   }
      // }

      // setImagesArrayRes(DocumentsData)
      // setDocumentId([...documentId])
      // let state2: any = location.state
      // let userIdData5 =
      //   state2?.names == 'create'
      //     ? localStorage.getItem('time_sheet_admin_screen_user_id')
      //     : localStorage.getItem('userid')

      // const getImages = await Apiservices.docNameIdProjectList1({
      //   week_start_date: weekStartDate,
      //   week_end_date: weekEndDate,
      //   user_id: userIdData5,
      // })
      // setDocResultDataRes(getImages.data.data)
      // if (numArray?.includes('timesheetadmin')) {
      //   if (
      //     getImages?.data?.data &&
      //     getImages?.data?.data?.length > 0 &&
      //     prevAr &&
      //     prevAr.length > 0
      //   ) {
      //     var test4 = [...prevAr, ...getImages?.data?.data]
      //   } else if (getImages?.data?.data?.length == null && prevAr?.length == null) {
      //     // var test4 = [...prevAr]
      //     var test4 = [getImages?.data?.data]
      //   } else if (prevAr && prevAr?.length > 0 && getImages?.data?.data?.length == null) {
      //     var test4 = [...prevAr]
      //   } else {
      //     var test4 = getImages?.data?.data ? [...getImages?.data?.data] : []
      //   }
      //   setDocResultDataRes(test4)
      // } else {
      //   setDocResultDataRes(getImages.data.data)
      // }
    }
  }

  const downloadFile = (blob: any, index: any) => {
    var link = document.createElement('a')
    // If you don't know the name or want to use
    // the webserver default set name = ''
    link.setAttribute('download', 'Downloaded File')
    link.href = blob
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
  const handleDownload = async (url1: string, docIndex: number, original_name?: any) => {
    try {
      const token = localStorage.getItem('Authorization') // or however you store your JWT
      if (!token) {
        console.error('No authentication token found')
        return
      }
      const response: any = await fetch(url1, {
        method: 'GET',
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      if (!response.ok) {
        toast.warn(response.statusText)
        throw new Error(`Failed to download file: ${response.statusText}`)
      }
      // Get the filename from Content-Disposition header or use provided/default
      const contentDisposition = response.headers.get('Content-Disposition')
      let downloadFilename = 'Downloaded File'
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
        if (filenameMatch) {
          downloadFilename = filenameMatch[1]
        }
      }
      const blob = await response.blob()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      // link.setAttribute('download', downloadFilename)
      link.setAttribute('download', original_name)
      document.body.appendChild(link)
      link.click()
      link.remove()
      // window.URL.revokeObjectURL(link.href)
    } catch (error) {
      console.error('Download failed:', error)
      // You can add toast notification or other error handling here
    }
  }

  const getDemoBlob = async (doc: any): Promise<Blob | null> => {
    if (doc._blob) return doc._blob

    const fileName = doc.original_name?.toLowerCase()
    const extension = fileName ? fileName.split('.').pop() : undefined

    // ✅ Word documents
    if (extension === 'docx') {
      if (doc.blobUrl) {
        try {
          const token = localStorage.getItem('Authorization')

          if (!token) {
            return null
          }
          const response: any = await fetch(doc.blobUrl, {
            method: 'GET',
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          })
          if (!response.ok) {
            toast.warn(response.statusText)
            throw new Error(`Failed to fetch DOCX: ${response.statusText}`)
          }
          const blob = await response.blob()
          return blob
        } catch (error) {
          return null
        }
      }
    }
    if (extension === 'xlsx' || extension === 'xls') {
      if (doc.blobUrl) {
        try {
          const token = localStorage.getItem('Authorization')
          if (!token) {
            return null
          }
          const response: any = await fetch(doc.blobUrl, {
            method: 'GET',
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          })
          if (!response.ok) {
            toast.warn(response.statusText)
            throw new Error(`Failed to download file: ${response.statusText}`)
          }
          const blob = await response.blob()
          return blob
        } catch (error) {
          return null
        }
      }
      return null
    }
    return null
  }

  const handleViewToken = async (url1: string, single_obj?: any) => {
    const fileName = single_obj?.original_name?.toLowerCase()
    const extension = fileName ? fileName.split('.').pop() : undefined

    // const blob = await getDemoBlob(single_obj)
    if (extension === 'docx') {
      const blob = await getDemoBlob(single_obj)
      if (blob) {
        try {
          const mammoth = await import('mammoth')
          const arrayBuffer = await blob.arrayBuffer()
          const result = await mammoth.convertToHtml({arrayBuffer})

          // ✅ CREATE A BLOB URL AND OPEN IN NEW TAB
          const htmlContent = `
              <!DOCTYPE html>
              <html>
                <head>
                  <meta charset="UTF-8">
                  <title>${single_obj?.original_name || 'Document'}</title>
                  <style>
                    body {
                      font-family: Onest, sans-serif;
                      max-width: 800px;
                      margin: 40px auto;
                      padding: 20px;
                      line-height: 1.6;
                    }
                  </style>
                </head>
                <body>
                  ${result.value || '<p>No content found in document.</p>'}
                </body>
              </html>
            `

          const htmlBlob = new Blob([htmlContent], {type: 'text/html'})
          const htmlUrl = window.URL.createObjectURL(htmlBlob)
          window.open(htmlUrl, '_blank')

          // Optional: Clean up after a delay
          setTimeout(() => window.URL.revokeObjectURL(htmlUrl), 1000)
        } catch (err) {
          // setDocxHtml('<p style="color:red;">Failed to render DOCX preview.</p>')
          // setPreviewType('docx')
        }
      }
    } else if (extension === 'xlsx' || extension === 'xls') {
      const blob = await getDemoBlob(single_obj)
      if (blob) {
        try {
          const arrayBuffer = await blob.arrayBuffer()
          const XLSX = await import('xlsx')
          const workbook = XLSX.read(arrayBuffer, {type: 'array'})

          // ✅ BUILD HTML WITH ALL SHEETS
          let sheetsHtml = ''

          workbook.SheetNames.forEach((sheetName, index) => {
            const sheet = workbook.Sheets[sheetName]
            const htmlTable = XLSX.utils.sheet_to_html(sheet, {
              header: '',
              footer: '',
            })

            sheetsHtml += `
              <div class="sheet-container">
                <h2 class="sheet-title">Sheet: ${sheetName}</h2>
                ${htmlTable}
              </div>
              ${index < workbook.SheetNames.length - 1 ? '<hr class="sheet-divider">' : ''}
            `
          })

          // ✅ CREATE HTML DOCUMENT WITH STYLED TABLES
          const htmlContent = `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="UTF-8">
                <title>${single_obj?.original_name || 'Spreadsheet'}</title>
                <style>
                  body {
                    font-family: Onest, Arial, sans-serif;
                    margin: 20px;
                    padding: 20px;
                    background-color: #f5f5f5;
                  }
                  .sheet-container {
                    background: white;
                    padding: 20px;
                    margin-bottom: 20px;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    overflow-x: auto;
                  }
                  .sheet-title {
                    color: #333;
                    margin-top: 0;
                    margin-bottom: 15px;
                    font-size: 18px;
                    font-weight: 600;
                  }
                  .sheet-divider {
                    border: none;
                    height: 2px;
                    background: #e0e0e0;
                    margin: 30px 0;
                  }
                  table {
                    border-collapse: collapse;
                    width: 100%;
                    font-size: 14px;
                  }
                  td, th {
                    border: 1px solid #ddd;
                    padding: 8px 12px;
                    text-align: left;
                  }
                  th {
                    background-color: #f8f9fa;
                    font-weight: 600;
                    color: #333;
                  }
                  tr:nth-child(even) {
                    background-color: #f9f9f9;
                  }
                  tr:hover {
                    background-color: #f0f0f0;
                  }
                </style>
              </head>
              <body>
                <h1 style="color: #333; margin-bottom: 30px;">
                  ${single_obj?.original_name || 'Spreadsheet Preview'}
                </h1>
                ${sheetsHtml}
              </body>
            </html>
          `

          // ✅ CREATE BLOB URL AND OPEN IN NEW TAB
          const htmlBlob = new Blob([htmlContent], {type: 'text/html'})
          const htmlUrl = window.URL.createObjectURL(htmlBlob)
          window.open(htmlUrl, '_blank')

          // Optional: Clean up after a delay
          setTimeout(() => window.URL.revokeObjectURL(htmlUrl), 1000)
        } catch (err) {
          // setPreviewType('none')
        }
      }
    } else {
      try {
        const token = localStorage.getItem('Authorization') // or however you store your JWT
        if (!token) {
          console.error('No authentication token found')
          return
        }
        const response: any = await fetch(url1, {
          method: 'GET',
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        })
        if (!response.ok) {
          toast.warn(response.statusText)
          throw new Error(`Failed to download file: ${response.statusText}`)
        }
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
        // window.URL.revokeObjectURL(link.href)
      } catch (error) {
        console.error('Download failed:', error)
        // You can add toast notification or other error handling here
      }
    }
  }
  const viewFile = (blob: any, index: any) => {
    // window.open(blob, '_blank', 'noopener,noreferrer')
    // window.location.href = blob
    setViewOpen(true)
    setViewBlob(blob)
    setViewShow(true)
    setHistoryOpenPerWeek(false)
  }
  const handleCancel = () => {
    setViewShow(false)
  }

  const getHistoryPerDay = async (proj_id: any, timesheet_date: any) => {
    setShow(true)
    setHistoryOpenPerDay(true)

    const test = {
      project_id: proj_id,
      week_start_date: weekStartDate,
      week_end_date: weekEndDate,
      timesheet_date: moment(timesheet_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    }
    const res = await Apiservices.timesheetHistoryPerDay(test)
    if (res.data && res.data.data && res.data.data) {
      setHistoryPerDay(res.data.data)
    } else {
      setHistoryPerDay([])
    }
  }

  const getHistoryPerWeek = async (project_id: any, list: any) => {
    setShow(true)
    setHistoryOpenPerWeek(true)
    const week = `${weekStartDate}T00:00:00Z-${weekEndDate}T00:00:00Z`

    const test = {
      project_id: project_id,
      week_start_date: weekStartDate,
      week_end_date: weekEndDate,
    }
    const res = await Apiservices.timesheetHistory(test)

    if (res.data && res.data.data && res.data.data) {
      setHistoryPerWeek(res.data.data.timesheet_status_history)
    } else {
      setHistoryPerWeek([])
    }
  }

  const handleSubmit1 = () => {}
  const [textinput, setTextinput] = useState('')

  const test = (event: any) => {
    setTextinput(event.target.value)
  }
  const [leaveOnBlurData, setLeaveOnBlurData] = useState<any | {}>({})
  const leaveOnBlur = (e: any, index: any, weekDayIndex: any, validationHours: any) => {
    const leaveData = {
      e: e,
      projectIndex: index,
      dayIndex: weekDayIndex,
      validationHours: validationHours,
    }
    setLeaveOnBlurData(leaveData)
    let eValue = e.target.value.toString()
    if (eValue.indexOf(':') > 0) {
      let EnteredHours = e.target.value.split(':')
      let totalLeaveMinutes: number = EnteredHours[0] * 60 + parseInt(EnteredHours[1])
      callValidate(totalLeaveMinutes, e, index, weekDayIndex, validationHours)
    } else if (eValue.indexOf('.') > 0) {
      let EnteredHours = e.target.value.split('.')
      let totalLeaveMinutes: number = EnteredHours[0] * 60 + parseInt(EnteredHours[1])
      callValidate(totalLeaveMinutes, e, index, weekDayIndex, validationHours)
    } else {
      let totalLeaveMinutes: number = e.target.value
      callValidate(totalLeaveMinutes, e, index, weekDayIndex, validationHours)
    }
  }
  const callValidate = (
    totalLeaveMinutes: number,
    e: any,
    index: any,
    weekDayIndex: any,
    validationHours: any
  ) => {
    if (totalLeaveMinutes > 0) {
      setForLeavePopup(true)
    } else {
      timechange(e, index, weekDayIndex, validationHours)
    }
  }
  const leavePopHandler = (message: any, data: any) => {
    setForLeavePopup(false)

    if (message == 'ApplyLeave') {
      timechange(data.e, data.projectIndex, data.dayIndex, data.validationHours)
    } else {
      data.e.target.value = 0
      timechange(data.e, data.projectIndex, data.dayIndex, data.validationHours)
    }
  }
  const ClientEmailValidation = (e: any, index: any) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    if (e.target.value && !re.test(String(e.target.value).toLowerCase())) {
      ClientManagerNameValidation[index].ceValidation = true
      setClientManagerNameValidation([...ClientManagerNameValidation])
      toast.warn('Email Format is invalid')
    } else {
      ClientManagerNameValidation[index].ceValidation = false
      setClientManagerNameValidation([...ClientManagerNameValidation])
    }
  }

  const timechangeForRegularHours = (
    e: any,
    projectIndex: any,
    dayIndex: any,
    ValidationHours: any = RegularHoursEntry
  ) => {
    let timeString = e.target.value

    if (timeString.indexOf(':') > -1) {
      var totalMints = MinutesConvertionWithColon(timeString)
    } else if (timeString.indexOf('.') > -1) {
      var totalMints = MinutesConvertionWithDot(timeString)
    } else {
      let regularStart = timeString
      var regularStartingValue: number = regularStart * 60
      var totalMints = regularStartingValue
    }

    if (totalMints <= ValidationHours * 60) {
      timechange(e, projectIndex, dayIndex, ValidationHours)
      // timechange(e, index, 0, 16)
    } else {
      e.target.value = ValidationHours
      e.target.name = 'regular_hours'
      timechange(e, projectIndex, dayIndex, ValidationHours)

      MonthlyStatus[projectIndex][dayIndex]['ott'] = true
      setMonthlyStatus([...MonthlyStatus])
      let remainingMinutes = totalMints - ValidationHours * 60
      let hoursRemaining = Math.floor(remainingMinutes / 60) + ':' + (remainingMinutes % 60)
      e.target.value = hoursRemaining
      e.target.name = 'ot_hours'
      timechange(e, projectIndex, dayIndex, OTHoursEntry)
    }
    e.target.name = 'regular_hours'
  }

  const timechange = (e: any, projectIndex: any, dayIndex: any, ValidationHours: any = 8) => {
    let timeString = e.target.value
    var timeFormat = '0:00'

    if (timeString.length !== 0) {
      if (timeString.split(':').length > 2 || timeString.split('.').length > 2) {
        timeFormat = '00:00'
      } else {
        if (timeString.indexOf(':') > -1 || timeString.indexOf('.') > -1) {
          if (
            parseInt(timeString) >= ValidationHours ||
            timeString.split('').filter((ele: any) => {
              return ele === '.'
            }).length > 1
          ) {
            timeFormat = parseInt(ValidationHours) + ':00'
          } else if (timeString.indexOf('.') > -1 && timeString.indexOf(':') > -1) {
            timeFormat = '00:00'
          } else if (timeString.indexOf('.') > -1) {
            if (timeString.indexOf('.') !== 0) {
              if (parseInt(timeString) <= ValidationHours) {
                let [int, dec] = timeString.split('.')
                var mins: any = (dec * 60) / Math.pow(10, dec.length)
                mins = Math.round(mins)
                if (mins <= 9) {
                  mins = '0' + parseInt(mins)
                }
                timeFormat =
                  parseInt(int) +
                  ':' +
                  (parseInt(timeString) == ValidationHours ? '00' : mins ? mins : '00')
              }
            } else {
              let [int, dec] = timeString.split('.')
              int = '0'
              var mins: any = (dec * 60) / Math.pow(10, dec.length)
              mins = Math.round(mins)
              if (mins <= 9) {
                mins = '0' + parseInt(mins)
              }
              timeFormat =
                parseInt(int) +
                ':' +
                (parseInt(timeString) == ValidationHours ? '00' : mins ? mins : '00')
            }
          } else if (timeString.indexOf(':') > -1) {
            let [int, dec] = timeString.split(':')
            var mins: any = parseInt(dec.length) == 2 ? dec : '00'

            mins = parseInt(dec) >= 60 ? 59 : dec
            if (mins <= 9) {
              mins = '0' + parseInt(mins)
            }
            int = int.length !== 0 ? int : '0'
            timeFormat =
              parseInt(int) +
              ':' +
              (parseInt(timeString) == ValidationHours ? '00' : mins ? mins : '00')
          } else {
            timeFormat = parseInt(timeString) + ':00'
          }
        } else {
          if (timeString.indexOf('.') == -1 && timeString.indexOf(':') == -1) {
            if (parseInt(timeString) <= ValidationHours) {
              timeFormat = parseInt(timeString) + ':00'
            } else {
              timeFormat = parseInt(ValidationHours) + ':00'
            }
          }
        }
      }
    } else if (timeString.length == 0) {
      timeFormat = '0:00'
    } else {
      timeFormat = '0.00'
    }
    // monthDayDataEntry[dayIndex].project_wise_data[projectIndex][e.target.getAttribute('name')] =
    //   timeFormat
    monthDayDataEntry[projectIndex].timesheet_data[dayIndex][e.target.getAttribute('name')] =
      timeFormat
    // if (weekDayDataEntry[projectIndex].timesheet_data[dayIndex]) {
    // if (weekDayDataEntry[projectIndex] && timeFormat == '0:00') {
    //   showOtLeaveHolidayHandler(projectIndex, weekDayName, dayIndex)
    //   setOtDisable(true)
    //   weekDayStatus[projectIndex].otdisable = true
    //   weekDayStatus[projectIndex].monday_ott = false
    // } else {
    //   weekDayStatus[projectIndex].otdisable = false
    //   setOtDisable(false)
    // }
    // }
    if (
      e.target.getAttribute('name') == 'absent_hours' ||
      e.target.getAttribute('name') == 'absent-minutes'
    ) {
      let absentHours: any =
        monthDayDataEntry[projectIndex].timesheet_data[dayIndex].absent_hours.split(':')

      var totalMinutes = absentHours[0] * 60 + parseInt(absentHours[1])
      if (totalMinutes > 0) {
        monthDayDataEntry[projectIndex].timesheet_data[dayIndex].absent_type = 1
        MonthlyStatus[projectIndex][dayIndex]['holidayt'] = true
        setMonthlyStatus([...MonthlyStatus])
        SuccessToast('Leave Applied')
      } else {
        monthDayDataEntry[projectIndex].timesheet_data[dayIndex].absent_type = null
        MonthlyStatus[projectIndex][dayIndex]['holidayt'] = false
        setMonthlyStatus([...MonthlyStatus])
        WarnToast('Leave Not Applied')
      }
    }

    if (e.target.getAttribute('name') === 'regular_hours') {
      let regularHours: any =
        monthDayDataEntry[projectIndex].timesheet_data[dayIndex].regular_hours.split(':')
      var totalMinutes = regularHours[0] * 60 + parseInt(regularHours[1])
      if (totalMinutes > 0) {
        MonthlyotfieldsdisabledValidation[projectIndex][dayIndex] = false
      } else {
        MonthlyotfieldsdisabledValidation[projectIndex][dayIndex] = true
        showOtLeaveHolidayHandlerForOtbutton(projectIndex, 'ott', dayIndex)
      }
      setMonthlyotfieldsdisabledValidation([...MonthlyotfieldsdisabledValidation])
    }

    enableDisableSubmitButton(monthDayDataEntry)
    sumOfTotalHours(monthDayDataEntry)
    setmonthDayDataEntry([...monthDayDataEntry])
  }
  const enableDisableSubmitButton = (weekDayDataEntry: any) => {
    let ForAllProjects: any = []

    weekDayDataEntry.map((singleProject: any, Projectindex: any) => {
      let ForSingleProject: any = []
      singleProject.timesheet_data.map((singleDay: any, index: any) => {
        if (singleDay.status == '' || singleDay.status == 'REJECTED') {
          if (singleDay.absent_hours.toString().indexOf(':') > -1) {
            var AbsentMinutes = singleDay.absent_hours.toString()
          } else {
            AbsentMinutes = '0:0'
          }
          if (singleDay.regular_hours.toString().indexOf(':') > -1) {
            var RegularMinutes = singleDay.regular_hours.toString()
          } else {
            RegularMinutes = '0:0'
          }
          if (singleDay.ot_hours.toString().indexOf(':') > -1) {
            var OtMinutes = singleDay.ot_hours.toString()
          } else {
            OtMinutes = '0:0'
          }
          let ValidationAbsentHours: any = AbsentMinutes.split(':')
          let ValidationAbsentMinutes =
            ValidationAbsentHours[0] * 60 + parseInt(ValidationAbsentHours[1])
          let ValidationRegularHours: any = RegularMinutes.split(':')
          let ValidationRegularMinutes =
            ValidationRegularHours[0] * 60 + parseInt(ValidationRegularHours[1])
          let ValidationOtHours: any = OtMinutes.split(':')
          let ValidationOtMinutes = ValidationOtHours[0] * 60 + parseInt(ValidationOtHours[1])
          if (
            ValidationAbsentMinutes > 0 ||
            ValidationRegularMinutes > 0 ||
            ValidationOtMinutes > 0 ||
            singleDay.absent_type == 2
          ) {
            ForSingleProject.splice(0, 1)
          } else {
            ForSingleProject.push(false)
          }
        }
      })

      ForAllProjects.push(ForSingleProject)
    })
    setMonthlySubmitButtonEnableDisableValidation([])
    let submitButtonVlidation: any = []
    ForAllProjects.map((project: any, index: any) => {
      if (weekDayDataEntry[index].timesheet_data.find((item: any) => item.status == 'SAVED')) {
        submitButtonVlidation.push(false)
      } else {
        if (project.length == MonthlysubmitButtonEnableDisable[index].length) {
          submitButtonVlidation.push(true)
        } else {
          submitButtonVlidation.push(false)
        }
      }
    })
    setMonthlySubmitButtonEnableDisableValidation([...submitButtonVlidation])
  }

  const sumOfTotalHours = (weekDayDataEntry: any) => {
    sumofAllProj.length = 0
    sumofAllProjLeave.length = 0
    weekDayDataEntry.map((singleProject: any, i: any) => {
      var regularHours = 0
      var regularMinutes = 0
      var LeaveHours = 0
      var LeaveMinutes = 0

      for (let i = 0; i < singleProject.timesheet_data.length; i++) {
        if (
          singleProject.timesheet_data[i].regular_hours ||
          singleProject.timesheet_data[i].absent_hours
        ) {
          var rHours = singleProject.timesheet_data[i].regular_hours
            ? singleProject.timesheet_data[i].regular_hours.split(':')[0] * 60
            : 0
          var otHours = singleProject.timesheet_data[i].ot_hours
            ? singleProject.timesheet_data[i].ot_hours.split(':')[0] * 60
            : 0
          regularHours += rHours + otHours
          var rMinutes = singleProject.timesheet_data[i].regular_hours
            ? parseInt(singleProject.timesheet_data[i].regular_hours.split(':')[1])
            : 0
          var otMinutes = singleProject.timesheet_data[i].ot_hours
            ? parseInt(singleProject.timesheet_data[i].ot_hours.split(':')[1])
            : 0

          regularHours += rMinutes + otMinutes

          if (singleProject.timesheet_data[i].absent_hours) {
            LeaveHours += singleProject.timesheet_data[i].absent_hours
              ? singleProject.timesheet_data[i].absent_hours.split(':')[0] * 60
              : 0
            LeaveMinutes += singleProject.timesheet_data[i].absent_hours
              ? parseInt(singleProject.timesheet_data[i].absent_hours.split(':')[1])
              : 0
          }
        }
      }

      let regularHoursMints = Math.floor(regularHours / 60)
      regularMinutes = regularHours % 60
      let LeaveHoursMints = Math.floor((LeaveHours + LeaveMinutes) / 60)
      LeaveMinutes = (LeaveHours + LeaveMinutes) % 60

      const hoursAndMinutes = `${regularHoursMints}:${
        regularMinutes <= 9 ? '0' + regularMinutes : regularMinutes
      }`
      const LeaveHoursAndMinutes = `${LeaveHoursMints}:${
        LeaveMinutes <= 9 ? '0' + LeaveMinutes : LeaveMinutes
      }`
      sumofAllProj.push(hoursAndMinutes)
      sumofAllProjLeave.push(LeaveHoursAndMinutes)
      setSumofAllProj([...sumofAllProj])
      setSumofAllProjLeave([...sumofAllProjLeave])
    })
    var HeaderHours = 0
    var HeaderMinutes = 0

    sumofAllProj.map((each: any, i: any) => {
      if (each) {
        HeaderHours += each.split(':')[0] * 60
        HeaderMinutes += parseInt(each.split(':')[1])
      }
    })

    let HeaderHoursMints = Math.floor((HeaderHours + HeaderMinutes) / 60)
    HeaderMinutes = HeaderMinutes % 60
    const TotalHeaderHoursAndMintes = `${
      HeaderHoursMints <= 9 ? '0' + HeaderHoursMints : HeaderHoursMints
    }:${HeaderMinutes <= 9 ? '0' + HeaderMinutes : HeaderMinutes}`
    setWeekHourDataSubmit({
      ...weekHourDataSubmit,
      headerTotalHours: TotalHeaderHoursAndMintes,
    })
  }

  const nextMonth = async () => {
    setmonthYear('')
    setMonthName('')
    setYearName('')
    var lastDayOfNextMonth = moment(seletedDate.add(1, 'M')).endOf('month')

    setseletedDate(lastDayOfNextMonth)
    const monthNo = moment(seletedDate).month()
    const nextMonth = seletedDate.format('MMMM')
    const nextMonth1 = seletedDate.format('M')
    const nextYear = seletedDate.format('YYYY')
    const next: any = `${nextMonth} ${nextYear}`
    setmonthYear(next)
    setMonthName(nextMonth)
    setYearName(nextYear)
    setMonthNumber(monthNo)
    monthViewNextAndPrev(monthNo + 1, nextYear)
  }
  const prevMonth = async () => {
    setmonthYear('')

    setMonthName('')
    setYearName('')
    var lastDayOfPreviousMonth = moment(seletedDate.add(-1, 'M')).endOf('month')
    setseletedDate(lastDayOfPreviousMonth)
    const monthNo = moment(seletedDate).month()
    const nextMonth = seletedDate.format('MMMM')
    const nextMonth1 = seletedDate.format('M')
    const nextYear = seletedDate.format('YYYY')
    const next: any = `${nextMonth} ${nextYear}`
    setmonthYear(next)
    setMonthName(nextMonth)
    setYearName(nextYear)
    setMonthNumber(monthNo)
    monthViewNextAndPrev(monthNo + 1, nextYear)
  }
  const singleMonthSelection = async (date: any) => {
    var lastDayOfPreviousMonth = moment(moment(date)).endOf('month')
    setseletedDate(lastDayOfPreviousMonth)
    const nextMonth = moment(date).format('MMMM')
    const monthNo = moment(date).month()
    const nextYear = moment(date).format('YYYY')
    const next: any = `${nextMonth} ${nextYear}`
    setmonthYear(next)
    setMonthName(nextMonth)
    setYearName(nextYear)
    monthViewNextAndPrev(monthNo + 1, nextYear)
  }
  const userName = (full_name: any) => {
    if (full_name === null) return ''
    else {
      let str = ''
      full_name?.split(' ').forEach((ele: any, i: any) => {
        str += (i == 0 ? '' : ' ') + ele.charAt(0).toUpperCase() + ele.slice(1)
      })
      return str
    }
  }
  const handleCountries = async (country: any) => {
    if (country && country.length >= 2) {
      const response: any = await Apiservices.getcountriesbyname({
        country_name: country,
      })
      if (response.data.data) {
        setCountry(response.data.data ? response.data.data : '')
      } else {
        setCountry([])
      }
    }
  }

  const selectedCountries = async (selected_country_name: any, projectIndex: any) => {
    let work2: any = []
    if (selected_country_name.length > 0) {
      StateFielddisabled[projectIndex] = false
    } else {
      StateFielddisabled[projectIndex] = true
      let candidate = [
        {
          name: states && states[0] && states[0]?.name ? '' : '',
        },
      ]
      states[projectIndex] = candidate
      // weekDayDataEntry[projectIndex]['work_state'] = ''
      monthDayDataEntry[projectIndex]['work_state'] = ''
    }
    WorkLocationValidation[projectIndex].countryValidation = false
    setStateFielddisabled([...StateFielddisabled])
    setStates([...states])
    work2[projectIndex] = selected_country_name
    setCountries(work2)
    monthDayDataEntry[projectIndex]['work_country'] = selected_country_name[0]?.name
    setweekDayDataEntry([...monthDayDataEntry])
    setUseStateCountryId(selected_country_name[0]?.id)
    SelectedCountry[projectIndex] = selected_country_name[0]?.id
    setSelectedCountry([...SelectedCountry])
    const response: any = await Apiservices.getstatebyname({
      country_id: selected_country_name[0]?.id,
    })

    if (response.data.data) {
      WorkStatesBasedOnCountry[projectIndex] = response.data.data
      setWorkStatesBasedOnCountry([...WorkStatesBasedOnCountry])
      setState([...WorkStatesBasedOnCountry])
    }
  }

  const handleStates = async (state: any, projectIndex: any, blur_event: any) => {
    if (blur_event === 'Blur') {
      let workStateSetting: any = []
      let data1 = [
        {
          name: monthDayDataEntry[projectIndex].work_state
            ? monthDayDataEntry[projectIndex].work_state
            : null,
        },
      ]
      workStateSetting[projectIndex] = data1
      setStates(workStateSetting)
    } else {
      if (SelectedCountry[projectIndex]) {
        // const response: any = await Apiservices.getstatebyname({country_id: useStateCountryId})
        const response: any = await Apiservices.getstatebyname({
          country_id: SelectedCountry[projectIndex],
        })

        if (response?.data?.data) {
          WorkStatesBasedOnCountry[projectIndex] = response.data.data
          setWorkStatesBasedOnCountry([...WorkStatesBasedOnCountry])
          setState([...WorkStatesBasedOnCountry])
          // setState(response.data.data ? response.data.data : '')
        }
      }
    }
  }
  const selectedStates = async (selected_state_name: any, projectIndex: any) => {
    let workState: any = []
    workState[projectIndex] = selected_state_name
    setStates(workState)
    monthDayDataEntry[projectIndex]['work_state'] = selected_state_name[0]?.name
    setweekDayDataEntry([...monthDayDataEntry])
    WorkLocationValidation[projectIndex].stateValidation = false
  }

  const user = (candidate: any) => {
    if (candidate === null) return ''
    else {
      let str = ''

      candidate.split(' ').forEach((ele: any, i: any) => {
        str += (i == 0 ? '' : ' ') + ele.charAt(0).toUpperCase() + ele.slice(1)
      })

      return str
    }
  }
  const [DocIndex, setDocIndex] = useState('')
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const HandleDocPop = (ind: any) => {
    setDocIndex(ind)
    setIsMenuOpen(true)
  }
  return (
    <>
      {forLeavePopup && (
        <LeavePopup
          leavePopHandler={leavePopHandler}
          text={'Do you want to apply Leave ?'}
          leaveOnBlurData={leaveOnBlurData}
        />
      )}
      {forLeaveAndHoldiayPopup && (
        <LeaveAndHolidayPopup
          holidayData={holidayData}
          leaveHandler={leaveHandler}
          text={'Do you want to apply holiday ?'}
        />
      )}
      {pageTitle?.names == 'create' ? (
        // <PageTitle breadcrumbs={[]}>
        //   {intl.formatMessage({id: 'MENU.ADDTIMESHEET'})}
        //   {`${pageTitle?.fullName}`}
        // </PageTitle>
        <PageTitle breadcrumbs={[]}>{`${userName(pageTitle?.fullName)}`}</PageTitle>
      ) : location.state ? (
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.UPDATETIMESHEET'})}</PageTitle>
      ) : (
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.ADDTIMESHEET'})}</PageTitle>
      )}
      <BackDrop showBackDrop={showBackDrop} />
      <Toolbar1 isLogin={isLogin} users={pageTitle?.user_list} />
      {ClientManagerNameValidation?.length > 0 ? (
        <div>
          {month_view_dates &&
            month_view_dates.length > 0 &&
            [month_view_dates[0]?.timesheet_data].map((list1: any, index: any) => {
              // Array.isArray(temp)
              //   ? temp.map((list1: any) => {
              return (
                <React.Fragment key={index}>
                  {/* <span> {list1[0].project_name}</span> */}
                  <div className='card card-custom card-flush h-100'>
                    <div className='card-body p-0'>
                      <Accordion
                      // defaultActiveKey={employeesProjectList?.length === 1 ? '0' : null}
                      // flush
                      >
                        <div className='w-100 p-5'>
                          <div className='row  gy-2  disabledColorForApprover'>
                            <div className='col-xs-12 col-md'>
                              <div className='row gy-2'>
                                <div className='col-12 col-md-3 '>
                                  <label className='form-label text-gray-600 fs-7'>
                                    Project Name
                                  </label>
                                  <input
                                    type='text'
                                    className='form-control form-control-sm'
                                    // defaultValue={list.project_name}
                                    defaultValue={
                                      month_view_dates[0]?.direct_customer_engagement
                                        ? month_view_dates[0]?.end_customer_name
                                        : month_view_dates[0]?.project_vendors &&
                                          month_view_dates[0]?.project_vendors[0] &&
                                          month_view_dates[0]?.project_vendors[0].client_name &&
                                          month_view_dates[0]?.project_vendors[0].client_name
                                    }
                                    disabled
                                    // {...methods.register('project_name')}
                                    name='project_name'
                                  />
                                </div>
                                <div className='col-12 col-md-3 '>
                                  <label className='form-label text-gray-600 fs-7'>
                                    Start Date <span className='fs-9'>(MM/DD/YYYY)</span>
                                  </label>
                                  <input
                                    disabled={true}
                                    type='text'
                                    className='form-control form-control-sm'
                                    // defaultValue={moment(list?.start_date).format('MM/DD/YYYY')}
                                    defaultValue={
                                      month_view_dates[0]?.joining_date
                                        ? moment(month_view_dates[0]?.joining_date).format(
                                            'MM/DD/YYYY'
                                          )
                                        : month_view_dates[0]?.start_date
                                        ? moment(month_view_dates[0]?.start_date).format(
                                            'MM/DD/YYYY'
                                          )
                                        : '-'
                                    }
                                    name='project_start_date'
                                    // onChange={(e) => {
                                    //   ClientDetails(e, index)
                                    // }}
                                  />
                                </div>
                                <div className='col-12 col-md-3'>
                                  <label className='form-label text-gray-600 fs-7'>
                                    Client Manager Name *
                                  </label>
                                  <input
                                    type='text'
                                    // className='form-control form-control-sm'
                                    className={` ${
                                      ClientManagerNameValidation &&
                                      ClientManagerNameValidation[0].cmValidation
                                        ? `form-control form-control-sm  is-invalid`
                                        : `form-control form-control-sm text-capitalize `
                                    }`}
                                    // disabled={
                                    //   weekDayDataEntry[index]?.ts_status === 'APPROVED' ? true : false
                                    // }
                                    defaultValue={
                                      month_view_dates[0]?.ts_client_manager_name
                                        ? month_view_dates[0].ts_client_manager_name
                                        : month_view_dates[0]?.client_manager_name
                                        ? month_view_dates[0]?.client_manager_name
                                        : ''
                                    }
                                    name='client_manager_name'
                                    onChange={(e) => {
                                      ClientDetails(e, index)
                                    }}
                                  />
                                  {ClientManagerNameValidation[0].cmValidation && (
                                    <p className='error text-danger mb-0 mt-2'>
                                      Client Manager is required
                                    </p>
                                  )}
                                </div>
                                <div className='col-12 col-md-3 '>
                                  <label className='form-label text-gray-600 fs-7'>
                                    Client Manager Email
                                  </label>
                                  <input
                                    // disabled={
                                    //   weekDayDataEntry[index]?.ts_status === 'APPROVED' ? true : false
                                    // }
                                    type='email'
                                    // className='form-control form-control-sm'
                                    className={` ${
                                      ClientManagerNameValidation[0].ceValidation
                                        ? `form-control form-control-sm  is-invalid`
                                        : `form-control form-control-sm  `
                                    }`}
                                    defaultValue={
                                      month_view_dates[0]?.ts_client_manager_email
                                        ? month_view_dates[0].ts_client_manager_email
                                        : month_view_dates[0]?.client_manager_email
                                        ? month_view_dates[0]?.client_manager_email
                                        : ''
                                    }
                                    onBlur={(e) => ClientEmailValidation(e, index)}
                                    name='client_manager_email'
                                    onChange={(e) => {
                                      ClientDetails(e, index)
                                    }}
                                  />
                                </div>
                                <div className='col-xs-12 col-md-3 '>
                                  <label className='form-label text-gray-600 fs-7'>
                                    Work Country *{' '}
                                  </label>
                                  <Typeahead
                                    id='basic-typeahead-single'
                                    onChange={(e) => selectedCountries(e, 0)}
                                    onInputChange={(e) => handleCountries(e)}
                                    options={country}
                                    placeholder='Search Country '
                                    selected={countries[0]}
                                    labelKey={(country: any) => user(country.name)}
                                    // inputProps={{required: true}}
                                    inputProps={{
                                      className: `${
                                        WorkLocationValidation[0].countryValidation
                                          ? 'form-control form-control-sm  is-invalid'
                                          : 'form-control form-control-sm '
                                      }`,
                                    }}
                                  >
                                    {({onClear, selected}) => (
                                      <div className='rbt-aux'>
                                        {!!selected.length && (
                                          // <ClearButton disabled={AllFieldsToDisabled} onClick={onClear} />
                                          <ClearButton onClick={onClear} />
                                        )}
                                      </div>
                                    )}
                                  </Typeahead>
                                  {WorkLocationValidation[0].countryValidation && (
                                    <p className='error text-danger mb-0 mt-2'>
                                      Work Country is required
                                    </p>
                                  )}
                                </div>
                                <div className='col-xs-12 col-md-3'>
                                  <label className='form-label text-gray-600 fs-7'>
                                    Work State *{' '}
                                  </label>
                                  <Typeahead
                                    id='basic-typeahead-single'
                                    onChange={(e) => selectedStates(e, 0)}
                                    onInputChange={(e) => handleStates(e, 0, 'Not')}
                                    onBlur={(e) => handleStates(e, 0, 'Blur')}
                                    options={state[0]}
                                    disabled={StateFielddisabled[0]}
                                    placeholder='Search State'
                                    selected={states[0]}
                                    labelKey={(state: any) => user(state.name)}
                                    // inputProps={{required: true}}
                                    inputProps={{
                                      className: `${
                                        WorkLocationValidation[0].stateValidation
                                          ? 'form-control form-control-sm  is-invalid'
                                          : 'form-control form-control-sm'
                                      }`,
                                    }}
                                  >
                                    {({onClear, selected}) => (
                                      <div className='rbt-aux'>
                                        {!!selected.length && (
                                          // <ClearButton disabled={AllFieldsToDisabled} onClick={onClear} />
                                          <ClearButton onClick={onClear} />
                                        )}
                                      </div>
                                    )}
                                  </Typeahead>
                                  {WorkLocationValidation[0].stateValidation && (
                                    <p className='error text-danger mb-0 mt-2'>
                                      Work State is required
                                    </p>
                                  )}
                                </div>
                                <div className='col-xs-12 col-md-3 '>
                                  <label className='form-label text-gray-600 fs-7'>
                                    Work City *
                                  </label>
                                  <input
                                    type='text'
                                    placeholder='Enter City Name'
                                    // className='form-control fs-6 text-capitalize'
                                    className={` ${
                                      WorkLocationValidation[0].cityValidation
                                        ? `form-control form-control-sm  is-invalid`
                                        : `form-control form-control-sm text-capitalize `
                                    }`}
                                    value={
                                      monthDayDataEntry[index]?.work_city == null
                                        ? ''
                                        : monthDayDataEntry[index]?.work_city
                                        ? monthDayDataEntry[index]?.work_city
                                        : ''
                                    }
                                    onChange={(e) => {
                                      ClientDetails(e, index)
                                    }}
                                    minLength={3}
                                    name='work_city'
                                  ></input>
                                  {WorkLocationValidation[0].cityValidation && (
                                    <p className='error text-danger mb-0 mt-2'>
                                      Work City is required
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* <div className='col-xs-12 col-auto text-end '>
                      {weekDayDataEntry[index].ts_status === 'APPROVED' ? (
                        <span
                          className={'badge badge-light-success mt-11 p-2 px-3 fw-semibold fs-6'}
                        >
                          Approved
                        </span>
                      ) : (
                        ''
                      )}
                      {weekDayDataEntry[index].ts_status === 'REJECTED' ? (
                        <span
                          className={'badge badge-light-danger mt-11 p-2 px-3 fw-semibold fs-6'}
                        >
                          Rejected
                        </span>
                      ) : (
                        ''
                      )}
                      {weekDayDataEntry[index].ts_status === 'SUBMITTED' ? (
                        <span
                          className={'badge badge-light-warning mt-11 p-2 px-3 fw-semibold fs-6'}
                        >
                          Waiting for approval
                        </span>
                      ) : (
                        ''
                      )}
                      {weekDayDataEntry[index].ts_status == null ? (
                        <span
                          className={'badge badge-light-primary mt-11 p-2 px-3 fw-semibold fs-6'}
                        >
                          Yet to submit
                        </span>
                      ) : (
                        ''
                      )}
                      {weekDayDataEntry[index].ts_status == 'SAVED' ? (
                        <span
                          className={'badge badge-light-primary mt-11 p-2 px-3 fw-semibold fs-6'}
                        >
                          Draft
                        </span>
                      ) : (
                        ''
                      )}
                    </div> */}
                            <></>
                            <div className='col-xs-12 col-auto'>
                              <ContextAwareToggle eventKey={`${index}`}>
                                Click me!
                              </ContextAwareToggle>
                            </div>
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </div>
                  <div className='monthTextFieldHeight mt-4'>
                    <div className='card border border-gray-200 '>
                      {/* <div className='card shadow-sm '>
                        <div className='monthName'>
                          <div className='text-center bg-light-primary text-primary fw-semibold fs-5 calMonth'>
                            <span>
                              {moment(list1[15].date).format('MMMM') +
                                ' - ' +
                                moment(list1[15].date).format('YYYY')}
                              <br />
                            </span>
                          </div>
                        </div>
                      </div> */}
                      <div className='calMonthView'>
                        <table className='table table-row-bordered border border-gray-300 rounded w-100 g-0 m-0'>
                          <thead className='text-center fw-semibold fs-8 text-gray-700 g-1'>
                            <tr>
                              <th className='bg-white p-1'>MON</th>
                              <th className='bg-white p-1'>TUE</th>
                              <th className='bg-white p-1'>WED</th>
                              <th className='bg-white p-1'>THU</th>
                              <th className='bg-white p-1'>FRI</th>
                              <th className='bg-white p-1'>SAT</th>
                              <th className='bg-white p-1'>SUN</th>
                              <th className='bg-white p-1'></th>
                            </tr>
                          </thead>
                          <tbody className='text-center'>
                            {list1 &&
                              list1.length > 0 &&
                              list1.map((temp: any, index: any) => {
                                return (
                                  <React.Fragment key={index}>
                                    {/* <h1>{index % 7}</h1> */}
                                    {index % 7 == 0 ? (
                                      <tr key={index}>
                                        {list1.length > 0 &&
                                          MonthlyStatus[0]?.length > 0 &&
                                          list1
                                            .slice(index, index + 7)
                                            .map((temp: any, indexTwo: any) => {
                                              const originalIndex = index + indexTwo
                                              const date = new Date(temp.date)
                                              const daysOfWeek = [
                                                'SUN',
                                                'MON',
                                                'TUE',
                                                'WED',
                                                'THU',
                                                'FRI',
                                                'SAT',
                                              ]
                                              let check_Date = moment(
                                                temp.date,
                                                'YYYY-MM-DD'
                                              ).format('ddd')
                                              const daysOfWeekOT = [
                                                'sunday_ott',
                                                'monday_ott',
                                                'tuesday_ott',
                                                'wednesday_ott',
                                                'thursday_ott',
                                                'friday_ott',
                                                'saturday_ott',
                                              ]
                                              return (
                                                <>
                                                  <td key={indexTwo}>
                                                    {moment(temp.date).format('M') ==
                                                    moment(list1[15].date).format('M') ? (
                                                      <div className='d-flex flex-column'>
                                                        <div className='d-flex align-items-center flex-nowrap p-1 border-bottom border-gray-300 bg-opacity-5 bg-info justify-content-center gap-1 min-h-25px'>
                                                          <label className='form-label mb-0 fs-9 fw-semibold py-0 text-info opacity-60'>
                                                            {/* {daysOfWeek[date.getDay()]}:{' '} */}
                                                            {check_Date.toUpperCase()}:{' '}
                                                            {moment(temp.date, 'YYYY-MM-DD').format(
                                                              'DD'
                                                            )}
                                                          </label>
                                                          {MonthlyStatus[0][originalIndex]
                                                            ?.holidayt ? (
                                                            <img
                                                              src={PlaneIcon}
                                                              className='timeEntryIcons yellowBg ms-2'
                                                            />
                                                          ) : (
                                                            ''
                                                          )}
                                                          {MonthlyStatus[0][originalIndex]
                                                            ?.leavet ? (
                                                            <img
                                                              src={UmbrellaIcon}
                                                              className='timeEntryIcons pinkBg ms-2'
                                                            />
                                                          ) : (
                                                            ''
                                                          )}
                                                          <div className='invisibleBlock d-none'></div>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                          <div className='d-flex p-2 align-items-center gap-2'>
                                                            <div className='input-group flex-nowrap'>
                                                              <input
                                                                type='text'
                                                                className={clsx(
                                                                  'form-control  px-1 fs-6 text-center',
                                                                  // weekDayStatus[index]?.monday_ott
                                                                  MonthlyStatus[0][originalIndex]
                                                                    ?.ott
                                                                    ? 'formControlMinWidth45 border-end-0'
                                                                    : 'formControlMinWidth90'
                                                                )}
                                                                value={
                                                                  monthDayDataEntry[0]
                                                                    ?.timesheet_data[originalIndex]
                                                                    ?.regular_hours == '0.00'
                                                                    ? ''
                                                                    : monthDayDataEntry[0]
                                                                        ?.timesheet_data[
                                                                        originalIndex
                                                                      ]?.regular_hours
                                                                }
                                                                onBlur={(e) =>
                                                                  timechangeForRegularHours(
                                                                    e,
                                                                    0,
                                                                    originalIndex,
                                                                    RegularHoursEntry
                                                                  )
                                                                }
                                                                name={'regular_hours'}
                                                                tabIndex={10 * index + 1}
                                                                onFocus={(event) =>
                                                                  event.target.select()
                                                                }
                                                                onChange={(e: any) => {
                                                                  // DailyEntry(e, index, 0)
                                                                  DailyEntry(e, 0, originalIndex)
                                                                }}
                                                                placeholder='0:00'
                                                                aria-label='Hours'
                                                                // disabled={
                                                                //   ermState?.consultant_role == 'ERM'
                                                                //     ? true
                                                                //     : getDisableStatusofBenchProject(
                                                                //         list?.is_placement_project,
                                                                //         mon
                                                                //       )
                                                                //     ? // list?.is_placement_project === 2
                                                                //       true
                                                                //     : weekDayDataEntry[index]?.timesheet_data[0]
                                                                //         ?.qb_invoice_id != null
                                                                //     ? true
                                                                //     : projectStartDateDisable &&
                                                                //       projectStartDateDisable[index] &&
                                                                //       projectStartDateDisable[index][0]
                                                                //     ? true
                                                                //     : projectEndDateDisable &&
                                                                //       projectEndDateDisable[index] &&
                                                                //       projectEndDateDisable[index][0]
                                                                //     ? true
                                                                //     : weekDayDataEntry[index]?.timesheet_data[0]
                                                                //         ?.status == 'SUBMITTED'
                                                                //     ? true
                                                                //     : weekDayDataEntry[index]?.timesheet_data[0]
                                                                //         ?.status == 'APPROVED'
                                                                //     ? true
                                                                //     : false
                                                                // }
                                                                disabled={
                                                                  projectStartDateDisable &&
                                                                  projectStartDateDisable[0] &&
                                                                  projectStartDateDisable[0][
                                                                    originalIndex
                                                                  ]
                                                                    ? true
                                                                    : projectEndDateDisable &&
                                                                      projectEndDateDisable[0] &&
                                                                      projectEndDateDisable[0][
                                                                        originalIndex
                                                                      ]
                                                                    ? true
                                                                    : monthDayDataEntry[0]
                                                                        ?.timesheet_data[
                                                                        originalIndex
                                                                      ]?.status == 'SUBMITTED'
                                                                    ? true
                                                                    : monthDayDataEntry[0]
                                                                        ?.timesheet_data[
                                                                        originalIndex
                                                                      ]?.status == 'APPROVED'
                                                                    ? true
                                                                    : false
                                                                }
                                                              />
                                                              {/* {weekDayStatus[index]?.monday_ott && ( */}
                                                              {MonthlyStatus[0][originalIndex]
                                                                ?.ott && (
                                                                <>
                                                                  {}
                                                                  <span
                                                                    // className={clsx(
                                                                    //   'input-group-text  bg-body   px-0 my-1 fs-6 '
                                                                    // )}
                                                                    className={clsx(
                                                                      'input-group-text bg-body px-1 fs-6 ',
                                                                      monthDayDataEntry[0]
                                                                        ?.timesheet_data[
                                                                        originalIndex
                                                                      ]?.status == 'SUBMITTED'
                                                                        ? 'disabledBg'
                                                                        : monthDayDataEntry[0]
                                                                            ?.timesheet_data[
                                                                            originalIndex
                                                                          ]?.status == 'APPROVED'
                                                                        ? 'disabledBg'
                                                                        : ''
                                                                    )}
                                                                  >
                                                                    +
                                                                  </span>
                                                                  <input
                                                                    type='text'
                                                                    className={clsx(
                                                                      'form-control border-start-0 px-1 fs-6 text-center',
                                                                      //   weekDayStatus[index]?.monday_ott
                                                                      MonthlyStatus[0][
                                                                        originalIndex
                                                                      ]?.ott
                                                                        ? 'formControlMinWidth45'
                                                                        : 'formControlMinWidth90'
                                                                    )}
                                                                    value={
                                                                      monthDayDataEntry[0]
                                                                        ?.timesheet_data[
                                                                        originalIndex
                                                                      ]?.ot_hours == 0.0
                                                                        ? ''
                                                                        : monthDayDataEntry[0]
                                                                            ?.timesheet_data[
                                                                            originalIndex
                                                                          ]?.ot_hours
                                                                    }
                                                                    onBlur={(e) =>
                                                                      timechange(
                                                                        e,
                                                                        0,
                                                                        originalIndex,
                                                                        OTHoursEntry
                                                                      )
                                                                    }
                                                                    onFocus={(event) =>
                                                                      event.target.select()
                                                                    }
                                                                    onChange={(e: any) => {
                                                                      DailyEntry(
                                                                        e,
                                                                        0,
                                                                        originalIndex
                                                                      )
                                                                    }}
                                                                    // disabled={
                                                                    //   weekDayDataEntry[index]?.timesheet_data[0]
                                                                    //     ?.qb_invoice_id != null
                                                                    //     ? true
                                                                    //     : weekDayDataEntry[index]
                                                                    //         ?.timesheet_data[0]?.status ==
                                                                    //       'SUBMITTED'
                                                                    //     ? true
                                                                    //     : weekDayDataEntry[index]
                                                                    //         ?.timesheet_data[0]?.status ==
                                                                    //       'APPROVED'
                                                                    //     ? true
                                                                    //     : false
                                                                    // }

                                                                    disabled={
                                                                      monthDayDataEntry[0]
                                                                        ?.timesheet_data[
                                                                        originalIndex
                                                                      ]?.status == 'SUBMITTED'
                                                                        ? true
                                                                        : monthDayDataEntry[0]
                                                                            ?.timesheet_data[
                                                                            originalIndex
                                                                          ]?.status == 'APPROVED'
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    name='ot_hours'
                                                                    placeholder='0:00'
                                                                    aria-label='OT'
                                                                  />
                                                                </>
                                                              )}
                                                            </div>
                                                            <button
                                                              type='button'
                                                              className='btn btn-icon btn-secondary fs-8 w-auto h-auto p-2 btn-active-light-info'
                                                              // onClick={() =>
                                                              //   showOtLeaveHolidayHandler(
                                                              //     index,
                                                              //     'monday_ott',
                                                              //     0
                                                              //   )
                                                              // }
                                                              onClick={() =>
                                                                showOtLeaveHolidayHandler(
                                                                  0,
                                                                  // 'monday_ott',
                                                                  // daysOfWeekOT[date.getDay()],
                                                                  'ott',
                                                                  originalIndex
                                                                )
                                                              }
                                                              // disabled={
                                                              //   ermState?.consultant_role == 'ERM'
                                                              //     ? true
                                                              //     : getDisableStatusofBenchProject(
                                                              //         list?.is_placement_project,
                                                              //         mon
                                                              //       )
                                                              //     ? // list?.is_placement_project === 2
                                                              //       true
                                                              //     : weekDayDataEntry[index]?.timesheet_data[0]
                                                              //         ?.qb_invoice_id != null
                                                              //     ? true
                                                              //     : projectStartDateDisable &&
                                                              //       projectStartDateDisable[index] &&
                                                              //       projectStartDateDisable[index][0]
                                                              //     ? true
                                                              //     : projectEndDateDisable &&
                                                              //       projectEndDateDisable[index] &&
                                                              //       projectEndDateDisable[index][0]
                                                              //     ? true
                                                              //     : weekDayDataEntry[index] &&
                                                              //       weekDayDataEntry[index].timesheet_data[0] &&
                                                              //       weekDayDataEntry[index].timesheet_data[0]
                                                              //         .status == 'SUBMITTED'
                                                              //     ? true
                                                              //     : weekDayDataEntry[index] &&
                                                              //       weekDayDataEntry[index].timesheet_data[0] &&
                                                              //       weekDayDataEntry[index].timesheet_data[0]
                                                              //         .status == 'APPROVED'
                                                              //     ? true
                                                              //     : otfieldsdisabledValidation[index][0]
                                                              //     ? true
                                                              //     : false
                                                              // }
                                                              // disabled={
                                                              //   monthDayDataEntry[0]?.timesheet_data[
                                                              //     originalIndex
                                                              //   ]?.qb_invoice_id != null
                                                              //     ? true
                                                              //     : monthDayDataEntry[0].timesheet_data[
                                                              //         originalIndex
                                                              //       ].status == 'SUBMITTED'
                                                              //     ? true
                                                              //     : monthDayDataEntry[0].timesheet_data[
                                                              //         originalIndex
                                                              //       ].status == 'APPROVED'
                                                              //     ? true
                                                              //     : MonthlyotfieldsdisabledValidation[0][
                                                              //         originalIndex
                                                              //       ]
                                                              //     ? true
                                                              //     : false
                                                              // }
                                                              disabled={
                                                                projectStartDateDisable &&
                                                                projectStartDateDisable[0] &&
                                                                projectStartDateDisable[0][
                                                                  originalIndex
                                                                ]
                                                                  ? true
                                                                  : projectEndDateDisable &&
                                                                    projectEndDateDisable[0] &&
                                                                    projectEndDateDisable[0][
                                                                      originalIndex
                                                                    ]
                                                                  ? true
                                                                  : monthDayDataEntry[0] &&
                                                                    monthDayDataEntry[0]
                                                                      .timesheet_data[
                                                                      originalIndex
                                                                    ] &&
                                                                    monthDayDataEntry[0]
                                                                      .timesheet_data[originalIndex]
                                                                      .status == 'SUBMITTED'
                                                                  ? true
                                                                  : monthDayDataEntry[0] &&
                                                                    monthDayDataEntry[0]
                                                                      .timesheet_data[
                                                                      originalIndex
                                                                    ] &&
                                                                    monthDayDataEntry[0]
                                                                      .timesheet_data[originalIndex]
                                                                      .status == 'APPROVED'
                                                                  ? true
                                                                  : MonthlyotfieldsdisabledValidation[0][
                                                                      originalIndex
                                                                    ]
                                                                  ? true
                                                                  : false
                                                              }
                                                            >
                                                              OT
                                                            </button>
                                                          </div>
                                                          <div className='d-flex gap-1 bg-primary bg-opacity-10 p-2 align-items-center'>
                                                            <input
                                                              type='text'
                                                              className='form-control form-control-xs text-center  fs-8 w-100 '
                                                              placeholder='Leave'
                                                              name='absent_hours'
                                                              // disabled={
                                                              //   ermState?.consultant_role == 'ERM'
                                                              //     ? true
                                                              //     : getDisableStatusofBenchProject(
                                                              //         list?.is_placement_project,
                                                              //         mon
                                                              //       )
                                                              //     ? // list?.is_placement_project === 2
                                                              //       true
                                                              //     : weekDayDataEntry[index]
                                                              //         ?.timesheet_data[0]?.qb_invoice_id !=
                                                              //       null
                                                              //     ? true
                                                              //     : projectStartDateDisable &&
                                                              //       projectStartDateDisable[index] &&
                                                              //       projectStartDateDisable[index][0]
                                                              //     ? true
                                                              //     : projectEndDateDisable &&
                                                              //       projectEndDateDisable[index] &&
                                                              //       projectEndDateDisable[index][0]
                                                              //     ? true
                                                              //     : weekDayDataEntry[index]
                                                              //         ?.timesheet_data[0]?.status ==
                                                              //       'SUBMITTED'
                                                              //     ? true
                                                              //     : weekDayDataEntry[index]
                                                              //         ?.timesheet_data[0]?.status ==
                                                              //       'APPROVED'
                                                              //     ? true
                                                              //     : weekDayStatus[index]?.monday_leavet
                                                              //     ? true
                                                              //     : false
                                                              // }
                                                              disabled={
                                                                projectStartDateDisable &&
                                                                projectStartDateDisable[0] &&
                                                                projectStartDateDisable[0][
                                                                  originalIndex
                                                                ]
                                                                  ? true
                                                                  : projectEndDateDisable &&
                                                                    projectEndDateDisable[0] &&
                                                                    projectEndDateDisable[0][
                                                                      originalIndex
                                                                    ]
                                                                  ? true
                                                                  : monthDayDataEntry[0]
                                                                      ?.timesheet_data[
                                                                      originalIndex
                                                                    ]?.status == 'SUBMITTED'
                                                                  ? true
                                                                  : monthDayDataEntry[0]
                                                                      ?.timesheet_data[
                                                                      originalIndex
                                                                    ]?.status == 'APPROVED'
                                                                  ? true
                                                                  : MonthlyStatus[0][originalIndex]
                                                                      ?.leavet
                                                                  ? true
                                                                  : false
                                                              }
                                                              // value={
                                                              //   weekDayDataEntry[index]?.timesheet_data[0]
                                                              //     ?.absent_hours == '0.00'
                                                              //     ? ''
                                                              //     : weekDayDataEntry[index]
                                                              //         ?.timesheet_data[0]?.absent_hours
                                                              // }
                                                              value={
                                                                monthDayDataEntry[0]
                                                                  ?.timesheet_data[originalIndex]
                                                                  ?.absent_hours == '0.00'
                                                                  ? ''
                                                                  : monthDayDataEntry[0]
                                                                      ?.timesheet_data[
                                                                      originalIndex
                                                                    ]?.absent_hours
                                                              }
                                                              onBlur={
                                                                (e) =>
                                                                  leaveOnBlur(
                                                                    e,
                                                                    0,
                                                                    originalIndex,
                                                                    LeaveHoursEntry
                                                                  )
                                                                //  timechange(e, index, 0, 24)
                                                              }
                                                              // onFocus={(e: any) => {
                                                              //
                                                              // }}
                                                              // ref={searchInput}
                                                              onChange={(e: any) => {
                                                                // DailyEntry(e, index, 0)
                                                                DailyEntry(e, 0, originalIndex)
                                                              }}
                                                            />
                                                            <Tooltip text='Mark as holiday'>
                                                              <button
                                                                className='btn icon-btn p-0 d-flex'
                                                                // disabled={
                                                                //   monthDayDataEntry[0]
                                                                //     ?.timesheet_data[originalIndex]
                                                                //     ?.status == 'SUBMITTED'
                                                                //     ? true
                                                                //     : monthDayDataEntry[0]
                                                                //         ?.timesheet_data[
                                                                //         originalIndex
                                                                //       ]?.status == 'APPROVED'
                                                                //     ? true
                                                                //     : MonthlyStatus[0][
                                                                //         originalIndex
                                                                //       ]?.holidayt
                                                                //     ? true
                                                                //     : false
                                                                // }

                                                                disabled={
                                                                  projectStartDateDisable &&
                                                                  projectStartDateDisable[0] &&
                                                                  projectStartDateDisable[0][
                                                                    originalIndex
                                                                  ]
                                                                    ? true
                                                                    : projectEndDateDisable &&
                                                                      projectEndDateDisable[0] &&
                                                                      projectEndDateDisable[0][
                                                                        originalIndex
                                                                      ]
                                                                    ? true
                                                                    : monthDayDataEntry[0]
                                                                        ?.timesheet_data[
                                                                        originalIndex
                                                                      ]?.status == 'SUBMITTED'
                                                                    ? true
                                                                    : monthDayDataEntry[0]
                                                                        ?.timesheet_data[
                                                                        originalIndex
                                                                      ]?.status == 'APPROVED'
                                                                    ? true
                                                                    : MonthlyStatus[0][
                                                                        originalIndex
                                                                      ]?.holidayt
                                                                    ? true
                                                                    : false
                                                                }
                                                                // disabled={
                                                                //   ermState?.consultant_role == 'ERM'
                                                                //     ? true
                                                                //     : weekDayDataEntry[index]
                                                                //         ?.timesheet_data[0]
                                                                //         ?.qb_invoice_id != null
                                                                //     ? true
                                                                //     : projectStartDateDisable &&
                                                                //       projectStartDateDisable[index] &&
                                                                //       projectStartDateDisable[index][0]
                                                                //     ? true
                                                                //     : projectEndDateDisable &&
                                                                //       projectEndDateDisable[index] &&
                                                                //       projectEndDateDisable[index][0]
                                                                //     ? true
                                                                //     : weekDayDataEntry[index]
                                                                //         ?.timesheet_data[0]?.status ==
                                                                //       'SUBMITTED'
                                                                //     ? true
                                                                //     : weekDayDataEntry[index]
                                                                //         ?.timesheet_data[0]?.status ==
                                                                //       'APPROVED'
                                                                //     ? true
                                                                //     : weekDayStatus[index]?.monday_holidayt
                                                                //     ? true
                                                                //     : false
                                                                // }

                                                                onClick={() =>
                                                                  onClickHolidayDisableLeave(
                                                                    0,
                                                                    'leavet',
                                                                    originalIndex
                                                                  )
                                                                }
                                                              >
                                                                <img
                                                                  src={UmbrellaIcon}
                                                                  className='timeEntryIcons pinkBgLight'
                                                                />
                                                              </button>
                                                            </Tooltip>
                                                            {/* <Tooltip text=''>
                                                              <div className=''>
                                                                <Popup
                                                                  trigger={
                                                                    <a
                                                                      onClick={() =>
                                                                        copyToClipboard(
                                                                          parse(xmlString)
                                                                        )
                                                                      }
                                                                    >
                                                                      <i className='las la-info-circle fs-6'></i>
                                                                    </a>
                                                                  }
                                                                  position='right center'
                                                                  on={['hover', 'focus']}
                                                                >
                                                                  <div>
                                                                    <div className='p-0'>
                                                                      <div className='text-gray-900 fs-7 fw-semibold'>
                                                                        {parse(xmlString)}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </Popup>
                                                              </div>
                                                            </Tooltip> */}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ''
                                                    )}
                                                  </td>
                                                </>
                                              )
                                            })}
                                        <td className='comment-icon'>
                                          <React.Fragment>
                                            <div className='d-flex flex-column gap-2 align-items-center'>
                                              <Tooltip
                                                text={
                                                  WeeklyComments &&
                                                  WeeklyComments?.length > 0 &&
                                                  WeeklyComments.find(
                                                    (test: any) =>
                                                      test.weekIndex == index && test.comments
                                                  )?.comments
                                                }
                                              >
                                                <a
                                                  // onClick={() =>
                                                  //   handleResend()
                                                  // }
                                                  className={
                                                    WeeklyComments &&
                                                    WeeklyComments?.length > 0 &&
                                                    WeeklyComments?.find(
                                                      (test: any) =>
                                                        test.weekIndex === index && test.comments
                                                    )?.comments
                                                      ? 'position-relative btn btn-icon btn-light-primary btn-sm w-auto h-auto p-1'
                                                      : 'btn btn-icon btn-bg-light btn-active-color-gray btn-sm  w-auto h-auto p-1'
                                                  }
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/communication/com007.svg'
                                                    className='svg-icon-2'
                                                  />
                                                </a>
                                              </Tooltip>

                                              {WeeklyDocuments?.find(
                                                (test: any) =>
                                                  test.weekIndex === index &&
                                                  test.document?.length > 1
                                              ) ? (
                                                <div className='position-relative'>
                                                  <a
                                                    className='position-relative btn btn-icon btn-light-success btn-sm w-auto h-auto p-1'
                                                    onClick={() => HandleDocPop(index)}
                                                    onBlur={() =>
                                                      setTimeout(() => {
                                                        setIsMenuOpen(false)
                                                      }, 200)
                                                    }
                                                    tabIndex={0}
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/communication/com008.svg'
                                                      className='svg-icon-2'
                                                    />
                                                  </a>
                                                  {isMenuOpen && DocIndex === index ? (
                                                    <div
                                                      className='position-absolute fileAttachments menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-250px show'
                                                      data-kt-menu='true'
                                                    >
                                                      <div className='menu-content  px-2'>
                                                        {WeeklyDocuments?.length > 0 &&
                                                          WeeklyDocuments.find(
                                                            (test: any) =>
                                                              test.weekIndex === index &&
                                                              test.document?.length > 0
                                                          )?.document.map((doc: any) => {
                                                            return (
                                                              <>
                                                                {doc?.original_name?.length > 0 &&
                                                                  (doc?.original_name?.substr(
                                                                    doc?.original_name?.lastIndexOf(
                                                                      '.'
                                                                    ) + 1
                                                                  ) == 'jpeg' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'png' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'pdf' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'xlsx' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'docx' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'PDF' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'jpg') && (
                                                                    <div className='menu-item'>
                                                                      <a
                                                                        className='menu-link d-flex fw-normal fs-7 py-2'
                                                                        // href={doc.blobUrl}
                                                                        onClick={() =>
                                                                          getValidate(
                                                                            doc.blobUrl,
                                                                            'view',
                                                                            doc
                                                                          )
                                                                        }
                                                                        target='_blank'
                                                                      >
                                                                        <span className='text-truncate'>
                                                                          {doc.original_name}
                                                                        </span>
                                                                      </a>
                                                                    </div>
                                                                  )}
                                                              </>
                                                            )
                                                          })}
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    ''
                                                  )}
                                                </div>
                                              ) : WeeklyDocuments?.find(
                                                  (test: any) =>
                                                    test.weekIndex === index &&
                                                    test.document?.length == 1
                                                ) ? (
                                                <div className='position-relative'>
                                                  <a
                                                    className='position-relative btn btn-icon btn-light-success btn-sm w-auto h-auto p-1'
                                                    onClick={() => HandleDocPop(index)}
                                                    onBlur={() =>
                                                      setTimeout(() => {
                                                        setIsMenuOpen(false)
                                                      }, 200)
                                                    }
                                                    tabIndex={0}
                                                  >
                                                    <svg
                                                      xmlns='http://www.w3.org/2000/svg'
                                                      className='w-15px'
                                                      viewBox='0 0 24 24'
                                                      fill='none'
                                                      stroke='currentColor'
                                                      stroke-width='2'
                                                      stroke-linecap='round'
                                                      stroke-linejoin='round'
                                                    >
                                                      <path d='M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0' />
                                                      <circle cx='12' cy='12' r='3' />
                                                    </svg>
                                                  </a>
                                                  {isMenuOpen && DocIndex === index ? (
                                                    <div
                                                      className='position-absolute fileAttachments menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-250px show'
                                                      data-kt-menu='true'
                                                    >
                                                      <div className='menu-content  px-2'>
                                                        {WeeklyDocuments?.length > 0 &&
                                                          WeeklyDocuments.find(
                                                            (test: any) =>
                                                              test.weekIndex === index &&
                                                              test.document?.length > 0
                                                          )?.document.map((doc: any) => {
                                                            return (
                                                              <>
                                                                {doc?.original_name?.length > 0 &&
                                                                  (doc?.original_name?.substr(
                                                                    doc?.original_name?.lastIndexOf(
                                                                      '.'
                                                                    ) + 1
                                                                  ) == 'jpeg' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'png' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'pdf' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'xlsx' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'docx' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'PDF' ||
                                                                    doc?.original_name?.substr(
                                                                      doc?.original_name?.lastIndexOf(
                                                                        '.'
                                                                      ) + 1
                                                                    ) == 'jpg') && (
                                                                    <div className='menu-item'>
                                                                      <a
                                                                        className='menu-link d-flex fw-normal fs-7 py-2'
                                                                        // href={doc.blobUrl}
                                                                        onClick={() =>
                                                                          getValidate(
                                                                            doc.blobUrl,
                                                                            'view',
                                                                            doc
                                                                          )
                                                                        }
                                                                        target='_blank'
                                                                      >
                                                                        <span className='text-truncate'>
                                                                          {doc.original_name}
                                                                        </span>
                                                                      </a>
                                                                    </div>
                                                                  )}
                                                              </>
                                                            )
                                                          })}
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    ''
                                                  )}
                                                </div>
                                              ) : (
                                                ''
                                              )}

                                              {/* single attachment */}
                                            </div>
                                          </React.Fragment>
                                        </td>
                                      </tr>
                                    ) : (
                                      ''
                                    )}
                                  </React.Fragment>
                                )
                              })}
                          </tbody>
                        </table>
                      </div>

                      <div></div>
                    </div>
                  </div>
                </React.Fragment>
              )
            })}
          <div className='card card-custom card-flush mt-4'>
            <div className='card-body p-2'>
              <div className='row g-3'>
                <div className='col-md-6 col-lg-6'>
                  <label className='form-label '>Project Status Update </label>
                  <textarea
                    required
                    className='form-control form-control-sm'
                    // className={
                    //   // ClientManagerNameValidation[index].ccValidation
                    //   //   ? `form-control fs-6  is-invalid`
                    //   // :
                    //   'form-control fs-6'
                    // }
                    // className={` ${
                    //   ClientManagerNameValidation[0].ccValidation
                    //     ? `form-control fs-6  is-invalid`
                    //     : `form-control fs-6  `
                    // }`}
                    // disabled={
                    //   ermState?.consultant_role == 'ERM'
                    //     ? true
                    //     : getDisableStatusofBenchProject(
                    //         list?.is_placement_project,
                    //         null
                    //       )
                    //     ? // list?.is_placement_project === 2
                    //       true
                    //     : !(
                    //         projectStartDateDisable &&
                    //         projectStartDateDisable[index] &&
                    //         projectStartDateDisable[index].includes(false)
                    //       )
                    //     ? true
                    //     : !(
                    //         projectEndDateDisable &&
                    //         projectEndDateDisable[index] &&
                    //         projectEndDateDisable[index].includes(false)
                    //       )
                    //     ? true
                    //     : weekDayDataEntry[index]?.timesheet_data.find(
                    //         (item: any) => item.status == ''
                    //       ) ||
                    //       weekDayDataEntry[index]?.timesheet_data.find(
                    //         (item: any) => item.status == 'REJECTED'
                    //       ) ||
                    //       weekDayDataEntry[index]?.timesheet_data.find(
                    //         (item: any) => item.status == 'SAVED'
                    //       )
                    //     ? false
                    //     : true
                    // }
                    value={
                      monthDayDataEntry[0]?.user_notes == null
                        ? ''
                        : monthDayDataEntry[0]?.user_notes
                        ? monthDayDataEntry[0]?.user_notes
                        : monthDayDataEntry[0]?.ts_user_notes
                    }
                    name='user_notes'
                    placeholder='Please Enter Project Status Update'
                    rows={1}
                    onChange={(e: any) => {
                      DailyEntry(e, 0, 0)
                    }}
                  ></textarea>
                  {ClientManagerNameValidation[0].ccValidation && (
                    <p className='error text-danger mb-0 mt-2'>Project status update is required</p>
                  )}
                </div>
                <div className='col-md-6 col-lg-6 d-none'>
                  <label className='form-label '>Approver Comments</label>
                  <textarea
                    className='form-control form-control-sm'
                    placeholder='Approver Comments'
                    rows={1}
                    disabled
                    // value={
                    //   weekDayDataEntry[index]?.ts_approver_notes == null
                    //     ? ''
                    //     : weekDayDataEntry[index]?.ts_approver_notes
                    // }
                  ></textarea>
                </div>

                {/* {( weekDayDataEntry[index]?.timesheet_data.find(
                                      (item: any, index: number) => item.status === 'SUBMITTED'
                                    )) && ( */}
                <div className='col-md-6 col-lg-6 '>
                  <label className='form-label' style={{visibility: 'hidden'}}>
                    Upload The Document
                  </label>

                  <input
                    type='file'
                    id={'test' + 0}
                    className='d-none'
                    name='file'
                    multiple
                    // disabled={
                    //   ermState?.consultant_role == 'ERM'
                    //     ? true
                    //     : getDisableStatusofBenchProject(
                    //         list?.is_placement_project,
                    //         null
                    //       )
                    //     ? // list?.is_placement_project === 2
                    //       true
                    //     : !(
                    //         projectStartDateDisable &&
                    //         projectStartDateDisable[index] &&
                    //         projectStartDateDisable[index].includes(false)
                    //       )
                    //     ? true
                    //     : !(
                    //         projectEndDateDisable &&
                    //         projectEndDateDisable[index] &&
                    //         projectEndDateDisable[index].includes(false)
                    //       )
                    //     ? true
                    //     : false
                    // }
                    accept='image/png,image/jpg,image/jpeg,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword'
                    onChange={(e: any) => {
                      let y2 = WeeklyDocuments?.filter((test: any) => test.document)
                      FileUpload(e, 0, y2?.length == 0 ? 'yes' : '')
                      e.target.value = ''
                    }}
                  />

                  <div>
                    <div className='monthViewCal'>
                      <label
                        role='button'
                        htmlFor={'test' + 0}
                        // className={clsx(
                        //   // ClientManagerNameValidation[index].ucValidation
                        //   //   ? 'border-danger bg-danger'
                        //   // :
                        //   'border-primary bg-primary',
                        //   'width100   p-1 text-dark bg-opacity-10 border  border-dashed uploadDocument  d-flex align-items-center h85 justify-content-center'
                        // )}
                        className={clsx(
                          ClientManagerNameValidation[0].ucValidation
                            ? 'border-danger bg-danger'
                            : 'border-primary bg-primary',
                          'width100   p-2 text-dark bg-opacity-10 border  border-dashed uploadDocument  d-flex align-items-center h85 justify-content-center'
                        )}
                      >
                        {' '}
                        <div className='d-flex align-items-center justify-content-center gap-3'>
                          <div>
                            <i className='bi bi-upload fs10'></i>
                            {/* <img src={Arrow078} className='downloadIcon' /> */}
                          </div>
                          <div>
                            <div className='text-gray-700  fw-semibold fs-7'>
                              Upload Client approved timesheets{' '}
                              {/* {list.is_placement_project == '1' && '*'} */}
                            </div>
                            <div className='text-gray-500  fw-normal fs-8'>
                              Max 10 MB , Max 5 Files,
                              {/* <br /> */}
                              png, jpg, jpeg, docx, xlsx, pdf
                            </div>
                            {/* <div className="fs-9 text-primary">(MAX 10 MB)</div> */}
                          </div>
                        </div>
                      </label>
                      {/* {ClientManagerNameValidation[index].ucValidation && (
                                            <p className='error text-danger mb-0 mt-2'>
                                              Documents are required
                                            </p>
                                          )} */}
                      {ClientManagerNameValidation[0].ucValidation && (
                        <p className='error text-danger mb-0 mt-2'>Documents are required</p>
                      )}
                    </div>
                  </div>
                </div>
                {/* )} */}
              </div>
            </div>

            {docResultDataRes?.length > 0 && (
              <>
                <div className='border-top '></div>
                <div className='py-4 px-5'>
                  <div className='row gap-3 px-3'>
                    {docResultDataRes.map((each: any, docIndex: any) => {
                      if (each.project_id === Project_id) {
                        return (
                          <div
                            key={docIndex}
                            className='col-auto p-2 text-dark bg-opacity-10 border border-primary border-dashed uploadDocument  text-gray-700 fw-normal fs-7'
                          >
                            <div className='d-flex gap-2 align-items-center'>
                              <div>{each?.original_name}</div>
                              {each?.original_name?.length > 0 &&
                                (each?.original_name?.substr(
                                  each?.original_name?.lastIndexOf('.') + 1
                                ) == 'jpeg' ||
                                  each?.original_name?.substr(
                                    each?.original_name?.lastIndexOf('.') + 1
                                  ) == 'png' ||
                                  each?.original_name?.substr(
                                    each?.original_name?.lastIndexOf('.') + 1
                                  ) == 'pdf' ||
                                  each?.original_name?.substr(
                                    each?.original_name?.lastIndexOf('.') + 1
                                  ) == 'xlsx' ||
                                  each?.original_name?.substr(
                                    each?.original_name?.lastIndexOf('.') + 1
                                  ) == 'docx' ||
                                  each?.original_name?.substr(
                                    each?.original_name?.lastIndexOf('.') + 1
                                  ) == 'PDF' ||
                                  each?.original_name?.substr(
                                    each?.original_name?.lastIndexOf('.') + 1
                                  ) == 'jpg') && (
                                  <Tooltip text='View Uploaded File'>
                                    <div role='button'>
                                      <a
                                        // href={each.blobUrl}
                                        // onClick={() => handleViewToken(each.blobUrl)}
                                        onClick={() => handleViewToken(each.blobUrl, each)}
                                        target='_blank'
                                        className='m-1 mx-2'
                                      >
                                        <i className='bi bi-eye fw-bold fs-4 text-primary'></i>
                                      </a>
                                    </div>
                                  </Tooltip>
                                )}
                              <Tooltip text='Download File'>
                                <div>
                                  <a
                                    className='m-1 mx-2'
                                    role='button'
                                    onClick={() => {
                                      // downloadFile(each.blobDownloadUrl, docIndex)
                                      handleDownload(
                                        each.blobDownloadUrl,
                                        docIndex,
                                        each.original_name
                                      )
                                    }}
                                  >
                                    <i className='bi bi-download  fw-bold fs-4 text-primary'></i>
                                  </a>
                                </div>
                              </Tooltip>
                              {monthDayDataEntry[0]?.timesheet_data
                                .filter(
                                  (item: any) =>
                                    moment(item.timesheet_date).format('M') == Monthname
                                )
                                .find((item: any, index: number) => item.status === 'APPROVED') ||
                              monthDayDataEntry[0]?.timesheet_data
                                .filter(
                                  (item: any) =>
                                    moment(item.timesheet_date).format('M') == Monthname
                                )
                                .find((item: any, index: number) => item.status === 'SUBMITTED') ? (
                                ''
                              ) : (
                                <Tooltip text='Delete File'>
                                  <div>
                                    <i
                                      className='bi bi-trash3 m-1 mx-2 text-danger fw-bold fs-4'
                                      role='button'
                                      onClick={() => removeDoc1(each.id, docIndex, each.project_id)}
                                    ></i>
                                  </div>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        )
                      }
                    })}
                  </div>
                </div>
              </>
            )}
            {submitshow ? (
              <SubmitButtonPop
                FormSubmit={FormSingleProjectSubmit}
                submit_open={submit_open}
                submitshow={submitshow}
                setSubmitOpen={setSubmitOpen}
                modalPop={modalPop}
                handleSubmitted={handleSubmitted}
                setSubmitShow={setSubmitShow}
                index={indexState}
                sumofRegularHoursProject={sumofRegularHoursProject}
                sumofOtHoursProject={sumofOtHoursProject}
                sumofLeaveHoursProject={sumofLeaveHoursProject}
              />
            ) : (
              ''
            )}
            {WorkLocationshow ? (
              <WorkLocationPop
                WorkLocationshow={WorkLocationshow}
                setWorkLocationShow={setWorkLocationShow}
                WorkLocationContinuePop={WorkLocationContinuePop}
                WorkLocationOkPop={WorkLocationOkPop}
              />
            ) : (
              ''
            )}

            {MonthCommentshow ? (
              <MonthlyCommentsPop
                CommentOverRidePop={CommentOverRidePop}
                CommentRemainingOkPop={CommentRemainingOkPop}
              />
            ) : (
              ''
            )}
            {MonthlyDocsPopProceed ? (
              <MonthlyDocsOptionalPopUp
                DocumentProceedPop={DocumentProceedPop}
                DocumentStopPop={DocumentStopPop}
              />
            ) : (
              ''
            )}

            {FilePop ? (
              <MonthlyFileUploadPop
                FileUploadPop={FileUploadPop}
                Fileindex={Fileindex}
                FileEvent={FileEvent}
                // FileUploadPopOpen={FileUploadPopOpen}
              />
            ) : (
              ''
            )}
            <div className='d-flex gap-3 justify-content-end px-5 mb-10 py-3'>
              {monthDayDataEntry &&
              monthDayDataEntry?.length > 0 &&
              monthDayDataEntry[0].timesheet_data
                .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                .find((item: any, index: number) => item.status != 'APPROVED') ? (
                monthDayDataEntry &&
                monthDayDataEntry?.length > 0 &&
                monthDayDataEntry[0].timesheet_data
                  .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                  .find((item: any, index: number) => item.status === 'SAVED') ? (
                  monthDayDataEntry &&
                  monthDayDataEntry?.length > 0 &&
                  monthDayDataEntry[0].timesheet_data
                    .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                    .find((item: any, index: number) => item.status === 'SUBMITTED') ? (
                    monthDayDataEntry &&
                    monthDayDataEntry?.length > 0 &&
                    monthDayDataEntry[0].timesheet_data.find(
                      (item: any, index: number) => item.status === 'REJECTED'
                    ) ? (
                      <>
                        <div>
                          <button
                            type='button'
                            className='btn btn-light-primary  btn-sm'
                            // disabled={
                            //   getDisableStatusofBenchProject(
                            //     list?.is_placement_project,
                            //     null
                            //   )
                            //     ? // list?.is_placement_project === 2
                            //       true
                            //     : false
                            // }
                            onClick={() => {
                              FormSave(0)
                            }}
                          >
                            Save
                          </button>
                        </div>
                        <div>
                          <button
                            type='button'
                            className='btn btn-primary btn-sm'
                            // disabled={
                            //   getDisableStatusofBenchProject(
                            //     list?.is_placement_project,
                            //     null
                            //   )
                            //     ? // list?.is_placement_project === 2
                            //       true
                            //     : false
                            // }
                            onClick={() => {
                              FormSingleProjectUnSubmit(0)
                            }}
                          >
                            Unsubmit
                          </button>
                        </div>
                        <div>
                          <button
                            type='button'
                            className='btn btn-primary btn-sm'
                            onClick={() => {
                              FormSingleProjectSubmit(0, '', list, '')
                            }}
                            // disabled={
                            //   getDisableStatusofBenchProject(
                            //     list?.is_placement_project,
                            //     null
                            //   )
                            //     ? // list?.is_placement_project === 2
                            //       true
                            //     : submitButtonEnableDisableValidation[index]
                            // }
                            disabled={MonthlysubmitButtonEnableDisableValidation[0]}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          <button
                            type='button'
                            className='btn btn-light-primary  btn-sm'
                            // disabled={
                            //   getDisableStatusofBenchProject(
                            //     list?.is_placement_project,
                            //     null
                            //   )
                            //     ? // list?.is_placement_project === 2
                            //       true
                            //     : false
                            // }
                            onClick={() => {
                              FormSave(0)
                            }}
                          >
                            Save
                          </button>
                        </div>
                        <div>
                          <button
                            type='button'
                            className='btn btn-primary btn-sm'
                            onClick={() => {
                              FormSingleProjectUnSubmit(0)
                            }}
                          >
                            Unsubmit
                          </button>
                        </div>
                        <div>
                          <button
                            type='button'
                            className='btn btn-primary btn-sm'
                            // disabled={
                            //   getDisableStatusofBenchProject(
                            //     list?.is_placement_project,
                            //     null
                            //   )
                            //     ? // list?.is_placement_project === 2
                            //       true
                            //     : submitButtonEnableDisableValidation[index]
                            // }
                            disabled={MonthlysubmitButtonEnableDisableValidation[0]}
                            onClick={() => {
                              FormSingleProjectSubmit(0, '', list, '')
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )
                  ) : monthDayDataEntry[0].timesheet_data
                      .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                      .find((item: any, index: number) => item.status === 'SAVED') ? (
                    <>
                      <div>
                        <button
                          type='button'
                          className='btn btn-light-primary  btn-sm'
                          // disabled={
                          //   getDisableStatusofBenchProject(
                          //     list?.is_placement_project,
                          //     null
                          //   )
                          //     ? // list?.is_placement_project === 2
                          //       true
                          //     : false
                          // }
                          onClick={() => {
                            FormSave(0)
                          }}
                        >
                          Save
                        </button>
                      </div>
                      <div>
                        <button
                          type='button'
                          className='btn btn-primary btn-sm'
                          // disabled={
                          //   getDisableStatusofBenchProject(
                          //     list?.is_placement_project,
                          //     null
                          //   )
                          //     ? // list?.is_placement_project === 2
                          //       true
                          //     : submitButtonEnableDisableValidation[index]
                          // }
                          disabled={MonthlysubmitButtonEnableDisableValidation[0]}
                          onClick={() => {
                            FormSingleProjectSubmit(0, '', list, '')
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </>
                  ) : (
                    'submit'
                  )
                ) : monthDayDataEntry[0].timesheet_data
                    .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                    .find((item: any, index: number) => item.status === 'SUBMITTED') ? (
                  monthDayDataEntry[0].timesheet_data
                    .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                    .find((item: any, index: number) => item.status === 'REJECTED') ? (
                    <>
                      <div>
                        <button
                          type='button'
                          className='btn btn-light-primary  btn-sm'
                          // disabled={
                          //   getDisableStatusofBenchProject(
                          //     list?.is_placement_project,
                          //     null
                          //   )
                          //     ? // list?.is_placement_project === 2
                          //       true
                          //     : false
                          // }
                          onClick={() => {
                            FormSave(0)
                          }}
                        >
                          Save
                        </button>
                      </div>
                      <div>
                        <button
                          type='button'
                          className='btn btn-primary btn-sm'
                          onClick={() => {
                            FormSingleProjectUnSubmit(0)
                          }}
                        >
                          Unsubmit
                        </button>
                      </div>
                      <div>
                        <button
                          type='button'
                          className='btn btn-primary btn-sm'
                          // disabled={
                          //   getDisableStatusofBenchProject(
                          //     list?.is_placement_project,
                          //     null
                          //   )
                          //     ? // list?.is_placement_project === 2
                          //       true
                          //     : submitButtonEnableDisableValidation[index]
                          // }
                          disabled={MonthlysubmitButtonEnableDisableValidation[0]}
                          onClick={() => {
                            FormSingleProjectSubmit(0, '', list, '')
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </>
                  ) : monthDayDataEntry[0].timesheet_data
                      .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                      .find((item: any, index: number) => item.status === 'SUBMITTED') ? (
                    monthDayDataEntry[0].timesheet_data
                      .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                      .find(
                        (item: any, index: number) => item.status == '' || item.status == null
                      ) ? (
                      <>
                        <div>
                          <button
                            type='button'
                            className='btn btn-light-primary  btn-sm'
                            // disabled={
                            //   getDisableStatusofBenchProject(
                            //     list?.is_placement_project,
                            //     null
                            //   )
                            //     ? // list?.is_placement_project === 2
                            //       true
                            //     : false
                            // }
                            onClick={() => {
                              FormSave(0)
                            }}
                          >
                            Save
                          </button>
                        </div>
                        <div>
                          <button
                            type='button'
                            className='btn btn-primary btn-sm'
                            onClick={() => {
                              FormSingleProjectUnSubmit(0)
                            }}
                          >
                            Unsubmit
                          </button>
                        </div>
                        <div>
                          <button
                            type='button'
                            className='btn btn-primary btn-sm'
                            onClick={() => {
                              FormSingleProjectSubmit(0, '', list, '')
                            }}
                            disabled={MonthlysubmitButtonEnableDisableValidation[0]}
                            // disabled={
                            //   getDisableStatusofBenchProject(
                            //     list?.is_placement_project,
                            //     null
                            //   )
                            //     ? // list?.is_placement_project === 2
                            //       true
                            //     : submitButtonEnableDisableValidation[0]
                            // }
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    ) : (
                      <div>
                        <button
                          type='button'
                          className='btn btn-primary btn-sm'
                          onClick={() => {
                            FormSingleProjectUnSubmit(0)
                          }}
                        >
                          Unsubmit
                        </button>
                      </div>
                    )
                  ) : (
                    <div>
                      <button
                        type='button'
                        className='btn btn-primary btn-sm'
                        onClick={() => {
                          FormSingleProjectUnSubmit(0)
                        }}
                      >
                        Unsubmit
                      </button>
                    </div>
                  )
                ) : monthDayDataEntry[0].timesheet_data
                    .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                    .find(
                      (item: any, index: number) => item.status == '' || item.status == null
                    ) ? (
                  <>
                    <div>
                      <button
                        type='button'
                        className='btn btn-light-primary  btn-sm'
                        // disabled={
                        //   getDisableStatusofBenchProject(
                        //     list?.is_placement_project,
                        //     null
                        //   )
                        //     ? // list?.is_placement_project === 2
                        //       true
                        //     : false
                        // }
                        onClick={() => {
                          FormSave(0)
                        }}
                      >
                        Save
                      </button>
                    </div>
                    <div>
                      <button
                        type='button'
                        className='btn btn-primary btn-sm'
                        onClick={() => {
                          FormSingleProjectSubmit(0, '', list, '')
                        }}
                        disabled={MonthlysubmitButtonEnableDisableValidation[0]}
                        // disabled={
                        //   getDisableStatusofBenchProject(
                        //     list?.is_placement_project,
                        //     null
                        //   )
                        //     ? // list?.is_placement_project === 2
                        //       true
                        //     : submitButtonEnableDisableValidation[0]
                        // }
                      >
                        Submit
                      </button>
                    </div>
                  </>
                ) : monthDayDataEntry[0].timesheet_data
                    .filter((item: any) => moment(item.timesheet_date).format('M') == Monthname)
                    .find((item: any, index: number) => item.status === 'REJECTED') ? (
                  <>
                    <div>
                      <button
                        type='button'
                        className='btn btn-light-primary  btn-sm'
                        // disabled={
                        //   getDisableStatusofBenchProject(
                        //     list?.is_placement_project,
                        //     null
                        //   )
                        //     ? // list?.is_placement_project === 2
                        //       true
                        //     : false
                        // }
                        onClick={() => {
                          FormSave(0)
                        }}
                      >
                        Save
                      </button>
                    </div>
                    <div>
                      <button
                        type='button'
                        className='btn btn-primary btn-sm'
                        onClick={() => {
                          FormSingleProjectSubmit(0, '', list, '')
                        }}
                        disabled={MonthlysubmitButtonEnableDisableValidation[0]}
                        // disabled={
                        //   getDisableStatusofBenchProject(
                        //     list?.is_placement_project,
                        //     null
                        //   )
                        //     ? // list?.is_placement_project === 2
                        //       true
                        //     : submitButtonEnableDisableValidation[index]
                        // }
                      >
                        Submit
                      </button>
                    </div>
                  </>
                ) : (
                  ''
                )
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      <ToastContainer />
    </>
  )
}
export default MonthlyTimesheet
